export const translations = {
  "en": {
    "appName": "Finn ERP",
    "appSubtitle": "Enterprise Resource Planning",
    "menuDashboard": "Dashboard",
    "menuEmployees": "Employees",
    "menuSites": "Locations / Sites",
    "menuAttendance": "Attendance",
    "menuPayroll": "Payroll",
    "menuReports": "Reports",
    "menuKiosk": "Kiosk Mode",
    "kioskWelcome": "Welcome to our Kiosk",
    "kioskSub": "Please select a service to begin",
    "kioskPos": "Self-Service POS",
    "kioskService": "Repair Tracking",
    "kioskCheckIn": "Staff Check-in",
    "kioskClock": "Current Time",
    "kioskBack": "Back to Home",
    "settings": "Settings",
    "search": "Search...",
    "allEmployees": "All Employees",
    "manageStaff": "Manage employees and shifts.",
    "addEmployee": "Add Employee",
    "name": "Name",
    "role": "Role",
    "dept": "Department",
    "salary": "Base Salary",
    "bonus": "Bonus",
    "overtime": "Overtime",
    "deductions": "Deductions",
    "total": "Total",
    "netPay": "Net Pay",
    "actions": "Actions",
    "login": "Login",
    "signup": "Sign Up",
    "email": "Email",
    "password": "Password",
    "welcome": "Welcome Back",
    "signInToAccess": "Sign in to access your dashboard",
    "createAccount": "Create Account",
    "haveAccount": "Already have an account?",
    "noAccount": "Don't have an account?",
    "logout": "Logout",
    "location": "Location",
    "shift": "Shift",
    "totalComp": "Total Comp",
    "dailyAttendance": "Daily Attendance Log",
    "trackAttendance": "Track employee check-ins and shifts.",
    "checkIn": "Check In",
    "checkOut": "Check Out",
    "status": "Status",
    "import": "Import",
    "export": "Export",
    "payrollMgmt": "Payroll Management",
    "costAnalysis": "Real-time cost analysis.",
    "aiInsights": "AI Insights",
    "siteStats": "Site Statistics",
    "assignedGuards": "Assigned Employees",
    "deleteLocation": "Delete Location",
    "terminateGuard": "Terminate / Delete Employee",
    "aiAssistant": "AI Assistant",
    "genReview": "Generate Performance Review",
    "generating": "Generating...",
    "downloadReport": "Download Report",
    "editLocation": "Edit Location",
    "otp": "OTP Code",
    "otpSent": "OTP Sent to Admin",
    "otpSentDetail": "An OTP code has been sent to shoaibwwe01@outlook.com. Please ask the admin for the code.",
    "registrationId": "Registration ID",
    "invalidOtp": "Invalid OTP code",
    "registeredOnly": "Registered feature only",
    "guestNotice": "You are in Guest Mode. Register to access all online features.",
    "menuAccounts": "Accounts",
    "menuSalesPurchases": "Sales",
    "menuWarehouses": "Warehouses",
    "menuCafe": "Cafe",
    "menuInvoices": "History",
    "weeklySales": "Weekly Sales Report",
    "weeklyBuy": "Weekly Buy/Inventory Report",
    "walkIn": "Walk-in",
    "takeaway": "Takeaway",
    "walkInCustomer": "Walk-in Customer",
    "takeawayCustomer": "Takeaway Customer",
    "customerCopy": "Customer Copy",
    "shopCopy": "Shop Copy",
    "printSettings": "Print Settings",
    "thermal": "Thermal (80mm)",
    "a4": "A4 (Standard)",
    "dualPrint": "Dual Print (Client + Shop)",
    "lastUpdated": "Last Updated",
    "stockValueBuy": "Stock Value (Buy)",
    "stockValueSell": "Stock Value (Sell)",
    "itemsSummary": "Items Summary",
    "invoiceId": "Invoice ID",
    "type": "Type",
    "soldBy": "Sold By",
    "customerId": "Customer ID",
    "taxed": "Taxed",
    "advanceSalary": "Advance Salary",
    "image": "Image",
    "salesEmployee": "Sales Employee",
    "adminDefault": "Admin (Default)",
    "historyLog": "History Log",
    "historySubtitle": "Comprehensive log of sales and warehouse activities.",
    "allTypes": "All Types",
    "sales": "Sales",
    "stockUpdates": "Stock Updates",
    "valueStatus": "Value / Status",
    "noHistory": "No history records found.",
    "sold": "Sold",
    "to": "to",
    "units": "Units",
    "stockCheck": "Stock Check",
    "items": "items",
    "posTerminal": "POS Terminal",
    "searchProducts": "Search products...",
    "todaysSales": "Today's Sales",
    "salesOn": "Sales on",
    "time": "Time",
    "amount": "Amount",
    "receipt": "Receipt",
    "currentBill": "Current Bill",
    "cartEmpty": "Cart is empty",
    "selectItems": "Select items from grid to add",
    "subtotal": "Subtotal",
    "checkout": "Checkout",
    "customerNameOptional": "Customer Name (Optional)",
    "hold": "Hold Cart",
    "resumeWarning": "Resuming will overwrite current cart. Continue?",
    "quickStockIn": "Quick Stock In",
    "currentQuantity": "Current Quantity",
    "enterAddedQty": "Enter added quantity to add",
    "payWithUPI": "Pay with UPI",
    "assistant": "Assistant",
    "reviewOrder": "Review Order",
    "products": "Products",
    "scanner": "Scanner",
    "cart": "Cart",
    "digitalPayment": "Digital Payment",
    "linkExpired": "Link Expired",
    "linkExpiredDetail": "This payment link was valid for 10 minutes only. Please ask the merchant for a new QR code.",
    "payNow": "Pay Now",
    "secureUpi": "Secure UPI Payment",
    "securePayment": "Secure Digital Payment",
    "totalLabel": "Total",
    "goBackToApp": "Go back to App",
    "inventorySubtitle": "Inventory levels and stock movements",
    "searchInventory": "Search inventory...",
    "itemName": "Item Name",
    "buyPrice": "Buy Price",
    "sellPrice": "Sell Price",
    "barcode": "Barcode",
    "scanBarcode": "Scan Barcode",
    "paymentMethodNotConfigured": "Payment method not configured in Settings",
    "digitalPayment_QR": "Digital Payment (QR)",
    "upiId": "UPI ID",
    "instapayId": "InstaPay ID",
    "payWithInstapay": "Pay with InstaPay",
    "confirmCheckout": "Confirm Checkout",
    "totalWithDiscount": "Total after discount",
    "quantity": "Quantity",
    "refinement": "Refinement",
    "noInventory": "No inventory items found",
    "hideCosts": "Hide Costs",
    "showCosts": "Show Costs",
    "securityCheck": "Security Check",
    "addItem": "Add Item",
    "edit": "Edit",
    "itemNotFound": "Product not found in inventory. Please check or add it.",
    "generate": "Generate",
    "print": "Print",
    "printAll": "Print All Barcodes",
    "shopSettings": "Shop Settings",
    "shopName": "Shop Name",
    "shopAddress": "Shop Address",
    "shopPhone": "Shop Phone",
    "updateSettings": "Update Settings",
    "securityPin": "Security PIN",
    "language": "Language",
    "close": "Close",
    "retailInvoice": "Retail Invoice",
    "invoice": "INVOICE",
    "date": "Date",
    "billNo": "Bill No",
    "paymentMode": "Payment Mode",
    "cash": "Cash",
    "item": "Item",
    "qty": "Qty",
    "amt": "Amt",
    "price": "Price",
    "taxVAT": "Tax/VAT",
    "taxRate": "Tax rate",
    "makeChecksPayable": "Make all checks payable to",
    "thankYou": "Thank you for your business!",
    "billTo": "BILL TO",
    "description": "DESCRIPTION",
    "unitPrice": "Unit Price",
    "lineTotal": "Line Total",
    "comments": "COMMENTS",
    "termsConditions": "Terms & Conditions",
    "paymentTerms": "1. Total payment due in 30 days",
    "includeInvoiceNumber": "2. Please include the invoice number on your check",
    "phone": "Phone",
    "customer": "Customer",
    "contactQuestions": "If you have any questions about this invoice, please contact",
    "details": "Employee Info",
    "manageDetails": "Manage Selection",
    "siteName": "Site Name",
    "city": "City / Region",
    "manager": "Manager",
    "operationalStatus": "Operational Status",
    "photoUrl": "Employee Photo",
    "uploadPhoto": "Upload Photo",
    "unassigned": "Unassigned",
    "securityTeam": "Team",
    "guards": "Employees",
    "addLocation": "Add New Location",
    "createLocation": "Create Location",
    "cancel": "Cancel",
    "filterAll": "All Locations",
    "morningShift": "Morning (9AM - 5PM)",
    "nightShift": "Evening (5PM - 1AM)",
    "operational": "Operational",
    "renovating": "Renovating",
    "active": "Active",
    "closed": "Closed",
    "onTime": "On Time",
    "late": "Late",
    "absent": "Absent",
    "design": "Design",
    "engineering": "Engineering",
    "hr": "Human Resources",
    "marketing": "Marketing",
    "operations": "Operations",
    "security": "Security",
    "it": "IT",
    "headquarters": "Headquarters",
    "kitchen": "Kitchen",
    "service": "Service",
    "bar": "Bar",
    "retail": "Retail",
    "warehouse": "Warehouse",
    "cafe": "Cafe",
    "inventory": "Inventory",
    "customers": "Customers",
    "addCustomer": "Add Customer",
    "newTicket": "New Ticket",
    "serviceModule": "Service Module",
    "devicePhotos": "Device Photos",
    "accounts": "Accounts",
    "management": "Management",
    "cleaning": "Cleaning",
    "maintenance": "Maintenance",
    "morning12": "Morning (12 Hours)",
    "night12": "Night (12 Hours)",
    "importSuccess": "Successfully imported {0} records.",
    "importError": "Error importing: ",
    "payrollUpdateSuccess": "Successfully updated payroll for {0} employees.",
    "payrollUpdateError": "Error updating payroll: ",
    "myProfile": "My Profile",
    "emailLabel": "Email:",
    "userIdLabel": "User ID:",
    "accountTypeLabel": "Account Type:",
    "admin": "Admin",
    "shopSettingsSaved": "Shop Settings Saved to Cloud",
    "shopSettingsError": "Error saving settings",
    "localization": "Localization",
    "currency": "Currency",
    "departmentSettings": "Department Settings",
    "departments": "Departments",
    "manageDepartments": "Add or remove departments",
    "addDepartment": "Add Department",
    "backupRestore": "Backup & Restore",
    "exportBackup": "Export Backup",
    "importBackup": "Import Backup",
    "backupDescription": "Export your data as JSON or restore from a previous backup.",
    "dangerZone": "Danger Zone",
    "irreversibleAction": "Irreversible action. Deletes all data.",
    "factoryReset": "Factory Reset System",
    "compensation": "Compensation",
    "advance": "Advance",
    "delete": "Delete",
    "terminateService": "Terminate Service",
    "addAttendance": "Add Attendance",
    "editAttendance": "Edit Attendance",
    "deleteAttendance": "Delete Attendance",
    "selectEmployee": "Select Employee",
    "selectDate": "Select Date",
    "selectStatus": "Select Status",
    "save": "Save",
    "replacementFor": "Replacement For",
    "coveringFor": "Covering For",
    "lateDeductions": "Late Deductions",
    "absentDeductions": "Absent Deductions",
    "manualDeduction": "Manual Deduction",
    "cost": "Cost",
    "none": "None",
    "dashboardTotal": "Total",
    "activeGuards": "Active Employees",
    "operationalSites": "Operational Sites",
    "checkedInToday": "Checked In Today",
    "issuesToday": "Issues Today",
    "quickActions": "Quick Actions",
    "addStaff": "Add Staff",
    "addSite": "Add Site",
    "systemStatus": "System Status",
    "systemOperational": "All systems operational. Database synced.",
    "online": "Online",
    "attendanceReport": "Attendance Report",
    "payrollReport": "Payroll Report",
    "staffReport": "Staff Report",
    "taxReport": "Tax Report",
    "today": "Today",
    "lateAbsent": "Late/Absent",
    "lateHours": "Late Hours",
    "attendanceExists": "Attendance already exists for this employee on this date.",
    "theme": "Theme",
    "light": "Light",
    "dark": "Dark",
    "payrollSlip": "PAYROLL SLIP",
    "payrollFor": "Payroll for",
    "employeeName": "Employee Name",
    "employeeId": "Employee ID",
    "payPeriod": "Pay Period",
    "basicSalary": "Basic Salary",
    "grossPay": "Gross Pay",
    "totalDeductions": "Total Deductions",
    "otherDeductions": "Other Deductions",
    "employeeSignature": "Employee Signature",
    "authorizedSignature": "Authorized Signature",
    "computerGenerated": "This is a computer-generated payroll slip. No signature required.",
    "generatedOn": "Generated on",
    "at": "at",
    "companyName": "Company Name",
    "companyAddress": "Company Address",
    "selectLocation": "Select Location",
    "noLocations": "No locations available - Please create a location first",
    "authError": "Auth Error: ",
    "googleSignInError": "Google Sign In Error: ",
    "factoryResetWarning": "CRITICAL WARNING: This will DELETE ALL DATA (Employees, Sales, Inventory, etc.) PERMANENTLY. Are you sure?",
    "pinPrompt": "Enter Security PIN to continue:",
    "incorrectPin": "Incorrect PIN. Please try again.",
    "factoryResetPinPrompt": "Enter Security PIN to confirm Factory Reset:",
    "factoryResetIncorrectPin": "Incorrect PIN. Reset Aborted.",
    "switchModePrompt": "Enter Admin PIN to switch mode:",
    "changeUserPrompt": "Enter PIN to Change Sales User:",
    "resetComplete": "Factory Reset Complete. All data has been wiped.",
    "resetFailed": "Factory Reset Failed: ",
    "backupExported": "Backup exported successfully!",
    "exportFailed": "Export failed: ",
    "backupImported": "Backup imported successfully! Reloading...",
    "importFailed": "Import failed: ",
    "overwriteWarning": "WARNING: This will OVERWRITE all existing data. Continue?",
    "guestLogin": "Guest Login",
    "forgotPassword": "Forgot Password?",
    "resetPassword": "Reset Password",
    "sendResetLink": "Send Reset Link",
    "backToLogin": "Back to Login",
    "passwordResetSent": "Password reset email sent!",
    "enterEmail": "Enter your email to reset password",
    "orContinue": "Or continue with",
    "signInGoogle": "Sign in with Google",
    "linkSuccess": "Google Account Linked Successfully!",
    "linkError": "Link Error: ",
    "accountLinked": "This Google Account is already active. Please Log Out and use \"Sign in with Google\" directly.",
    "employeeSaved": "Employee Saved Successfully!",
    "saveError": "Error saving: ",
    "deleteConfirm": "Are you sure?",
    "updateError": "Error updating item: ",
    "addPurchaseError": "Error adding purchase: ",
    "genInvoiceError": "Error generating invoice: ",
    "addItemError": "Error adding item: ",
    "deleteLocationWarning": "Cannot delete. Employees assigned.",
    "deleteLocationConfirm": "Delete this location?",
    "errorNoUser": "Error: No user logged in.",
    "totalIncome": "Total Income",
    "visa": "Visa",
    "onlinePayment": "Online",
    "forgotPin": "Forgot PIN?",
    "securityQuestion": "Security Question",
    "securityAnswer": "Security Answer",
    "enterSecurityAnswer": "Enter Security Answer",
    "pinResetSuccess": "PIN Reset Successfully! Your new PIN is 1234.",
    "incorrectAnswer": "Incorrect Answer.",
    "setSecurityQuestion": "Set Security Question",
    "changePin": "Change Security PIN",
    "newPin": "New PIN",
    "manageLocations": "Manage and monitor all your physical sites and locations.",
    "siteEmployees": "Employees",
    "saveSettings": "Save Settings",
    "currentPin": "Current PIN",
    "enterNewPin": "Enter New PIN",
    "pinChanged": "PIN Updated Successfully!",
    "pinSetMessage": "PIN is set. Use \"Forgot PIN\" to reset.",
    "confirmChangePin": "Set new PIN?",
    "secQ_pet": "What is your first pet's name?",
    "secQ_mother": "What is your mother's maiden name?",
    "secQ_city": "In what city were you born?",
    "secQ_school": "What is the name of your first school?",
    "daily": "Daily",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "profitLossReport": "Profit & Loss Report",
    "monthlyPl": "Monthly Profit & Loss",
    "plSubtitle": "Revenue vs COGS vs Expenses analysis",
    "revenue": "REVENUE",
    "totalSales": "Total Sales",
    "discount": "Discount",
    "cogs": "COGS",
    "cogsFull": "Cost of Goods Sold",
    "grossProfit": "GROSS PROFIT",
    "expenses": "EXPENSES",
    "purchasesOther": "Purchases/Other",
    "netProfit": "NET PROFIT",
    "netLoss": "NET LOSS",
    "incomeStatement": "INCOME STATEMENT",
    "salesCash": "Sales - Cash",
    "salesVisa": "Sales - Visa",
    "salesOnline": "Sales - Online",
    "totalRevenue": "Total Revenue",
    "costOfGoodsSold": "Cost of Goods Sold",
    "grossMargin": "Gross Margin",
    "operatingExpenses": "OPERATING EXPENSES",
    "totalExpenses": "Total Expenses",
    "netMargin": "Net Margin",
    "deptExpenses": "Department Expenses",
    "invPurchases": "Inventory Purchases",
    "selectEmployeeAlert": "Please select a sales employee!",
    "accountHandling": "Account Handling",
    "connectGoogle": "Connect Google Account",
    "linkGoogleDesc": "Link your Google account to login with it instead of password.",
    "soldItemsDetail": "SOLD ITEMS DETAIL",
    "boughtItemsDetail": "BOUGHT ITEMS DETAIL (Purchases & Expenses)",
    "unknown": "Unknown",
    "totals": "TOTALS",
    "unitCost": "Unit Cost",
    "period": "Period",
    "na": "N/A",
    "totalCost": "Total Cost",
    "profit": "Profit",
    "liveBoard": "Live Board",
    "manageUnits": "Rooms & Tables",
    "menuRecipes": "Menu & Recipes",
    "activeSessions": "Active Sessions",
    "unitsMonitoring": "Live monitoring for {0} units",
    "inSession": "In-Session",
    "available": "Available",
    "startSession": "Start Session",
    "addOrder": "Add Order",
    "stop": "Stop",
    "recipeBuilder": "Recipe Builder",
    "manageUnitsTitle": "Manage Units",
    "roomName": "Room Name",
    "unitType": "Unit Type",
    "hourlyRate": "Hourly Rate",
    "saveUnit": "Save Unit",
    "cafeTable": "Cafe Table",
    "playStationRoom": "PlayStation Room",
    "billiardsTable": "Billiards Table",
    "category": "Category",
    "offerPrice": "Price",
    "composition": "Composition",
    "linkStock": "+ Link warehouse stock",
    "hotDrinks": "Hot Drinks",
    "coldDrinks": "Cold Drinks",
    "snacks": "Snacks",
    "meals": "Meals",
    "updateItem": "Update Item",
    "addToMenu": "Add to Menu",
    "appendSession": "Append items to session",
    "orderHistory": "Order History",
    "newSelection": "New Selection",
    "trayEmpty": "Tray is Empty",
    "trayTotal": "Tray Total",
    "confirmOrder": "Confirm Order",
    "menuItemsMissingTitle": "Menu items missing",
    "all": "All",
    "customerPhone": "Customer Phone *",
    "customerName": "Customer Name",
    "sessionType": "Session Type",
    "openSession": "Open (No Limit)",
    "fixedDuration": "Fixed Duration",
    "startSessionTitle": "Start Session",
    "managePayroll": "Manage Payroll",
    "advanceTaken": "Advance Taken",
    "manualDeductions": "Manual Deductions",
    "lateAbsentAuto": "Late/Absent (Auto)",
    "grossEarnings": "Gross Earnings",
    "netPayable": "Net Payable",
    "reset": "Reset",
    "saveRecord": "Save Record",
    "hourlyRateLabel": "HOURLY RATE",
    "sessionTypeLabel": "SESSION TYPE",
    "phonePlaceholder": "e.g. 050 123 4567",
    "guestName": "Guest Name",
    "subtotalLabel": "SUBTOTAL",
    "retryCamera": "Retry Camera",
    "scanFocusInfo": "Pinch or use slider to focus.",
    "tapToFocus": "Tap screen to force focus.",
    "centerCodeFrame": "Center the code inside the blue frame",
    "holdAwayTap": "Hold 20cm away & Tap to sharpen",
    "selectMonthInfo": "Select month to view salary details",
    "manageEditMonth": "Manage/Edit for this Month",
    "viewManageLocations": "View and manage all your physical locations",
    "addAccount": "Add Account",
    "accountName": "Account Name",
    "initialBalance": "Initial Balance",
    "editItem": "Edit Item",
    "addInventoryItem": "Add Inventory Item",
    "printBarcodeLabel": "Print Barcode Label",
    "newSale": "New Sale",
    "totalAmount": "Total Amount",
    "completed": "Completed",
    "shipped": "Shipped",
    "itemsSummaryLabel": "Items (Summary)",
    "connectionError": "Connection Error:",
    "dismiss": "Dismiss",
    "adminUser": "Admin User",
    "optional": "Optional",
    "onTimeLabel": "On Time",
    "lateLabel": "Late",
    "absentLabel": "Absent",
    "pendingLabel": "Pending",
    "createSale": "Create Sale",
    "newPurchase": "New Purchase",
    "supplierName": "Supplier Name",
    "tax": "Tax",
    "accountsSubtitle": "Track assets, liabilities, and expenses.",
    "mixedLocationError": "Cannot mix items from different locations! Please clear cart first.",
    "department": "Department",
    "missing": "Missing",
    "taxEstimation": "Estimated tax deductions",
    "noAccounts": "No accounts found. Add one to get started.",
    "outOfStock": "Out of Stock",
    "printWizard": "Print Barcodes Wizard",
    "totalLabels": "Total Labels",
    "layoutMode": "Layout Mode",
    "orderNumber": "Order Number",
    "partsUsed": "Parts Used",
    "createInvoice": "Create Invoice",
    "serviceInvoice": "Service Invoice",
    "printNow": "Print Now",
    "dailySales": "Daily Sales",
    "cafeHistory": "Cafe History",
    "searchByDate": "Search by Date",
    "printSelected": "Print Selected",
    "previousBills": "Previous Bills",
    "confirmDelete": "Are you sure you want to delete?",
    "deleteError": "Error deleting item",
    "history": "History",
    "itemExists": "Item already exists",
    "update": "Update",
    "upi": "UPI",
    "pay": "Pay",
    "Saved": "Saved!",
    "Report": "Report",
    "Reset to defaults": "Reset to defaults",
    "id": "ID",
    "instaPay": "InstaPay",
    "method": "Method",
    "exp": "Exp",
    "a": "A",
    "T": "T",
    "pn": "PN",
    "No items with barcodes to print.": "No items with barcodes to print.",
    "Please allow popups to print payroll slip": "Please allow popups to print payroll slip",
    "Please select a question and answer!": "Please select a question and answer!",
    "printPayrollSlip": "Print Payroll Slip",
    "profit_loss": "Profit & Loss",
    "now": "Now",
    "h": "h",
    "m": "m",
    "PlayStation": "PlayStation",
    "Billiards": "Billiards",
    "Cafe": "Cafe",
    "sticker": "Sticker",
    "a4 sheet": "A4 Sheet",
    "noBarcode": "No Barcode",
    "menuService": "Service & Repairs",
    "activeJobs": "Active Jobs",
    "serviceHistory": "Service History",
    "customerInfo": "Customer Info",
    "deviceDetails": "Device Details",
    "issueDescription": "Issue Description",
    "describeIssue": "Describe the problem...",
    "estimatedCost": "Estimated Cost",
    "technician": "Technician",
    "priority": "Priority",
    "createTicket": "Create Ticket",
    "searchTickets": "Search tickets...",
    "noActiveJobs": "No active repair jobs",
    "editTicket": "Edit Repair Ticket",
    "saveChanges": "Save Changes",
    "received": "Received",
    "inProgress": "In Progress",
    "waitingParts": "Waiting for Parts",
    "readyPickup": "Ready for Pickup",
    "delivered": "Delivered",
    "lowStockAlerts": "Low Stock Alerts",
    "pendingRepairs": "Pending Repairs",
    "completedRepairs": "Completed Repairs",
    "pendingPayments": "Pending Payments",
    "servicePerformance": "Service Performance",
    "topRepairs": "Top Repair Types",
    "technicianRevenue": "Technician Revenue",
    "monthlyServiceRevenue": "Monthly Service Revenue",
    "sparePartsUsage": "Spare Parts Usage",
    "addStock": "Add Stock",
    "attachPhotos": "Device Photos",
    "add": "Add",
    "recentActivity": "Recent Activity",
    "customerProfile": "Customer Profile",
    "deviceInfo": "Device Information",
    "repairHistory": "Repair History",
    "diagnostics": "Diagnostics",
    "paymentStatus": "Payment Status",
    "paid": "Paid",
    "unpaid": "Unpaid",
    "partial": "Partial",
    "spareParts": "Spare Parts",
    "lowStock": "Low Stock",
    "phoneParts": "Phone Parts",
    "pcComponents": "PC Components",
    "accessories": "Accessories",
    "urgent": "Urgent",
    "high": "High",
    "normal": "Normal",
    "low": "Low",
    "createNewRepairTicket": "Create New Repair Ticket",
    "todaysRevenue": "Today's Revenue",
    "address": "Address",
    "assignedTechnician": "Assigned Technician",
    "brand": "Brand",
    "collected": "Collected",
    "console": "Console",
    "creditCard": "Credit Card",
    "dashboard": "Dashboard",
    "device": "Device",
    "editCustomer": "Edit Customer",
    "internalNotes": "Internal Notes",
    "minStock": "Min Stock",
    "mobile": "Mobile",
    "model": "Model",
    "other": "Other",
    "page": "Page",
    "paymentMethod": "Payment Method",
    "pc": "PC",
    "serialNo": "Serial No",
    "tablet": "Tablet",
    "totalNetPay": "Total Net Pay",
    "totalRecords": "Total Records",
    "allowPopups": "Please allow popups to print the receipt.",
    "sell": "Sell",
    "servicePOS": "Service POS",
    "serviceCenter": "Service Center",
    "repairManagement": "Repair Management",
    "activeRepairs": "Active Repairs",
    "noRecentActivity": "No Recent Activity",
    "searchRepairsAndStock": "Search Repairs or Stock...",
    "morning8": "Morning (8h)",
    "night8": "Night (8h)",
    "finance": "Finance",
    "ownerMode": "Owner Mode",
    "managerMode": "Manager Mode",
    "cashierMode": "Cashier Mode",
    "otherPayment": "Other Payment",
    "repairs": "Repairs",
    "insufficientIngredient": "Insufficient stock for ingredient",
    "insufficientStock": "Insufficient stock for",
    "maxStockReached": "Max stock reached:",
    "customItem": "Custom Item",
    "enterItemName": "Enter Item Name:",
    "enterItemPrice": "Enter Item Price:",
    "inventoryParts": "Inventory Parts",
    "useExternalTerminal": "Use External Terminal",
    "billToPOS": "Bill to POS",
    "permissionDeniedOwner": "Access Denied: Owner PIN Required.",
    "ownerOnlyPins": "Only Owner can manage PINs",
    "instapay": "InstaPay",
    "repairLabor": "Repair Labor",
    "autoHide": "Auto-hide",
    "seconds": "s",
    "terminal": "Terminal",
    "jobs": "Jobs",
    "sparePart": "Spare Part",
    "todaysServices": "Today's Services",
    "servicesOn": "Services on",
    "scan": "Scan",
    "shopLogo": "Shop Logo",
    "uploadLogo": "Upload Logo",
    "changeLogo": "Change Logo",
    "removeLogo": "Remove Logo",
    "kioskCheckInSuccess": "Check-in Successful!",
    "kioskCheckOutSuccess": "Check-out Successful!",
    "allTransactions": "All Transactions",
    "searchHistory": "Search history...",
    "reviewPastSales": "REVIEW PAST SALES & REPAIRS",
    "payment": "Payment",
    "reprint": "Reprint",
    "repair": "Repair",
    "noHistoryInPeriod": "No records found for this period",
    "manual": "Manual",
    "partsTotal": "Parts Total",
    "noPartsUsed": "No parts used yet",
    "viewCart": "View Cart",
    "customerInformation": "Customer Information",
    "ticketId": "Ticket ID",
    "inventoryManagement": "Inventory Management",
    "pinManagement": "PIN Management",
    "cashierPin": "Cashier PIN",
    "managerPin": "Manager PIN",
    "ownerPin": "Owner PIN",
    "saleCompleted": "Sale Completed!",
    "repairAlreadyInCart": "Repair already in cart!",
    "deleteViaActiveJobs": "Delete via Service Active Jobs",
    "photoUploadFailed": "Photo upload failed. Please check connection.",
    "logoSizeError": "Logo must be smaller than 2MB",
    "adminPinRequired": "Access Denied: Admin PIN Required.",
    "managerPinRestricted": "Manager PIN Restricted.",
    "ownerPinRestricted": "Owner PIN Restricted.",
    "totalQty": "Total Quantity",
    "exitKioskPrompt": "Double click to exit kiosk",
    "borrow": "Borrow",
    "borrowDate": "Borrow Date",
    "borrowTime": "Time",
    "dateBorrowed": "Borrowed On",
    "dateReturned": "Returned On",
    "returned": "Returned",
    "borrowed": "Borrowed",
    "borrowItems": "Borrowed Items",
    "noBorrowRecords": "No Borrow Records",
    "borrower": "Borrower",
    "markAsBorrowed": "Mark Borrowed",
    "markAsReturned": "Mark Returned",
    "borrowerName": "Borrower Name",
    "addBorrowRecord": "Add Borrow Record",
    "addRecord": "Add Record",
    "additionalInfo": "Additional Info",
    "enableGst": "Enable GST",
    "gstNumber": "GST Number",
    "gstPercent": "GST Rate (%)",
    "taxableAmt": "Taxable Amt",
    "taxableAmtMgmt": "Taxable Amt Management",
    "gstPlaceholder": "Ex: 22AAAAA0000",
    "gst": "GST"
  },
  "hi": {
    "appName": "Finn ERP",
    "appSubtitle": "एंटरप्राइज़ रिसोर्स प्लानिंग",
    "menuDashboard": "डैशबोर्ड",
    "menuEmployees": "कर्मचारी",
    "menuSites": "स्थान / साइट्स",
    "menuAttendance": "उपस्थिति",
    "menuPayroll": "वेतन",
    "menuReports": "रिपोर्ट",
    "settings": "सेटिंग्स",
    "search": "खोजें...",
    "allEmployees": "सभी कर्मचारी",
    "manageStaff": "सुरक्षा कर्मियों और शिफ्ट का प्रबंधन करें।",
    "addEmployee": "गार्ड जोड़ें",
    "name": "नाम",
    "role": "पद",
    "dept": "विभाग",
    "salary": "मूल वेतन",
    "bonus": "बोनस",
    "overtime": "ओवरटाइम",
    "deductions": "कटौती",
    "image": "छवि",
    "devicePhotos": "डिवाइस तस्वीरें",
    "salesEmployee": "बिक्री कर्मचारी",
    "adminDefault": "एडमिन (डिफ़ॉल्ट)",
    "historyLog": "इतिहास लॉग",
    "historySubtitle": "बिक्री और गोदाम गतिविधियों का व्यापक लॉग।",
    "allTypes": "सभी प्रकार",
    "sales": "बिक्री",
    "stockUpdates": "स्टॉक अपडेट",
    "valueStatus": "मूल्य / स्थिति",
    "noHistory": "कोई इतिहास रिकॉर्ड नहीं मिला।",
    "sold": "बेचा",
    "to": "को",
    "assistant": "सहायक",
    "reviewOrder": "ऑर्डर समीक्षा",
    "products": "उत्पाद",
    "scanner": "स्कैनर",
    "cart": "कार्ट",
    "digitalPayment": "डिजिटल भुगतान",
    "paymentMethodNotConfigured": "सेटिंग्स में भुगतान विधि कॉन्फ़िगर नहीं की गई है",
    "scanBarcode": "बारकोड स्कैन करें",
    "upiId": "UPI आईडी",
    "instapayId": "InstaPay आईडी",
    "payWithUPI": "UPI के साथ भुगतान करें",
    "payWithInstapay": "InstaPay से भुगतान करें",
    "confirmCheckout": "चेकआउट की पुष्टि करें",
    "linkExpired": "लिंक की अवधि समाप्त",
    "linkExpiredDetail": "यह भुगतान लिंक केवल 10 मिनट के लिए मान्य था। कृपया नया क्यूआर कोड मांगें।",
    "payNow": "अभी भुगतान करें",
    "secureUpi": "सुरक्षित UPI भुगतान",
    "securePayment": "सुरक्षित डिजिटल भुगतान",
    "totalLabel": "कुल",
    "goBackToApp": "ऐप पर वापस जाएं",
    "units": "इकाइयाँ",
    "stockCheck": "स्टॉक चेक",
    "items": "वस्तुएं",
    "total": "कुल",
    "netPay": "शुद्ध वेतन",
    "actions": "कार्रवाई",
    "login": "लॉग इन करें",
    "signup": "साइन अप करें",
    "email": "ईमेल",
    "password": "पासवर्ड",
    "welcome": "स्वागत है",
    "signInToAccess": "डैशबोर्ड का उपयोग करने के लिए साइन इन करें",
    "createAccount": "खाता बनाएं",
    "haveAccount": "क्या आपके पास खाता है?",
    "noAccount": "खाता नहीं है?",
    "logout": "लॉग आउट",
    "guestLogin": "अतिथि लॉगिन",
    "forgotPassword": "पासवर्ड भूल गए?",
    "resetPassword": "पासवर्ड रीसेट करें",
    "sendResetLink": "रीसेट लिंक भेजें",
    "backToLogin": "लॉगइन पर वापस जाएं",
    "passwordResetSent": "पासवर्ड रीसेट ईमेल भेजा गया!",
    "enterEmail": "पासवर्ड रीसेट करने के लिए अपना ईमेल दर्ज करें",
    "orContinue": "या इसके साथ जारी रखें",
    "signInGoogle": "Google के साथ साइन इन करें",
    "location": "स्थान",
    "shift": "शिफ्ट",
    "totalComp": "कुल आय",
    "dailyAttendance": "दैनिक उपस्थिति लॉग",
    "trackAttendance": "गार्ड चेक-इन और शिफ्ट ट्रैक करें।",
    "checkIn": "चेक इन",
    "checkOut": "चेक आउट",
    "status": "स्थिति",
    "import": "आयात (Import)",
    "export": "निर्यात (Export)",
    "payrollMgmt": "वेतन प्रबंधन",
    "costAnalysis": "वास्तविक समय लागत विश्लेषण।",
    "aiInsights": "AI विश्लेषण",
    "siteStats": "साइट आँकड़े",
    "assignedGuards": "नियुक्त गार्ड",
    "deleteLocation": "स्थान हटाएं",
    "terminateGuard": "कर्मचारी हटाएं",
    "aiAssistant": "AI सहायक",
    "genReview": "प्रदर्शन समीक्षा बनाएं",
    "generating": "बना रहा है...",
    "downloadReport": "रिपोर्ट डाउनलोड करें",
    "editLocation": "स्थान संपादित करें",
    "otp": "ओटीपी कोड",
    "otpSent": "ओटीपी भेजा गया",
    "otpSentDetail": "ओटीपी shoaibwwe01@outlook.com पर भेजा गया है। कृपया व्यवस्थापक से कोड मांगें।",
    "invalidOtp": "अमान्य ओटीपी कोड",
    "registeredOnly": "केवल पंजीकृत उपयोगकर्ताओं के लिए",
    "guestNotice": "आप अतिथि मोड में हैं। सभी सुविधाओं के लिए पंजीकरण करें।",
    "manageDetails": "साइट विवरण प्रबंधित करें",
    "siteName": "साइट का नाम",
    "city": "शहर / क्षेत्र",
    "manager": "साइट मैनेजर",
    "operationalStatus": "परिचालन स्थिति",
    "photoUrl": "कर्मचारी फोटो",
    "uploadPhoto": "फोटो अपलोड करें",
    "unassigned": "अनसाइंड",
    "securityTeam": "सुरक्षा टीम",
    "guards": "गार्ड",
    "addLocation": "नया स्थान जोड़ें",
    "createLocation": "स्थान बनाएं",
    "cancel": "रद्द करें",
    "filterAll": "सभी स्थान",
    "morningShift": "सुबह (12 घंटे)",
    "nightShift": "रात (12 घंटे)",
    "operational": "चालू",
    "renovating": "मरम्मत",
    "active": "सक्रिय",
    "closed": "बंद",
    "onTime": "समय पर",
    "late": "देर से",
    "absent": "अनुपस्थित",
    "design": "डिजाइन",
    "engineering": "इंजीनियरिंग",
    "hr": "मानव संसाधन",
    "marketing": "मार्केटिंग",
    "operations": "संचालन",
    "security": "सुरक्षा",
    "it": "IT",
    "headquarters": "मुख्यालय",
    "kitchen": "रसोई",
    "service": "सेवा",
    "bar": "बार",
    "retail": "खुदरा",
    "warehouse": "गोदाम",
    "inventory": "इन्वेंटरी",
    "accounts": "खाते",
    "management": "प्रबंधन",
    "cleaning": "साफ-सफाई",
    "maintenance": "रखरखाव",
    "morning12": "सुबह (12 घंटे)",
    "night12": "रात (12 घंटे)",
    "importSuccess": "{0} रिकॉर्ड सफलतापूर्वक आयात किए गए।",
    "importError": "आयात करने में त्रुटि: ",
    "payrollUpdateSuccess": "{0} कर्मचारियों के लिए वेतन अद्यतन किया गया।",
    "payrollUpdateError": "वेतन अद्यतन करने में त्रुटि: ",
    "myProfile": "मेरी प्रोफाइल",
    "emailLabel": "ईमेल:",
    "userIdLabel": "उपयोगकर्ता आईडी:",
    "accountTypeLabel": "खाता प्रकार:",
    "admin": "व्यवस्थापक",
    "shopSettingsSaved": "दुकान सेटिंग्स क्लाउड पर सहेजी गईं",
    "shopSettingsError": "सेटिंग्स सहेजने में त्रुटि",
    "localization": "स्थानीयकरण",
    "language": "भाषा",
    "daily": "दैनिक",
    "weekly": "साप्ताहिक",
    "monthly": "मासिक",
    "yearly": "वार्षिक",
    "profitLossReport": "लाभ और हानि रिपोर्ट",
    "currency": "मुद्रा",
    "departmentSettings": "विभाग सेटिंग्स",
    "departments": "विभाग",
    "manageDepartments": "विभाग जोड़ें या हटाएँ",
    "addDepartment": "विभाग जोड़ें",
    "backupRestore": "बैकअप और पुनर्स्थापना",
    "exportBackup": "बैकअप निर्यात करें",
    "importBackup": "बैकअप आयात करें",
    "backupDescription": "अपना डेटा JSON के रूप में निर्यात करें या पिछले बैकअप से पुनर्स्थापित करें।",
    "dangerZone": "खतरा क्षेत्र",
    "irreversibleAction": "अपरिवर्तनीय कार्रवाई। सभी डेटा हटा दिया जाएगा।",
    "factoryReset": "सिस्टम फैक्टरी रीसेट",
    "compensation": "मुआवजा",
    "advance": "अग्रिम",
    "delete": "हटाएं",
    "terminateService": "सेवा समाप्त करें",
    "selectEmployeeAlert": "कृपया एक बिक्री कर्मचारी चुनें!",
    "accountHandling": "खाता प्रबंधन",
    "connectGoogle": "Google खाता कनेक्ट करें",
    "linkGoogleDesc": "पासवर्ड के बजाय इसका उपयोग करके लॉग इन करने के लिए अपने Google खाते को लिंक करें।",
    "soldItemsDetail": "बेची गई वस्तुओं का विवरण",
    "boughtItemsDetail": "खरीदी गई वस्तुओं का विवरण (खरीद और व्यय)",
    "unknown": "अअम:",
    "totals": "कुल",
    "unitCost": "इकाई लागत",
    "period": "अवधि",
    "na": "लागू नहीं",
    "totalCost": "कुल लागत",
    "profit": "लाभ",
    "addAttendance": "हाजिरी जोड़ें",
    "editAttendance": "हाजिरी संपादित करें",
    "deleteAttendance": "हाजिरी हटाएं",
    "selectEmployee": "कर्मचारी चुनें",
    "selectDate": "दिनांक चुनें",
    "selectStatus": "स्थिति चुनें",
    "save": "सहेजें",
    "replacementFor": "की जगह (Replacement)",
    "coveringFor": "कवरिंग (Covering)",
    "lateDeductions": "देरी कटौती",
    "absentDeductions": "अनुपस्थिति कटौती",
    "manualDeduction": "मैनुअल कटौती",
    "cost": "लागत",
    "none": "कोई नहीं",
    "dashboardTotal": "कुल",
    "activeGuards": "सक्रिय गार्ड",
    "operationalSites": "परिचालन स्थल",
    "checkedInToday": "आज चेक-इन किया",
    "issuesToday": "आज की समस्याएं",
    "quickActions": "त्वरित कार्रवाई",
    "addStaff": "स्टाफ जोड़ें",
    "addSite": "साइट जोड़ें",
    "systemStatus": "सिस्टम की स्थिति",
    "systemOperational": "सभी सिस्टम चालू हैं। डेटाबेस सिंक किया गया।",
    "online": "ऑनलाइन",
    "attendanceReport": "उपस्थिति रिपोर्ट",
    "payrollReport": "वेतन रिपोर्ट",
    "staffReport": "स्टाफ रिपोर्ट",
    "taxReport": "कर रिपोर्ट",
    "today": "आज",
    "salesOn": "बिक्री दिनांक",
    "lateAbsent": "देर/अनुपस्थित",
    "lateHours": "विलंब घंटे",
    "attendanceExists": "इस कर्मचारी के लिए इस तारीख को उपस्थिति पहले से मौजूद है।",
    "theme": "थीम",
    "light": "लाइट",
    "payrollSlip": "वेतन पर्ची",
    "payrollFor": "वेतन के लिए",
    "employeeName": "कर्मचारी का नाम",
    "employeeId": "कर्मचारी आईडी",
    "payPeriod": "वेतन अवधि",
    "basicSalary": "मूल वेतन",
    "grossPay": "सकल वेतन",
    "totalDeductions": "कुल कटौती",
    "otherDeductions": "अन्य कटौती",
    "employeeSignature": "कर्मचारी के हस्ताक्षर",
    "authorizedSignature": "अधिकृत हस्ताक्षर",
    "computerGenerated": "यह कंप्यूटर जनित वेतन पर्ची है। हस्ताक्षर की आवश्यकता नहीं है।",
    "generatedOn": "उत्पन्न",
    "at": "पर",
    "companyName": "कंपनी का नाम",
    "companyAddress": "कंपनी का पता",
    "selectLocation": "स्थान चुनें",
    "noLocations": "कोई स्थान उपलब्ध नहीं है - कृपया पहले एक स्थान बनाएं",
    "menuAccounts": "Accounts",
    "menuSalesPurchases": "बेचना (Sell)",
    "menuWarehouses": "गोदाम (Warehouses)",
    "menuInvoices": "इतिहास (History)",
    "weeklySales": "साप्ताहिक बिक्री रिपोर्ट",
    "weeklyBuy": "साप्ताहिक खरीद/स्टॉक रिपोर्ट",
    "walkIn": "वॉक-इन (Walk-in)",
    "takeaway": "टेकअवे (Takeaway)",
    "customerCopy": "ग्राहक प्रति",
    "shopCopy": "दुकान प्रति",
    "printSettings": "प्रिंट सेटिंग्स",
    "thermal": "थर्मल (80mm)",
    "a4": "A4 (मानक)",
    "dualPrint": "दोहरी प्रिंट (ग्राहक + दुकान)",
    "lastUpdated": "अंतिम अपडेट",
    "stockValueBuy": "स्टॉक मूल्य (खरीद)",
    "stockValueSell": "स्टॉक मूल्य (बिक्री)",
    "itemsSummary": "वस्तु सारांश",
    "invoiceId": "चालान आईडी",
    "type": "प्रकार",
    "posTerminal": "POS टर्मिनल",
    "searchProducts": "उत्पाद खोजें...",
    "todaysSales": "आज की बिक्री",
    "time": "समय",
    "receipt": "रसीद",
    "currentBill": "वर्तमान बिल",
    "cartEmpty": "कार्ट खाली है",
    "selectItems": "ग्रिड से आइटम चुनें",
    "checkout": "चेकआउट",
    "customerNameOptional": "ग्राहक का नाम (वैकल्पिक)",
    "hold": "रोकें",
    "resumeWarning": "फिर से शुरू करने से वर्तमान कार्ट बदल जाएगा। जारी रखें?",
    "quickStockIn": "त्वरित स्टॉक इन",
    "currentQuantity": "वर्तमान मात्रा",
    "enterAddedQty": "जोड़ी गई मात्रा दर्ज करें",
    "soldBy": "विक्रेता (Sold By)",
    "taxed": "कर",
    "inventorySubtitle": "इन्वेंटरी स्तर और स्टॉक गतिविधियां",
    "searchInventory": "नाम या SKU द्वारा इन्वेंट्री खोजें...",
    "itemName": "वस्तु का नाम",
    "buyPrice": "खरीद मूल्य",
    "sellPrice": "विक्रय मूल्य",
    "quantity": "मात्रा",
    "refinement": "शोधन",
    "noInventory": "कोई इन्वेंट्री आइटम नहीं मिला",
    "hideCosts": "लागत छिपाएं",
    "showCosts": "लागत दिखाएं",
    "securityCheck": "सुरक्षा जाँच",
    "addItem": "आइटम जोड़ें",
    "edit": "संपादित करें",
    "itemNotFound": "इन्वेंट्री में उत्पाद नहीं मिला। कृपया जाँचें या जोड़ें।",
    "generate": "उत्पन्न करें",
    "print": "प्रिंट करें",
    "printAll": "सभी बारकोड प्रिंट करें",
    "shopSettings": "दुकान सेटिंग्स",
    "shopName": "दुकान का नाम",
    "shopAddress": "दुकान का पता",
    "shopPhone": "दुकान का फोन",
    "updateSettings": "सेटिंग्स अपडेट करें",
    "securityPin": "सुरक्षा पिन",
    "close": "बंद करें",
    "retailInvoice": "खुदरा चालान",
    "invoice": "चालान",
    "date": "तारीख",
    "billNo": "ID",
    "paymentMode": "भुगतान मोड",
    "cash": "नकद",
    "item": "वस्तु",
    "qty": "मात्रा",
    "amt": "राशि",
    "price": "मूल्य",
    "amount": "राशि",
    "subtotal": "उप-योग",
    "taxVAT": "कर/वैट",
    "taxRate": "कर दर",
    "makeChecksPayable": "सभी चेक देय बनाएं",
    "thankYou": "आपके व्यवसाय के लिए धन्यवाद!",
    "billTo": "बिल प्राप्तकर्ता",
    "description": "विवरण",
    "unitPrice": "इकाई मूल्य",
    "lineTotal": "पंक्ति कुल",
    "comments": "टिप्पणियाँ",
    "termsConditions": "नियम और शर्तें",
    "paymentTerms": "1. 30 दिनों में कुल भुगतान देय",
    "includeInvoiceNumber": "2. कृपया अपने चेक पर चालान संख्या शामिल करें",
    "phone": "फोन",
    "customer": "ग्राहक",
    "contactQuestions": "यदि इस चालान के बारे में आपके कोई प्रश्न हैं, तो कृपया संपर्क करें",
    "authError": "प्रमाणीकरण त्रुटि: ",
    "googleSignInError": "Google साइन इन त्रुटि: ",
    "factoryResetWarning": "महत्वपूर्ण चेतावनी: यह सभी डेटा को स्थायी रूप से हटा देगा। क्या आपको यकीन है?",
    "pinPrompt": "सुरक्षा पिन दर्ज करें:",
    "incorrectPin": "गलत पिन।",
    "factoryResetPinPrompt": "पुष्टि करने के लिए सुरक्षा पिन दर्ज करें:",
    "factoryResetIncorrectPin": "गलत पिन। रीसेट रद्द।",
    "switchModePrompt": "मोड बदलने के लिए व्यवस्थापक पिन दर्ज करें:",
    "changeUserPrompt": "उपयोगकर्ता बदलने के लिए पिन दर्ज करें:",
    "resetComplete": "रीसेट पूर्ण। डेटा मिटा दिया गया।",
    "resetFailed": "रीसेट विफल: ",
    "backupExported": "बैकअप सफलतापूर्वक निर्यात किया गया!",
    "exportFailed": "निर्यात विफल: ",
    "backupImported": "बैकअप आयातित! रीलोड हो रहा है...",
    "importFailed": "आयात विफल: ",
    "overwriteWarning": "चेतावनी: यह सभी मौजूदा डेटा को अधिलेखित कर देगा। जारी रखें?",
    "linkSuccess": "Google खाता सफलतापूर्वक लिंक किया गया!",
    "linkError": "लिंक त्रुटि: ",
    "accountLinked": "यह Google खाता पहले से सक्रिय है।",
    "employeeSaved": "कर्मचारी सफलतापूर्वक सहेजा गया!",
    "saveError": "सहेजने में त्रुटि: ",
    "deleteConfirm": "क्या आपको यकीन है?",
    "updateError": "आद्यतन त्रुटि: ",
    "addPurchaseError": "खरीद जोड़ने में त्रुटि: ",
    "genInvoiceError": "चालान त्रुटि: ",
    "addItemError": "आइटम जोड़ने में त्रुटि: ",
    "deleteLocationWarning": "हटा नहीं सकते। कर्मचारी नियुक्त हैं।",
    "deleteLocationConfirm": "इस स्थान को हटाएं?",
    "errorNoUser": "त्रुटि: कोई उपयोगकर्ता लॉग इन नहीं है।",
    "totalIncome": "कुल आय",
    "visa": "वीज़ा",
    "onlinePayment": "ऑनलाइन",
    "forgotPin": "पिन भूल गए?",
    "securityQuestion": "सुरक्षा प्रश्न",
    "securityAnswer": "सुरक्षा उत्तर",
    "enterSecurityAnswer": "सुरक्षा उत्तर दर्ज करें",
    "pinResetSuccess": "पिन सफलतापूर्वक रीसेट किया गया! आपका नया पिन 1234 है।",
    "incorrectAnswer": "गलत उत्तर।",
    "setSecurityQuestion": "सुरक्षा प्रश्न सेट करें",
    "changePin": "सुरक्षा पिन बदलें",
    "newPin": "नया पिन",
    "saveSettings": "सेटिंग्स सहेजें",
    "currentPin": "वर्तमान पिन",
    "enterNewPin": "नया पिन दर्ज करें",
    "pinChanged": "पिन सफलतापूर्वक अपडेट किया गया!",
    "pinSetMessage": "पिन सेट है। रीसेट करने के लिए \"पिन भूल गए\" का उपयोग करें।",
    "secQ_pet": "आपके पहले पालतू जानवर का नाम क्या है?",
    "secQ_mother": "आपकी माँ का मायके का नाम क्या है?",
    "secQ_city": "आपका जन्म किस शहर में हुआ था?",
    "secQ_school": "आपके पहले स्कूल का नाम क्या है?",
    "manageLocations": "अपने सभी भौतिक स्थानों को प्रबंधित और मॉनिटर करें।",
    "siteEmployees": "कर्मचारी",
    "monthlyPl": "मासिक लाभ और हानि",
    "discount": "छूट",
    "plSubtitle": "राजस्व बनाम बेचे गए माल की लागत बनाम व्यय विश्लेषण",
    "revenue": "राजस्व",
    "totalSales": "कुल बिक्री",
    "cogs": "बेचे गए माल की लागत",
    "cogsFull": "बेचे गए माल की लागत",
    "grossProfit": "सकल लाभ",
    "expenses": "व्यय",
    "purchasesOther": "खरीद/अन्य",
    "netProfit": "शुद्ध लाभ",
    "netLoss": "शुद्ध हानि",
    "incomeStatement": "आय विवरण",
    "salesCash": "बिक्री - नकद",
    "salesVisa": "बिक्री - वीज़ा",
    "salesOnline": "बिक्री - ऑनलाइन",
    "totalRevenue": "कुल राजस्व",
    "costOfGoodsSold": "बेचे गए माल की लागत",
    "grossMargin": "सकल मार्जिन",
    "operatingExpenses": "परिचालन व्यय",
    "totalExpenses": "कुल व्यय",
    "netMargin": "शुद्ध मार्जिन",
    "deptExpenses": "विभाग व्यय",
    "invPurchases": "इन्वेंटरी खरीद",
    "liveBoard": "लाइव बोर्ड",
    "manageUnits": "कमरे और मेज",
    "menuRecipes": "मेन्यू और रेसिपी",
    "activeSessions": "सक्रिय सत्र",
    "unitsMonitoring": "{0} इकाइयों की लाइव निगरानी",
    "inSession": "सत्र में",
    "available": "उपलब्ध",
    "startSession": "सत्र शुरू करें",
    "addOrder": "ऑर्डर जोड़ें",
    "stop": "रोकें",
    "recipeBuilder": "रेसिपी बिल्डर",
    "manageUnitsTitle": "इकाइयों का प्रबंधन",
    "roomName": "कमरे का नाम",
    "unitType": "इकाई प्रकार",
    "hourlyRate": "प्रति घंटा दर",
    "saveUnit": "इकाई सहेजें",
    "cafeTable": "कैफे मेज",
    "playStationRoom": "प्लेस्टेशन कमरा",
    "billiardsTable": "बिलियर्ड्स मेज",
    "category": "श्रेणी",
    "offerPrice": "कीमत",
    "composition": "संरचना",
    "linkStock": "+ गोदाम स्टॉक लिंक करें",
    "hotDrinks": "गर्म पेय",
    "coldDrinks": "ठंडे पेय",
    "snacks": "नाश्ता",
    "meals": "भोजन",
    "updateItem": "आइटम अपडेट करें",
    "addToMenu": "मेन्यू में जोड़ें",
    "appendSession": "सत्र में आइटम जोड़ें",
    "orderHistory": "ऑर्डर इतिहास",
    "newSelection": "नया चयन",
    "trayEmpty": "ट्रे खाली है",
    "trayTotal": "ट्रे कुल",
    "confirmOrder": "ऑर्डर की पुष्टि करें",
    "menuItemsMissingTitle": "कोई मेन्यू आइटम नहीं",
    "all": "सभी",
    "customerPhone": "ग्राहक फोन *",
    "customerName": "ग्राहक का नाम",
    "sessionType": "सत्र का प्रकार",
    "openSession": "खुला (कोई सीमा नहीं)",
    "fixedDuration": "निश्चित अवधि",
    "startSessionTitle": "सत्र शुरू करें",
    "managePayroll": "पेरोल प्रबंधित करें",
    "advanceTaken": "अग्रिम लिया गया",
    "manualDeductions": "मैनुअल कटौती",
    "lateAbsentAuto": "देरी/अनुपस्थित (ऑटो)",
    "grossEarnings": "कुल कमाई",
    "netPayable": "शुद्ध देय",
    "reset": "रीसेट",
    "saveRecord": "रिकॉर्ड सहेजें",
    "hourlyRateLabel": "प्रति घंटा दर",
    "sessionTypeLabel": "सत्र प्रकार",
    "phonePlaceholder": "उदाहरण: 050 123 4567",
    "guestName": "अतिथि का नाम",
    "subtotalLabel": "उप-योग",
    "retryCamera": "कैमरा पुनः प्रयास करें",
    "scanFocusInfo": "फोकस करने के लिए पिंच करें या स्लाइडर का उपयोग करें।",
    "tapToFocus": "जबरन फोकस करने के लिए स्क्रीन पर टैप करें।",
    "centerCodeFrame": "कोड को नीले फ्रेम के अंदर केंद्रित करें",
    "holdAwayTap": "20 सेमी दूर रखें और स्पष्ट करने के लिए टैप करें",
    "selectMonthInfo": "वेतन विवरण देखने के लिए महीना चुनें",
    "manageEditMonth": "इस महीने के लिए प्रबंधित/संपादित करें",
    "viewManageLocations": "अपने सभी भौतिक स्थानों को देखें और प्रबंधित करें",
    "addAccount": "खाता जोड़ें",
    "accountName": "खाता नाम",
    "initialBalance": "प्रारंभिक शेष",
    "editItem": "आइटम संपादित करें",
    "addInventoryItem": "इन्वेंट्री आइटम जोड़ें",
    "printBarcodeLabel": "बारकोड लेबल प्रिंट करें",
    "newSale": "नई बिक्री",
    "totalAmount": "कुल राशि",
    "completed": "पूरा हुआ",
    "shipped": "भेजा गया",
    "itemsSummaryLabel": "वस्तु सारांश",
    "connectionError": "कनेक्शन त्रुटि:",
    "dismiss": "खारिज करें",
    "adminUser": "व्यवस्थापक उपयोगकर्ता",
    "optional": "वैकल्पिक",
    "onTimeLabel": "समय पर",
    "lateLabel": "देर से",
    "absentLabel": "अनुपस्थित",
    "pendingLabel": "लंबित",
    "createSale": "बिक्री बनाएं",
    "newPurchase": "नई खरीद",
    "supplierName": "आपूर्तिकर्ता का नाम",
    "tax": "कर",
    "menuCafe": "कैफे",
    "walkInCustomer": "वॉक-इन ग्राहक",
    "takeawayCustomer": "टेकअवे ग्राहक",
    "customerId": "ग्राहक आईडी",
    "advanceSalary": "अग्रिम वेतन",
    "barcode": "बारकोड",
    "digitalPayment_QR": "डिजिटल भुगतान (QR)",
    "totalWithDiscount": "छूट के बाद कुल",
    "details": "कर्मचारी विवरण",
    "cafe": "कैफे",
    "dark": "डार्क",
    "confirmChangePin": "पिन बदलने की पुष्टि करें",
    "accountsSubtitle": "संपत्ति, देनदारियों और खर्चों को ट्रैक करें।",
    "mixedLocationError": "विभिन्न स्थानों की वस्तुओं को नहीं मिला सकते! कृपया पहले कार्ट खाली करें।",
    "department": "विभाग",
    "missing": "लापता",
    "taxEstimation": "अनुमानित कर कटौती",
    "noAccounts": "कोई खाता नहीं मिला। शुरू करने के लिए एक जोड़ें।",
    "outOfStock": "स्टॉक में नहीं है",
    "printWizard": "बारकोड प्रिंट विज़ार्ड",
    "totalLabels": "कुल लेबल",
    "layoutMode": "लेआउट मोड",
    "orderNumber": "ऑर्डर नंबर",
    "partsUsed": "पुर्जों का उपयोग",
    "createInvoice": "चालान बनाएँ",
    "serviceInvoice": "सेवा चालान",
    "printNow": "अभी प्रिंट करें",
    "dailySales": "दैनिक बिक्री",
    "cafeHistory": "कैफे इतिहास",
    "searchByDate": "तारीख से खोजें",
    "printSelected": "चयनित प्रिंट करें",
    "previousBills": "पिछले बिल",
    "confirmDelete": "क्या आप वाकई हटाना चाहते हैं?",
    "deleteError": "आइटम हटाने में त्रुटि",
    "history": "इतिहास",
    "itemExists": "आइटम पहले से मौजूद है",
    "update": "अपडेट करें",
    "upi": "UPI",
    "pay": "भुगतान करें",
    "Saved": "सहेज लिया गया!",
    "Report": "रिपोर्ट",
    "Reset to defaults": "डिफ़ॉल्ट पर रीसेट करें",
    "id": "आईडी",
    "instaPay": "InstaPay",
    "method": "तरीका",
    "exp": "खर्च",
    "a": "अ",
    "T": "टी",
    "pn": "पीएन",
    "No items with barcodes to print.": "प्रिंट करने के लिए बारकोड वाला कोई आइटम नहीं है।",
    "Please allow popups to print payroll slip": "कृपया पेरोल स्लिप प्रिंट करने के लिए पॉपअप की अनुमति दें",
    "Please select a question and answer!": "कृपया एक प्रश्न और उत्तर चुनें!",
    "printPayrollSlip": "पेरोल स्लिप प्रिंट करें",
    "profit_loss": "लाभ और हानि",
    "now": "अभी",
    "h": "घं",
    "m": "मि",
    "PlayStation": "प्लेस्टेशन",
    "Billiards": "बिलियर्ड्स",
    "Cafe": "कैफे",
    "sticker": "स्टिकर",
    "a4 sheet": "A4 शीट",
    "noBarcode": "कोई बारकोड नहीं",
    "menuService": "सेवा और मरम्मत",
    "activeJobs": "सक्रिय कार्य",
    "newTicket": "नया टिकट",
    "serviceHistory": "सेवा इतिहास",
    "customerInfo": "ग्राहक जानकारी",
    "deviceDetails": "डिवाइस विवरण",
    "issueDescription": "समस्या का विवरण",
    "describeIssue": "समस्या का वर्णन करें...",
    "estimatedCost": "अनुमानित लागत",
    "technician": "तकनीशियन",
    "priority": "प्राथमिकता",
    "createTicket": "टिकट बनाएं",
    "searchTickets": "टिकट खोजें...",
    "noActiveJobs": "कोई सक्रिय मरम्मत कार्य नहीं",
    "editTicket": "मरम्मत टिकट संपादित करें",
    "saveChanges": "परिवर्तन सहेजें",
    "received": "प्राप्त",
    "inProgress": "प्रगति में",
    "waitingParts": "पुर्जों की प्रतीक्षा में",
    "readyPickup": "पिकअप के लिए तैयार",
    "delivered": "वितरित",
    "lowStockAlerts": "कम स्टॉक अलर्ट",
    "pendingRepairs": "लंबित मरम्मत",
    "completedRepairs": "पूर्ण मरम्मत",
    "pendingPayments": "लंबित भुगतान",
    "servicePerformance": "सेवा प्रदर्शन",
    "topRepairs": "शीर्ष मरम्मत प्रकार",
    "technicianRevenue": "तकनीशियन राजस्व",
    "monthlyServiceRevenue": "मासिक सेवा राजस्व",
    "sparePartsUsage": "स्पेयर पार्ट्स का उपयोग",
    "addCustomer": "ग्राहक जोड़ें",
    "addStock": "स्टॉक जोड़ें",
    "attachPhotos": "डिवाइस तस्वीरें",
    "add": "जोड़ें",
    "recentActivity": "हाल की गतिविधि",
    "customerProfile": "ग्राहक प्रोफ़ाइल",
    "deviceInfo": "डिवाइस की जानकारी",
    "repairHistory": "मरम्मत इतिहास",
    "diagnostics": "नैदानिक",
    "paymentStatus": "भुगतान की स्थिति",
    "paid": "भुगतान किया गया",
    "unpaid": "अदत्त",
    "partial": "आंशिक",
    "spareParts": "स्पेयर पार्ट्स",
    "lowStock": "कम स्टॉक",
    "phoneParts": "फोन के पुर्जे",
    "pcComponents": "पीसीसी घटक",
    "accessories": "सहायक उपकरण",
    "urgent": "तत्काल",
    "high": "उच्च",
    "normal": "सामान्य",
    "low": "कम",
    "createNewRepairTicket": "नया मरम्मत टिकट बनाएं",
    "todaysRevenue": "आज का राजस्व",
    "address": "पता (Address)",
    "assignedTechnician": "नियुक्त तकनीशियन",
    "brand": "ब्रांड (Brand)",
    "collected": "एकत्र किया गया (Collected)",
    "console": "कंसोल (Console)",
    "creditCard": "क्रेडिट कार्ड",
    "dashboard": "डैशबोर्ड",
    "device": "डिवाइस",
    "editCustomer": "ग्राहक संपादित करें",
    "internalNotes": "आंतरिक नोट्स",
    "minStock": "न्यूनतम स्टॉक",
    "mobile": "मोबाइल",
    "model": "मॉडल (Model)",
    "other": "अन्य (Other)",
    "page": "पृष्ठ (Page)",
    "paymentMethod": "भुगतान विधि",
    "pc": "पीसी (PC)",
    "serialNo": "सीरियल नंबर",
    "tablet": "टैबलेट (Tablet)",
    "totalNetPay": "कुल शुद्ध वेतन",
    "totalRecords": "कुल रिकॉर्ड",
    "customers": "ग्राहक",
    "allowPopups": "रसीद प्रिंट करने के लिए कृपया पॉपअप की अनुमति दें।",
    "morning8": "सुबह (8 घंटे)",
    "night8": "रात (8 घंटे)",
    "finance": "वित्त",
    "ownerMode": "मालिक मोड",
    "managerMode": "प्रबंधक मोड",
    "cashierMode": "कैशियर मोड",
    "otherPayment": "अन्य भुगतान",
    "repairs": "मरम्मत",
    "insufficientIngredient": "सामग्री के लिए अपर्याप्त स्टॉक",
    "insufficientStock": "इसके लिए अपर्याप्त स्टॉक",
    "maxStockReached": "अधिकतम स्टॉक पहुंच गया:",
    "customItem": "कस्टम आइटम",
    "enterItemName": "आइटम का नाम दर्ज करें:",
    "enterItemPrice": "आइटम की कीमत दर्ज करें:",
    "inventoryParts": "इन्वेंटरी पार्ट्स",
    "useExternalTerminal": "बाहरी टर्मिनल का उपयोग करें",
    "billToPOS": "POS में बिल भेजें",
    "permissionDeniedOwner": "पहुंच अस्वीकृत: मालिक PIN आवश्यक है।",
    "ownerOnlyPins": "केवल मालिक PIN प्रबंधित कर सकता है",
    "instapay": "InstaPay",
    "repairLabor": "मरम्मत श्रम",
    "autoHide": "ऑटो-छिपाएँ",
    "seconds": "सेकंड",
    "terminal": "टर्मिनल",
    "jobs": "कार्य",
    "sparePart": "स्पेयर पार्ट",
    "todaysServices": "आज की सेवाएं",
    "servicesOn": "सेवाएं पर",
    "scan": "स्कैन",
    "shopLogo": "दुकान का लोगो",
    "uploadLogo": "लोगो अपलोड करें",
    "changeLogo": "लोगो बदलें",
    "removeLogo": "लोगो हटाएँ",
    "menuKiosk": "कियोस्क मोड",
    "kioskWelcome": "हमारे कियोस्क में आपका स्वागत है",
    "kioskSub": "शुरू करने के लिए कृपया एक सेवा चुनें",
    "kioskPos": "सेल्फ-सर्विस पीओएस",
    "kioskService": "मरम्मत ट्रैकिंग",
    "kioskCheckIn": "कर्मचारी चेक-इन",
    "kioskClock": "वर्तमान समय",
    "kioskBack": "होम पर वापस जाएं",
    "kioskCheckInSuccess": "चेक-इन सफल!",
    "kioskCheckOutSuccess": "चेक-आउट सफल!",
    "allTransactions": "सभी लेनदेन",
    "searchHistory": "इतिहास खोजें...",
    "reviewPastSales": "पिछली बिक्री और मरम्मत की समीक्षा करें",
    "payment": "भुगतान",
    "reprint": "पुनः मुद्रण",
    "repair": "मरम्मत",
    "noHistoryInPeriod": "इस अवधि के लिए कोई रिकॉर्ड नहीं मिला",
    "siteLogo": "साइट लोगो",
    "systemLogo": "सिस्टम लोगो",
    "uploadSiteLogo": "साइट लोगो अपलोड करें",
    "changeSiteLogo": "साइट लोगो बदलें",
    "removeSiteLogo": "साइट लोगो हटाएँ",
    "manual": "मैनुअल",
    "partsTotal": "पुर्जों का कुल",
    "noPartsUsed": "अभी तक कोई पुर्जे उपयोग नहीं किए गए",
    "sell": "बेचें",
    "servicePOS": "सर्विस POS",
    "serviceCenter": "सर्विस सेंटर",
    "repairManagement": "मरम्मत प्रबंधन",
    "activeRepairs": "सक्रिय मरम्मत",
    "noRecentActivity": "कोई हालिया गतिविधि नहीं",
    "searchRepairsAndStock": "मरम्मत या स्टॉक खोजें...",
    "viewCart": "कार्ट देखें",
    "serviceModule": "सर्विस मॉड्यूल",
    "customerInformation": "ग्राहक जानकारी",
    "ticketId": "टिकट ID",
    "inventoryManagement": "इन्वेंटरी प्रबंधन",
    "pinManagement": "PIN प्रबंधन",
    "cashierPin": "कैशियर PIN",
    "managerPin": "मैनेजर PIN",
    "ownerPin": "ओनर PIN",
    "saleCompleted": "बिक्री संपन्न!",
    "repairAlreadyInCart": "मरम्मत पहले से कार्ट में है!",
    "deleteViaActiveJobs": "सक्रिय मरम्मत जॉब्स के माध्यम से हटाएँ",
    "photoUploadFailed": "फोटो अपलोड विफल रहा। कृपया कनेक्शन जांचें।",
    "logoSizeError": "लोगो 2MB से कम होना चाहिए",
    "adminPinRequired": "पहुंच अस्वीकृत: एडमिन PIN आवश्यक।",
    "managerPinRestricted": "मैनेजर PIN प्रतिबंधित।",
    "ownerPinRestricted": "ओनर PIN प्रतिबंधित।",
    "totalQty": "कुल मात्रा",
    "exitKioskPrompt": "कियोस्क से बाहर निकलने के लिए डबल क्लिक करें",
    "borrow": "उधार",
    "borrowDate": "उधार की तारीख",
    "borrowTime": "समय",
    "dateBorrowed": "उधार लिया गया",
    "dateReturned": "वापस किया गया",
    "returned": "वापस किया",
    "borrowed": "उधार",
    "borrowItems": "उधार की वस्तुएं",
    "noBorrowRecords": "कोई उधार रिकॉर्ड नहीं",
    "borrower": "उधारकर्ता",
    "markAsBorrowed": "उधार चिह्नित करें",
    "markAsReturned": "वापसी चिह्नित करें",
    "borrowerName": "उधारकर्ता का नाम",
    "addBorrowRecord": "उधार रिकॉर्ड जोड़ें",
    "addRecord": "रिकॉर्ड जोड़ें",
    "additionalInfo": "अतिरिक्त जानकारी",
    "enableGst": "GST सक्षम करें",
    "gstNumber": "जीएसटी नंबर",
    "gstPercent": "जीएसटी दर (%)",
    "taxableAmt": "कर योग्य राशि",
    "taxableAmtMgmt": "कर योग्य राशि प्रबंधन",
    "gstPlaceholder": "उदा: 22AAAAA0000",
    "gst": "GST"
  },
  "ar": {
    "appName": "Finn ERP",
    "appSubtitle": "نظام تخطيط موارد المؤسسات",
    "menuDashboard": "لوحة القيادة",
    "menuEmployees": "الموظفين",
    "menuSites": "المواقع / الفروع",
    "menuAttendance": "الحضور",
    "menuPayroll": "الرواتب",
    "menuReports": "التقارير",
    "menuKiosk": "وضع الكشك",
    "kioskWelcome": "مرحباً بكم في الكشك الخاص بنا",
    "kioskSub": "يرجى اختيار خدمة البدء",
    "kioskPos": "نقطة بيع للخدمة الذاتية",
    "kioskService": "تتبع الإصلاح",
    "kioskCheckIn": "تسجيل الموظفين",
    "kioskClock": "الوقت الحالي",
    "kioskBack": "العودة للرئيسية",
    "settings": "الإعدادات",
    "search": "بحث...",
    "allEmployees": "جميع الموظفين",
    "manageStaff": "إدارة الموظفين والورديات.",
    "addEmployee": "إضافة موظف",
    "name": "الاسم",
    "role": "الدور",
    "dept": "القسم",
    "salary": "الراتب الأساسي",
    "bonus": "مكافأة",
    "overtime": "إضافي",
    "deductions": "خصومات",
    "total": "الإجمالي",
    "netPay": "صافي الراتب",
    "actions": "إجراءات",
    "login": "تسجيل الدخول",
    "signup": "إنشاء حساب",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "welcome": "مرحباً بعودتك",
    "enterEmail": "أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور",
    "location": "الموقع",
    "shift": "الوردية",
    "totalComp": "إجمالي المستحقات",
    "dailyAttendance": "سجل الحضور اليومي",
    "trackAttendance": "تتبع حضور وانصراف الموظفين والورديات.",
    "checkIn": "تسجيل حضور",
    "checkOut": "تسجيل انصراف",
    "status": "الحالة",
    "import": "استيراد",
    "export": "تصدير",
    "payrollMgmt": "إدارة الرواتب",
    "costAnalysis": "تحليل التكاليف في الوقت الفعلي.",
    "aiInsights": "رؤى الذكاء الاصطناعي",
    "siteStats": "إحصائيات المواقع",
    "assignedGuards": "الموظفين المعينين",
    "deleteLocation": "حذف الموقع",
    "terminateGuard": "إنهاء خدمة / حذف موظف",
    "aiAssistant": "مساعد الذكاء الاصطناعي",
    "genReview": "إنشاء مراجعة أداء",
    "generating": "جاري الإنشاء...",
    "downloadReport": "تحميل التقرير",
    "editLocation": "تعديل الموقع",
    "otp": "رمز التحقق (OTP)",
    "otpSent": "تم إرسال رمز التحقق",
    "otpSentDetail": "تم إرسال رمز التحقق إلى shoaibwwe01@outlook.com. يرجى مراجعة المسؤول.",
    "invalidOtp": "رمز التحقق غير صالح",
    "registeredOnly": "هذه الميزة للمستخدمين المسجلين فقط",
    "guestNotice": "أنت في وضع الضيف. سجل للحصول على كافة الميزات.",
    "menuAccounts": "الحسابات",
    "menuSalesPurchases": "المبيعات",
    "menuWarehouses": "المخازن",
    "menuCafe": "كافيه",
    "menuInvoices": "السجل",
    "weeklySales": "تقرير المبيعات الأسبوعي",
    "weeklyBuy": "تقرير الشراء والمخزون الأسبوعي",
    "walkIn": "عميل محلي",
    "takeaway": "تيك أواي",
    "walkInCustomer": "عميل محلي",
    "takeawayCustomer": "عميل تيك أواي",
    "customerCopy": "نسخة العميل",
    "shopCopy": "نسخة المحل",
    "printSettings": "إعدادات الطباعة",
    "thermal": "حراري (80 مم)",
    "a4": "A4 (عادي)",
    "dualPrint": "طباعة مزدوجة (العميل + المحل)",
    "lastUpdated": "آخر تحديث",
    "stockValueBuy": "قيمة المخزون (شراء)",
    "stockValueSell": "قيمة المخزون (بيع)",
    "itemsSummary": "ملخص العناصر",
    "invoiceId": "رقم الفاتورة",
    "type": "النوع",
    "soldBy": "تم البيع بواسطة",
    "customerId": "رقم العميل",
    "taxed": "خاضع للضريبة",
    "advanceSalary": "سلفة راتب",
    "image": "صورة",
    "salesEmployee": "موظف مبيعات",
    "adminDefault": "مسؤول (افتراضي)",
    "historyLog": "سجل النشاطات",
    "historySubtitle": "سجل شامل للمبيعات ونشاطات المخزن.",
    "allTypes": "جميع الأنواع",
    "sales": "مبيعات",
    "stockUpdates": "تحديثات المخزن",
    "valueStatus": "القيمة / الحالة",
    "noHistory": "لا يوجد سجلات.",
    "sold": "تم البيع",
    "to": "إلى",
    "units": "الوحدات",
    "stockCheck": "فحص المخزون",
    "items": "عناصر",
    "posTerminal": "نقطة بيع",
    "searchProducts": "بحث عن منتجات...",
    "todaysSales": "مبيعات اليوم",
    "salesOn": "المبيعات في",
    "time": "الوقت",
    "amount": "المبلغ",
    "receipt": "إيصال",
    "currentBill": "الفاتورة الحالية",
    "cartEmpty": "السلة فارغة",
    "selectItems": "اختر العناصر من الشبكة للإضافة",
    "subtotal": "المجموع الفرعي",
    "checkout": "إتمام البيع",
    "customerNameOptional": "اسم العميل (اختياري)",
    "hold": "تعليق السلة",
    "resumeWarning": "استئناف السلة سيؤدي لمسح السلة الحالية. هل تريد المتابعة؟",
    "quickStockIn": "توريد سريع للمخزن",
    "currentQuantity": "الكمية الحالية",
    "enterAddedQty": "أدخل الكمية المضافة",
    "payWithUPI": "دفع عبر UPI",
    "assistant": "المساعد",
    "reviewOrder": "مراجعة الطلب",
    "products": "المنتجات",
    "scanner": "الماسح الضوئي",
    "cart": "السلة",
    "digitalPayment": "دفع رقمي",
    "linkExpired": "انتهت صلاحية الرابط",
    "linkExpiredDetail": "كان رابط الدفع هذا صالحاً لمدة 10 دقائق فقط. يرجى طلب رمز QR جديد من التاجر.",
    "payNow": "ادفع الآن",
    "secureUpi": "دفع UPI آمن",
    "securePayment": "دفع رقمي آمن",
    "totalLabel": "الإجمالي",
    "goBackToApp": "العودة للتطبيق",
    "inventorySubtitle": "مستويات المخزون وحركات المخزون",
    "addCustomer": "إضافة عميل",
    "newTicket": "تذكرة جديدة",
    "serviceModule": "قسم الصيانة",
    "devicePhotos": "صور الجهاز",
    "searchInventory": "بحث في المخزن بالاسم...",
    "itemName": "إسم العنصر",
    "buyPrice": "سعر الشراء",
    "sellPrice": "سعر البيع",
    "barcode": "باركود",
    "scanBarcode": "مسح الباركود",
    "paymentMethodNotConfigured": "لم يتم تكوين طريقة الدفع في الإعدادات",
    "digitalPayment_QR": "دفع رقمي (QR)",
    "upiId": "معرف UPI",
    "instapayId": "معرف InstaPay",
    "payWithInstapay": "دفع عبر InstaPay",
    "confirmCheckout": "تأكيد إتمام البيع",
    "totalWithDiscount": "الإجمالي بعد الخصم",
    "quantity": "الكمية",
    "refinement": "تصفية",
    "noInventory": "لم يتم العثور على أصناف في المخزن",
    "hideCosts": "إخفاء التكاليف",
    "showCosts": "إظهار التكاليف",
    "securityCheck": "فحص أمني",
    "addItem": "إضافة صنف",
    "edit": "تعديل",
    "itemNotFound": "المنتج غير موجود في المخزن. يرجى التأكد أو إضافته.",
    "generate": "إنشاء",
    "print": "طباعة",
    "printAll": "طباعة جميع الباركودات",
    "shopSettings": "إعدادات المحل",
    "shopName": "اسم المحل",
    "shopAddress": "عنوان المحل",
    "shopPhone": "هاتف المحل",
    "updateSettings": "تحديث الإعدادات",
    "securityPin": "الرمز السري للأمان",
    "language": "اللغة",
    "close": "إغلاق",
    "retailInvoice": "فاتورة ضريبية مبسطة",
    "invoice": "فاتورة",
    "date": "التاريخ",
    "billNo": "ID",
    "paymentMode": "طريقة الدفع",
    "cash": "نقداً",
    "item": "الصنف",
    "qty": "الكمية",
    "amt": "المبلغ",
    "price": "السعر",
    "taxVAT": "الضريبة",
    "taxRate": "نسبة الضريبة",
    "makeChecksPayable": "اجعل جميع الشيكات مستحقة لـ",
    "thankYou": "شكراً لتعاملكم معنا!",
    "billTo": "فاتورة إلى",
    "description": "الوصف",
    "unitPrice": "سعر الوحدة",
    "lineTotal": "المجموع",
    "comments": "تعليقات",
    "termsConditions": "الشروط والأحكام",
    "paymentTerms": "1. إجمالي الدفعة مستحق خلال 30 يوماً",
    "includeInvoiceNumber": "2. يرجى إدراج رقم الفاتورة في الشيك الخاص بك",
    "phone": "الهاتف",
    "customer": "العميل",
    "contactQuestions": "إذا كانت لديك أي أسئلة حول هذه الفاتورة، يرجى التواصل معنا",
    "details": "معلومات الموظف",
    "manageDetails": "إدارة الاختيار",
    "siteName": "اسم الموقع",
    "city": "المدينة / المنطقة",
    "manager": "المدير",
    "operationalStatus": "حالة التشغيل",
    "photoUrl": "صورة الموظف",
    "uploadPhoto": "رفع صورة",
    "unassigned": "غير معين",
    "securityTeam": "الفريق",
    "guards": "الموظفين",
    "addLocation": "إضافة موقع جديد",
    "createLocation": "إنشاء موقع",
    "cancel": "إلغاء",
    "filterAll": "جميع المواقع",
    "morningShift": "صباحي (9 صباحاً - 5 مساءً)",
    "nightShift": "مسائي (5 مساءً - 1 صباحاً)",
    "operational": "يعمل",
    "renovating": "تحت التجديد",
    "active": "نشط",
    "closed": "مغلق",
    "onTime": "في الوقت",
    "late": "متأخر",
    "absent": "غائب",
    "design": "تصميم",
    "engineering": "هندسة",
    "hr": "الموارد البشرية",
    "marketing": "تسويق",
    "operations": "عمليات",
    "security": "أمن",
    "it": "تقنية معلومات",
    "headquarters": "المقر الرئيسي",
    "kitchen": "مطبخ",
    "service": "خدمة",
    "bar": "بار",
    "retail": "تجزئة",
    "warehouse": "مخزن",
    "cafe": "كافيه",
    "inventory": "مخزون",
    "accounts": "حسابات",
    "management": "إدارة",
    "cleaning": "تنظيف",
    "maintenance": "صيانة",
    "morning12": "صباحي (12 ساعة)",
    "night12": "مسائي (12 ساعة)",
    "importSuccess": "تم استيراد {0} سجلات بنجاح.",
    "importError": "خطأ في الاستيراد: ",
    "payrollUpdateSuccess": "تم تحديث الرواتب لـ {0} موظفين بنجاح.",
    "payrollUpdateError": "خطأ في تحديث الرواتب: ",
    "myProfile": "ملفي الشخصي",
    "emailLabel": "البريد الإلكتروني:",
    "userIdLabel": "رقم المستخدم:",
    "accountTypeLabel": "نوع الحساب:",
    "admin": "مسؤول",
    "shopSettingsSaved": "تم حفظ إعدادات المحل في السحابة",
    "shopSettingsError": "خطأ في حفظ الإعدادات",
    "localization": "التعريب",
    "currency": "العملة",
    "departmentSettings": "إعدادات الأقسام",
    "departments": "الأقسام",
    "manageDepartments": "إضافة أو حذف الأقسام",
    "addDepartment": "إضافة قسم",
    "backupRestore": "النسخ الاحتياطي والاستعادة",
    "exportBackup": "تصدير نسخة احتياطية",
    "importBackup": "استيراد نسخة احتياطية",
    "backupDescription": "تصدير بياناتك كملف JSON أو استعادتها من نسخة سابقة.",
    "dangerZone": "منطقة خطر",
    "irreversibleAction": "إجراء غير قابل للتراجع. سيتم حذف جميع البيانات.",
    "factoryReset": "إعادة ضبط المصنع للنظام",
    "compensation": "تعويضات",
    "advance": "سلفة",
    "delete": "حذف",
    "terminateService": "إنهاء الخدمة",
    "addAttendance": "إضافة حضور",
    "editAttendance": "تعديل حضور",
    "deleteAttendance": "حذف حضور",
    "selectEmployee": "اختر الموظف",
    "selectDate": "اختر التاريخ",
    "selectStatus": "اختر الحالة",
    "save": "حفظ",
    "replacementFor": "بديل لـ",
    "coveringFor": "تغطية لـ",
    "lateDeductions": "خصم تأخير",
    "absentDeductions": "خصم غياب",
    "manualDeduction": "خصم يدوي",
    "cost": "تكلفة",
    "none": "لا يوجد",
    "dashboardTotal": "الإجمالي",
    "activeGuards": "الموظفين النشطين",
    "operationalSites": "المواقع القائمة",
    "checkedInToday": "المسجلين اليوم",
    "issuesToday": "مشاكل اليوم",
    "quickActions": "إجراءات سريعة",
    "addStaff": "إضافة موظف",
    "addSite": "إضافة موقع",
    "systemStatus": "حالة النظام",
    "systemOperational": "جميع الأنظمة تعمل بشكل طبيعي. تم مزامنة قاعدة البيانات.",
    "online": "متصل",
    "attendanceReport": "تقرير الحضور",
    "payrollReport": "تقرير الرواتب",
    "staffReport": "تقرير الموظفين",
    "taxReport": "تقرير الضرائب",
    "today": "اليوم",
    "lateAbsent": "متأخر/غائب",
    "lateHours": "ساعات التأخير",
    "attendanceExists": "سجل الحضور موجود بالفعل لهذا الموظف في هذا التاريخ.",
    "theme": "المظهر",
    "light": "فاتح",
    "dark": "داكن",
    "payrollSlip": "قسيمة الراتب",
    "payrollFor": "راتب شهر",
    "employeeName": "اسم الموظف",
    "employeeId": "رقم الموظف",
    "payPeriod": "فترة الراتب",
    "basicSalary": "الراتب الأساسي",
    "grossPay": "إجمالي الراتب",
    "totalDeductions": "إجمالي الخصومات",
    "otherDeductions": "خصومات أخرى",
    "employeeSignature": "توقيع الموظف",
    "authorizedSignature": "التوقيع المعتمد",
    "computerGenerated": "هذه القسيمة تم إنشاؤها آلياً ولا تتطلب توقيعاً.",
    "generatedOn": "تم الإنشاء في",
    "at": "في",
    "companyName": "اسم الشركة",
    "companyAddress": "عنوان الشركة",
    "selectLocation": "اختر الموقع",
    "noLocations": "لا توجد مواقع متوفرة - يرجى إنشاء موقع أولاً",
    "authError": "خطأ في المصادقة: ",
    "googleSignInError": "خطأ في تسجيل الدخول عبر جوجل: ",
    "factoryResetWarning": "تحذير هام: سيتم حذف جميع البيانات نهائياً. هل أنت متأكد؟",
    "pinPrompt": "أدخل الرمز السري للمتابعة:",
    "incorrectPin": "الرمز السري غير صحيح.",
    "factoryResetPinPrompt": "أدخل الرمز السري لتأكيد إعادة ضبط المصنع:",
    "factoryResetIncorrectPin": "الرمز السري غير صحيح. تم إلغاء العملية.",
    "switchModePrompt": "أدخل الرمز السري للتبديل:",
    "changeUserPrompt": "أدخل الرمز السري لتغيير المستخدم:",
    "resetComplete": "اكتملت إعادة ضبط المصنع. تم مسح كافة البيانات.",
    "resetFailed": "فشلت الإعادة لـ: ",
    "backupExported": "تم تصدير النسخة الاحتياطية بنجاح!",
    "exportFailed": "فشل التصدير: ",
    "backupImported": "تم استيراد النسخة الاحتياطية! جاري إعادة التحميل...",
    "importFailed": "فشل الاستيراد: ",
    "overwriteWarning": "تحذير: سيتم استبدال جميع البيانات الحالية. هل تريد المتابعة؟",
    "guestLogin": "دخول ضيف",
    "forgotPassword": "نسيت كلمة المرور؟",
    "resetPassword": "إعادة تعيين كلمة المرور",
    "sendResetLink": "إرسال رابط التعيين",
    "backToLogin": "العودة لتسجيل الدخول",
    "passwordResetSent": "تم إرسال بريد إعادة تعيين كلمة المرور!",
    "noAccount": "ليس لديك حساب؟",
    "signInToAccess": "سجل الدخول للوصول إلى لوحة التحكم",
    "createAccount": "إنشاء حساب",
    "haveAccount": "لديك حساب بالفعل؟",
    "logout": "تسجيل خروج",
    "welcomeBack": "مرحباً بعودتك",
    "orContinue": "أو المتابعة عبر",
    "signInGoogle": "تسجيل الدخول عبر جوجل",
    "linkSuccess": "تم ربط حساب جوجل بنجاح!",
    "linkError": "خطأ في الربط: ",
    "accountLinked": "حساب جوجل هذا مفعل بالفعل. يرجى تسجيل الخروج واستخدامه مباشرة.",
    "employeeSaved": "تم حفظ الموظف بنجاح!",
    "saveError": "خطأ في الحفظ: ",
    "deleteConfirm": "هل أنت متأكد؟",
    "updateError": "خطأ في التحديث: ",
    "addPurchaseError": "خطأ في إضافة مشتريات: ",
    "genInvoiceError": "خطأ في إصدار الفاتورة: ",
    "addItemError": "خطأ في إضافة صنف: ",
    "deleteLocationWarning": "لا يمكن الحذف. هناك موظفون معينون.",
    "deleteLocationConfirm": "حذف هذا الموقع؟",
    "errorNoUser": "خطأ: لم يتم تسجيل الدخول.",
    "totalIncome": "إجمالي الدخل",
    "visa": "فيزا",
    "onlinePayment": "أونلاين",
    "forgotPin": "نسيت الرمز السري؟",
    "securityQuestion": "سؤال الأمان",
    "securityAnswer": "إجابة الأمان",
    "enterSecurityAnswer": "أدخل إجابة سؤال الأمان",
    "pinResetSuccess": "تم إعادة تعيين الرمز السري بنجاح! الرمز الجديد هو 1234.",
    "incorrectAnswer": "إجابة خاطئة.",
    "setSecurityQuestion": "ضبط سؤال الأمان",
    "changePin": "تغيير الرمز السري",
    "newPin": "الرمز السري الجديد",
    "confirmChangePin": "تأكيد تغيير الرقم السري",
    "saveSettings": "حفظ الإعدادات",
    "currentPin": "الرمز السري الحالي",
    "enterNewPin": "أدخل الرمز السري الجديد",
    "pinChanged": "تم تحديث الرمز السري بنجاح!",
    "pinSetMessage": "الرمز السري مفعل. استخدم \"نسيت الرمز\" لإعادة التعيين.",
    "secQ_pet": "ما اسم أول حيوان أليف لك؟",
    "secQ_mother": "ما هو اسم الأم قبل الزواج؟",
    "secQ_city": "في أي مدينة ولدت؟",
    "secQ_school": "ما هو اسم أول مدرسة التحقت بها؟",
    "daily": "يومياً",
    "weekly": "أسبوعياً",
    "monthly": "شهرياً",
    "yearly": "سنوياً",
    "profitLossReport": "تقرير الأرباح والخسائر",
    "monthlyPl": "الأرباح والخسائر الشهرية",
    "plSubtitle": "تحليل الإيرادات مقابل التكاليف مقابل المصروفات",
    "revenue": "الإيرادات",
    "totalSales": "إجمالي المبيعات",
    "discount": "خصم",
    "cogs": "تكلفة البضاعة المباعة",
    "cogsFull": "تكلفة البضاعة المباعة",
    "grossProfit": "إجمالي الربح",
    "expenses": "المصروفات",
    "purchasesOther": "مشتريات/أخرى",
    "netProfit": "صافي الربح",
    "netLoss": "صافي الخسارة",
    "incomeStatement": "قائمة الدخل",
    "salesCash": "مبيعات - نقدي",
    "salesVisa": "مبيعات - فيزا",
    "salesOnline": "مبيعات - أونلاين",
    "totalRevenue": "إجمالي الإيرادات",
    "costOfGoodsSold": "تكلفة البضاعة المباعة",
    "grossMargin": "هامش الربح",
    "operatingExpenses": "المصروفات التشغيلية",
    "totalExpenses": "إجمالي المصروفات",
    "netMargin": "صافي الهامش",
    "deptExpenses": "مصروفات الأقسام",
    "invPurchases": "مشتريات المخزون",
    "selectEmployeeAlert": "يرجى اختيار موظف مبيعات!",
    "accountHandling": "إدارة الحسابات",
    "connectGoogle": "ربط حساب جوجل",
    "linkGoogleDesc": "اربط حساب جوجل الخاص بك لتسجيل الدخول به بدلاً من كلمة المرور.",
    "soldItemsDetail": "تفاصيل المواد المباعة",
    "boughtItemsDetail": "تفاصيل المواد المشتراة (المشتريات والمصروفات)",
    "unknown": "غير معروف",
    "totals": "الإجماليات",
    "unitCost": "تكلفة الوحدة",
    "period": "الفترة",
    "na": "غير متوفر",
    "totalCost": "إجمالي التكلفة",
    "profit": "الربح",
    "liveBoard": "لوحة التحكم الحية",
    "manageUnits": "الغرف والطاولات",
    "menuRecipes": "المنيو والوصفات",
    "activeSessions": "الجلسات النشطة",
    "unitsMonitoring": "مراقبة حية لـ {0} وحدات",
    "inSession": "في جلسة",
    "available": "متاح",
    "startSession": "بدء جلسة",
    "addOrder": "إضافة طلب",
    "stop": "إيقاف",
    "recipeBuilder": "بناء الوصفات",
    "manageUnitsTitle": "إدارة الوحدات",
    "roomName": "اسم الغرفة",
    "unitType": "نوع الوحدة",
    "hourlyRate": "سعر الساعة",
    "saveUnit": "حفظ الوحدة",
    "cafeTable": "طاولة كافيه",
    "playStationRoom": "غرفة بلايستيشن",
    "billiardsTable": "طاولة بلياردو",
    "category": "الفئة",
    "offerPrice": "السعر",
    "composition": "المكونات",
    "linkStock": "+ ربط بمخزون المستودع",
    "hotDrinks": "مشروبات ساخنة",
    "coldDrinks": "مشروبات باردة",
    "snacks": "سناكس",
    "meals": "وجبات",
    "updateItem": "تحديث الصنف",
    "addToMenu": "إضافة للمنيو",
    "appendSession": "إضافة أصناف للجلسة",
    "orderHistory": "سجل الطلبات",
    "newSelection": "اختيار جديد",
    "trayEmpty": "الصينية فارغة",
    "trayTotal": "إجمالي الصينية",
    "confirmOrder": "تأكيد الطلب",
    "menuItemsMissingTitle": "أصناف المنيو مفقودة",
    "all": "الكل",
    "customerPhone": "هاتف العميل *",
    "customerName": "اسم العميل",
    "sessionType": "نوع الجلسة",
    "openSession": "مفتوحة (بدون حد)",
    "fixedDuration": "مدة محددة",
    "startSessionTitle": "بدء الجلسة",
    "managePayroll": "إدارة الرواتب",
    "advanceTaken": "سلفة مأخوذة",
    "manualDeductions": "خصومات يدوي",
    "lateAbsentAuto": "تأخير/غياب (تلقائي)",
    "grossEarnings": "إجمالي المستحقات",
    "netPayable": "صافي المستحق",
    "reset": "إعادة ضبط",
    "saveRecord": "حفظ السجل",
    "hourlyRateLabel": "سعر الساعة",
    "sessionTypeLabel": "نوع الجلسة",
    "phonePlaceholder": "مثال: 050 123 4567",
    "guestName": "اسم الضيف",
    "subtotalLabel": "المجموع الفرعي",
    "retryCamera": "إعادة محاولة الكاميرا",
    "scanFocusInfo": "استخدم إصبعين أو شريط التمرير للتركيز.",
    "tapToFocus": "اضغط على الشاشة للتركيز القسري.",
    "centerCodeFrame": "ضع الكود داخل الإطار الأزرق",
    "holdAwayTap": "أمسك الجهاز على بعد 20 سم واضغط للتوضيح",
    "selectMonthInfo": "اختر الشهر لعرض تفاصيل الراتب",
    "manageEditMonth": "إدارة/تعديل لهذا الشهر",
    "viewManageLocations": "عرض وإدارة جميع مواقعك الفعلية",
    "addAccount": "إضافة حساب",
    "accountName": "اسم الحساب",
    "initialBalance": "الرصيد الافتتاحي",
    "editItem": "تعديل الصنف",
    "addInventoryItem": "إضافة صنف للمخزن",
    "printBarcodeLabel": "طباعة ملصق الباركود",
    "newSale": "بيع جديد",
    "totalAmount": "المبلغ الإجمالي",
    "completed": "مكتمل",
    "shipped": "تم الشحن",
    "itemsSummaryLabel": "الأصناف (ملخص)",
    "connectionError": "خطأ في الاتصال:",
    "dismiss": "تجاهل",
    "adminUser": "مستخدم مسؤول",
    "optional": "اختياري",
    "onTimeLabel": "في الوقت",
    "lateLabel": "متأخر",
    "absentLabel": "غائب",
    "pendingLabel": "قيد الانتظار",
    "createSale": "إنشاء بيع",
    "newPurchase": "شراء جديد",
    "supplierName": "اسم المورد",
    "tax": "ضريبة",
    "manageLocations": "إدارة مراقبة جميع المواقع والفروع.",
    "siteEmployees": "موظفي الموقع",
    "accountsSubtitle": "تتبع الأصول والالتزامات والمصروفات.",
    "mixedLocationError": "لا يمكن خلط أصناف من مواقع مختلفة! يرجى مسح السلة أولاً.",
    "department": "قسم",
    "missing": "مفقود",
    "taxEstimation": "خصومات ضريبية تقديرية",
    "noAccounts": "لم يتم العثور على حسابات. أضف واحداً للبدء.",
    "outOfStock": "نفدت الكمية",
    "printWizard": "معالج طباعة الباركود",
    "totalLabels": "إجمالي الملصقات",
    "layoutMode": "وضع التخطيط",
    "orderNumber": "رقم الطلب",
    "partsUsed": "قطع الغيار المستخدمة",
    "createInvoice": "إنشاء فاتورة",
    "serviceInvoice": "فاتورة صيانة",
    "printNow": "اطبع الآن",
    "dailySales": "المبيعات اليومية",
    "cafeHistory": "سجل الكافيه",
    "searchByDate": "البحث بالتاريخ",
    "printSelected": "طباعة المحدد",
    "previousBills": "الفواتير السابقة",
    "confirmDelete": "هل أنت متأكد أنك تريد الحذف؟",
    "deleteError": "خطأ في حذف العنصر",
    "history": "السجل",
    "itemExists": "العنصر موجود بالفعل",
    "update": "تحديث",
    "upi": "UPI",
    "pay": "دفع",
    "Saved": "تم الحفظ!",
    "Report": "تقرير",
    "Reset to defaults": "إعادة التعيين إلى الافتراضيات",
    "id": "المعرف",
    "instaPay": "InstaPay",
    "method": "طريقة",
    "exp": "مصاريف",
    "a": "أ",
    "T": "ت",
    "pn": "رقم الهاتف",
    "No items with barcodes to print.": "لا توجد أصناف بها باركود للطباعة.",
    "Please allow popups to print payroll slip": "يرجى السماح بالنوافذ المنبثقة لطباعة قسيمة الراتب",
    "Please select a question and answer!": "يرجى اختيار سؤال وإجابة!",
    "printPayrollSlip": "طباعة قسيمة الراتب",
    "profit_loss": "الربح والخسارة",
    "now": "الآن",
    "h": "س",
    "m": "د",
    "PlayStation": "بلاي ستيشن",
    "Billiards": "بلياردو",
    "Cafe": "كافيه",
    "sticker": "ملصق",
    "a4 sheet": "ورقة A4",
    "noBarcode": "لا يوجد باركود",
    "menuService": "الصيانة والإصلاح",
    "activeJobs": "المهام النشطة",
    "serviceHistory": "سجل الصيانة",
    "customerInfo": "بيانات العميل",
    "deviceDetails": "تفاصيل الجهاز",
    "issueDescription": "وصف المشكلة",
    "describeIssue": "صف المشكلة هنا...",
    "estimatedCost": "التكلفة التقديرية",
    "technician": "الفني",
    "priority": "الأولوية",
    "createTicket": "إنشاء تذكرة",
    "searchTickets": "بحث في التذاكر...",
    "noActiveJobs": "لا توجد مهام صيانة نشطة",
    "editTicket": "تعديل تذكرة الصيانة",
    "saveChanges": "حفظ التغييرات",
    "received": "تم الاستلام",
    "inProgress": "قيد العمل",
    "waitingParts": "في انتظار قطع الغيار",
    "readyPickup": "جاهز للاستلام",
    "delivered": "تم التسليم",
    "lowStockAlerts": "تنبيهات انخفاض المخزون",
    "pendingRepairs": "إصلاحات معلقة",
    "completedRepairs": "إصلاحات مكتملة",
    "servicePerformance": "أداء الخدمة",
    "topRepairs": "أنواع الإصلاح الأكثر طلبًا",
    "technicianRevenue": "إيرادات الفنيين",
    "monthlyServiceRevenue": "الإيرادات الشهرية للخدمة",
    "sparePartsUsage": "استخدام قطع الغيار",
    "pendingPayments": "مدفوعات معلقة",
    "addStock": "إضافة مخزون",
    "attachPhotos": "صور الجهاز",
    "add": "إضافة",
    "recentActivity": "النشاط الأخير",
    "customerProfile": "ملف العميل",
    "deviceInfo": "معلومات الجهاز",
    "repairHistory": "سجل الإصلاحات",
    "diagnostics": "التشخيص",
    "paymentStatus": "حالة الدفع",
    "paid": "مدفوع",
    "unpaid": "غير مدفوع",
    "partial": "مدفوع جزئياً",
    "spareParts": "قطع الغيار",
    "lowStock": "مخزون منخفض",
    "phoneParts": "قطع غيار موبايل",
    "pcComponents": "مكونات كمبيوتر",
    "accessories": "إكسسوارات",
    "urgent": "عاجل",
    "high": "عالي",
    "normal": "عادي",
    "low": "منخفض",
    "createNewRepairTicket": "إنشاء تذكرة صيانة جديدة",
    "todaysRevenue": "إيرادات اليوم",
    "address": "العنوان",
    "assignedTechnician": "الفني المعين",
    "brand": "العلامة التجارية",
    "collected": "تم تحصيله",
    "console": "منصة ألعاب",
    "creditCard": "بطاقة ائتمان",
    "dashboard": "لوحة القيادة",
    "device": "الجهاز",
    "editCustomer": "تعديل العميل",
    "internalNotes": "ملاحظات داخلية",
    "minStock": "الحد الأدنى للمخزون",
    "mobile": "موبايل",
    "model": "الموديل",
    "other": "أخرى",
    "page": "صفحة",
    "paymentMethod": "طريقة الدفع",
    "pc": "كمبيوتر",
    "serialNo": "الرقم التسلسلي",
    "tablet": "تابلت",
    "totalNetPay": "إجمالي صافي الراتب",
    "totalRecords": "إجمالي السجلات",
    "customers": "العملاء",
    "allowPopups": "يرجى السماح بالنوافذ المنبثقة لطباعة الإيصال.",
    "morning8": "صباحي (8 ساعات)",
    "night8": "مسائي (8 ساعات)",
    "finance": "المالية",
    "ownerMode": "وضع المالك",
    "managerMode": "وضع المدير",
    "cashierMode": "وضع الكاشير",
    "otherPayment": "دفع آخر",
    "repairs": "تصليحات",
    "insufficientIngredient": "مخزون غير كافٍ للمكون",
    "insufficientStock": "مخزون غير كافٍ لـ",
    "maxStockReached": "تم الوصول للحد الأقصى للمخزون:",
    "customItem": "صنف مخصص",
    "enterItemName": "أدخل اسم الصنف:",
    "enterItemPrice": "أدخل سعر الصنف:",
    "inventoryParts": "قطع غيار المخزون",
    "useExternalTerminal": "استخدام ماكينة دفع خارجية",
    "billToPOS": "إرسال الفاتورة لـ POS",
    "permissionDeniedOwner": "تم رفض الوصول: يتطلب رمز المالك.",
    "ownerOnlyPins": "المالك فقط يمكنه إدارة الرموز السرية",
    "instapay": "انستا باي",
    "repairLabor": "عمل صيانة",
    "autoHide": "إخفاء تلقائي",
    "sell": "بيع",
    "servicePOS": "نقطة بيع الخدمة",
    "serviceCenter": "مركز الخدمة",
    "repairManagement": "إدارة الإصلاحات",
    "activeRepairs": "إصلاحات نشطة",
    "noRecentActivity": "لا يوجد نشاط أخير",
    "seconds": "ثانية",
    "shopLogo": "شعار المتجر",
    "uploadLogo": "رفع الشعار",
    "changeLogo": "تغيير الشعار",
    "removeLogo": "حذف الشعار",
    "kioskCheckInSuccess": "تم تسجيل الحضور بنجاح!",
    "kioskCheckOutSuccess": "تم تسجيل الانصراف بنجاح!",
    "allTransactions": "كل المعاملات",
    "searchHistory": "البحث في السجل...",
    "reviewPastSales": "مراجعة المبيعات والإصلاحات السابقة",
    "payment": "الدفع",
    "reprint": "إعادة طباعة",
    "repair": "صيانة",
    "noHistoryInPeriod": "لم يتم العثور على سجلات لهذه الفترة",
    "siteLogo": "شعار الموقع",
    "systemLogo": "شعار النظام",
    "uploadSiteLogo": "رفع شعار الموقع",
    "changeSiteLogo": "تغيير شعار الموقع",
    "removeSiteLogo": "حذف شعار الموقع",
    "manual": "يدوي",
    "partsTotal": "إجمالي القطع",
    "noPartsUsed": "لا توجد قطع مستخدمة بعد",
    "searchRepairsAndStock": "البحث في الإصلاحات أو المخزون...",
    "terminal": "ماكينة دفع",
    "jobs": "مهام",
    "sparePart": "قطعة غيار",
    "todaysServices": "خدمات اليوم",
    "servicesOn": "الخدمات في",
    "scan": "مسح",
    "viewCart": "عرض السلة",
    "customerInformation": "بيانات العميل",
    "ticketId": "رقم التذكرة",
    "inventoryManagement": "إدارة المخزن",
    "pinManagement": "إدارة الرموز السرية",
    "cashierPin": "رمز الكاشير",
    "managerPin": "رمز المدير",
    "ownerPin": "رمز المالك",
    "saleCompleted": "تمت عملية البيع بنجاح!",
    "repairAlreadyInCart": "الإصلاح مدرج بالفعل في السلة!",
    "deleteViaActiveJobs": "الحذف من خلال مهام الصيانة النشطة",
    "photoUploadFailed": "فشل رفع الصورة. يرجى التأكد من الاتصال.",
    "logoSizeError": "يجب أن يكون حجم الشعار أقل من 2 ميجا بايت",
    "adminPinRequired": "تم رفض الوصول: يتطلب رمز المدير.",
    "managerPinRestricted": "صلاحيات المدير مقيدة.",
    "ownerPinRestricted": "صلاحيات المالك مقيدة.",
    "totalQty": "إجمالي الكمية",
    "exitKioskPrompt": "انقر مرتين للخروج من وضع الكشك",
    "borrow": "استعارة",
    "borrowDate": "تاريخ الاستعارة",
    "borrowTime": "الوقت",
    "dateBorrowed": "تم الاستعارة في",
    "dateReturned": "تم الإرجاع في",
    "returned": "تم الإرجاع",
    "borrowed": "مستعار",
    "borrowItems": "الأصناف المستعارة",
    "noBorrowRecords": "لا توجد سجلات استعارة",
    "borrower": "المستعير",
    "markAsBorrowed": "تحديد كمستعار",
    "markAsReturned": "تحديد كمرجع",
    "borrowerName": "إسم المستعير",
    "addBorrowRecord": "إضافة سجل إستعارة",
    "addRecord": "إضافة سجل",
    "additionalInfo": "معلومات إضافية",
    "enableGst": "تمكين ضريبة السلع",
    "gstNumber": "رقم الضريبة (GST)",
    "gstPercent": "نسبة الضريبة (GST) %",
    "taxableAmt": "المبلغ الخاضع للضريبة",
    "taxableAmtMgmt": "إدارة المبالغ الضريبية",
    "gstPlaceholder": "مثال: 22AAAAA0000",
    "gst": "ضريبة السلع"
  },
  "zh": {
    "appName": "Finn ERP",
    "appSubtitle": "企业资源规划",
    "menuDashboard": "仪表板",
    "menuEmployees": "员工",
    "menuSites": "地点/站点",
    "menuAttendance": "考勤",
    "menuPayroll": "工资单",
    "menuReports": "报表",
    "menuKiosk": "自助机模式",
    "kioskWelcome": "欢迎使用自助服务",
    "kioskSub": "请选择一项服务",
    "kioskPos": "自助收银台",
    "kioskService": "维修跟踪",
    "kioskCheckIn": "员工打卡",
    "kioskClock": "当前时间",
    "kioskBack": "返回主页",
    "settings": "设置",
    "search": "搜索...",
    "allEmployees": "所有员工",
    "manageStaff": "管理员工和班次。",
    "addEmployee": "添加员工",
    "name": "姓名",
    "role": "角色",
    "dept": "部门",
    "salary": "基本工资",
    "bonus": "奖金",
    "overtime": "加班",
    "deductions": "扣除",
    "total": "总计",
    "netPay": "净工资",
    "actions": "操作",
    "login": "登录",
    "signup": "注册",
    "email": "电子邮件",
    "password": "密码",
    "welcome": "欢迎回来",
    "signInToAccess": "登录以访问仪表板",
    "createAccount": "创建帐户",
    "haveAccount": "已有帐户？",
    "noAccount": "没有帐户？",
    "logout": "登出",
    "location": "地点",
    "shift": "班次",
    "totalComp": "总薪酬",
    "dailyAttendance": "每日出勤日志",
    "trackAttendance": "跟踪员工签到和班次。",
    "checkIn": "签到",
    "checkOut": "签退",
    "status": "状态",
    "import": "导入",
    "export": "导出",
    "payrollMgmt": "工资管理",
    "costAnalysis": "实时成本分析。",
    "aiInsights": "AI 洞察",
    "siteStats": "站点统计",
    "assignedGuards": "指派员工",
    "deleteLocation": "删除地点",
    "terminateGuard": "解雇/删除员工",
    "aiAssistant": "AI 助手",
    "genReview": "生成绩效评估",
    "generating": "生成中...",
    "downloadReport": "下载报表",
    "editLocation": "编辑地点",
    "otp": "验证码 (OTP)",
    "otpSent": "验证码已发送至管理员",
    "otpSentDetail": "验证码已发送至 shoaibwwe01@outlook.com。请向管理员索取代码。",
    "invalidOtp": "验证码无效",
    "registeredOnly": "仅限注册用户使用",
    "guestNotice": "您当前处于访客模式。请注册以使用所有在线功能。",
    "menuAccounts": "账户",
    "menuSalesPurchases": "销售",
    "menuWarehouses": "仓库",
    "menuCafe": "咖啡厅",
    "menuInvoices": "历史",
    "weeklySales": "周销售报表",
    "weeklyBuy": "周采购/库存报表",
    "walkIn": "散客",
    "takeaway": "外带",
    "walkInCustomer": "散客",
    "takeawayCustomer": "外带客户",
    "customerCopy": "客户副本",
    "shopCopy": "店铺副本",
    "printSettings": "打印设置",
    "thermal": "热敏 (80mm)",
    "a4": "A4 (标准)",
    "dualPrint": "双重打印 (客户 + 店铺)",
    "lastUpdated": "最后更新",
    "stockValueBuy": "库存价值 (采购)",
    "stockValueSell": "库存价值 (销售)",
    "itemsSummary": "项目摘要",
    "invoiceId": "发票 ID",
    "type": "类型",
    "soldBy": "销售员",
    "customerId": "客户 ID",
    "taxed": "含税",
    "advanceSalary": "预支工资",
    "image": "图像",
    "devicePhotos": "设备照片",
    "salesEmployee": "销售员工",
    "adminDefault": "管理员 (默认)",
    "historyLog": "历史日志",
    "historySubtitle": "销售和仓库活动的全面日志。",
    "allTypes": "所有类型",
    "sales": "销售",
    "stockUpdates": "库存更新",
    "valueStatus": "价值/状态",
    "noHistory": "未找到历史记录。",
    "sold": "已售",
    "to": "至",
    "units": "单位",
    "stockCheck": "库存检查",
    "items": "项目",
    "posTerminal": "POS 终端",
    "searchProducts": "搜索产品...",
    "todaysSales": "今日销售",
    "salesOn": "销售于",
    "time": "时间",
    "amount": "金额",
    "receipt": "收据",
    "currentBill": "当前账单",
    "cartEmpty": "购物车为空",
    "selectItems": "从网格中选择项目进行添加",
    "subtotal": "小计",
    "checkout": "结账",
    "customerNameOptional": "客户姓名 (可选)",
    "hold": "挂单",
    "resumeWarning": "恢复将覆盖当前购物车。是否继续？",
    "quickStockIn": "快速入库",
    "currentQuantity": "当前数量",
    "enterAddedQty": "输入增加的数量进行添加",
    "payWithUPI": "使用 UPI 支付",
    "assistant": "助手",
    "reviewOrder": "订单审查",
    "products": "产品",
    "scanner": "扫描仪",
    "cart": "购物车",
    "digitalPayment": "数字支付",
    "linkExpired": "链接已过期",
    "linkExpiredDetail": "此支付链接有效期仅为 10 分钟。请向商家索取新的二维码。",
    "payNow": "立即支付",
    "secureUpi": "安全 UPI 支付",
    "securePayment": "安全数字支付",
    "totalLabel": "总计",
    "goBackToApp": "返回应用",
    "inventorySubtitle": "库存水平和库存变动",
    "searchInventory": "按名称搜索库存...",
    "itemName": "物品",
    "buyPrice": "采购价",
    "sellPrice": "零售价",
    "barcode": "条形码",
    "scanBarcode": "扫描条形码",
    "paymentMethodNotConfigured": "设置中未配置支付方式",
    "digitalPayment_QR": "数字支付 (QR)",
    "upiId": "UPI ID",
    "instapayId": "InstaPay ID",
    "payWithInstapay": "定期支付",
    "confirmCheckout": "确认结账",
    "totalWithDiscount": "折后总计",
    "quantity": "数量",
    "refinement": "精炼",
    "noInventory": "未找到库存项目",
    "hideCosts": "隐藏成本",
    "showCosts": "显示成本",
    "securityCheck": "安全检查",
    "addItem": "添加项目",
    "edit": "编辑",
    "itemNotFound": "库存中未找到该产品。请检查或添加。",
    "generate": "生成",
    "print": "打印",
    "printAll": "打印所有条形码",
    "shopSettings": "店铺设置",
    "shopName": "店铺名称",
    "shopAddress": "店铺地址",
    "shopPhone": "店铺电话",
    "updateSettings": "更新设置",
    "securityPin": "安全密码",
    "language": "语言",
    "close": "关闭",
    "retailInvoice": "零售发票",
    "invoice": "发票",
    "date": "日期",
    "billNo": "ID",
    "paymentMode": "支付方式",
    "cash": "现金",
    "item": "项目",
    "qty": "数量",
    "amt": "金额",
    "price": "单价",
    "taxVAT": "税费/增值税",
    "taxRate": "税率",
    "makeChecksPayable": "支票抬头请写",
    "thankYou": "感谢您的惠顾！",
    "billTo": "账单寄至",
    "description": "描述",
    "unitPrice": "单价",
    "lineTotal": "行合计",
    "comments": "备注",
    "termsConditions": "条款和条件",
    "paymentTerms": "1. 总款项需在 30 天内付清",
    "includeInvoiceNumber": "2. 请在支票上注明发票号码",
    "phone": "电话",
    "customer": "客户",
    "contactQuestions": "如果您对本发票有任何疑问，请联系",
    "details": "员工信息",
    "manageDetails": "管理选择",
    "siteName": "站点名称",
    "city": "城市/地区",
    "manager": "负责人",
    "operationalStatus": "运营状态",
    "photoUrl": "员工照片",
    "uploadPhoto": "上传照片",
    "unassigned": "未指派",
    "securityTeam": "团队",
    "guards": "员工",
    "addLocation": "添加新地点",
    "createLocation": "创建地点",
    "cancel": "取消",
    "filterAll": "所有地点",
    "morningShift": "早班 (9AM - 5PM)",
    "nightShift": "晚班 (5PM - 1AM)",
    "operational": "运营中",
    "renovating": "装修中",
    "active": "活跃",
    "closed": "关闭",
    "onTime": "准时",
    "late": "迟到",
    "absent": "缺勤",
    "design": "设计",
    "engineering": "工程",
    "hr": "人力资源",
    "marketing": "市场营销",
    "operations": "运营",
    "security": "安保",
    "it": "IT",
    "headquarters": "总部",
    "kitchen": "厨房",
    "service": "服务",
    "bar": "吧台",
    "retail": "零售",
    "warehouse": "仓库",
    "cafe": "咖啡厅",
    "inventory": "库存",
    "accounts": "账户",
    "management": "管理",
    "cleaning": "清洁",
    "maintenance": "维修",
    "morning12": "白班 (12小时)",
    "night12": "晚班 (12小时)",
    "importSuccess": "成功导入 {0} 条记录。",
    "importError": "导入错误：",
    "payrollUpdateSuccess": "成功更新 {0} 位员工的工资。",
    "payrollUpdateError": "更新工资错误：",
    "myProfile": "我的个人资料",
    "emailLabel": "电子邮件：",
    "userIdLabel": "用户 ID：",
    "accountTypeLabel": "账户类型：",
    "admin": "管理员",
    "shopSettingsSaved": "店铺设置已保存到云端",
    "shopSettingsError": "保存设置错误",
    "localization": "本地化",
    "currency": "货币",
    "departmentSettings": "部门设置",
    "departments": "部门",
    "manageDepartments": "添加或删除部门",
    "addDepartment": "添加部门",
    "backupRestore": "备份与恢复",
    "exportBackup": "导出备份",
    "importBackup": "导入备份",
    "backupDescription": "将您的数据导出为 JSON 或从之前的备份中恢复。",
    "dangerZone": "危险区域",
    "irreversibleAction": "不可逆操作。将删除所有数据。",
    "factoryReset": "系统出厂设置重置",
    "compensation": "薪酬",
    "advance": "预支",
    "delete": "删除",
    "terminateService": "终止服务",
    "addAttendance": "添加考勤",
    "editAttendance": "编辑考勤",
    "deleteAttendance": "删除考勤",
    "selectEmployee": "选择员工",
    "selectDate": "选择日期",
    "selectStatus": "选择状态",
    "save": "保存",
    "replacementFor": "替班",
    "coveringFor": "代班",
    "lateDeductions": "迟到扣款",
    "absentDeductions": "缺勤扣款",
    "manualDeduction": "人工扣款",
    "cost": "成本",
    "none": "无",
    "dashboardTotal": "总计",
    "activeGuards": "活跃员工",
    "operationalSites": "运营站点",
    "checkedInToday": "今日已签到",
    "issuesToday": "今日问题",
    "quickActions": "快速操作",
    "addStaff": "添加员工",
    "addSite": "添加站点",
    "systemStatus": "系统状态",
    "systemOperational": "所有系统运行正常。数据库已同步。",
    "online": "在线",
    "attendanceReport": "考勤报表",
    "payrollReport": "工资报表",
    "staffReport": "员工报表",
    "taxReport": "税务报表",
    "today": "今天",
    "lateAbsent": "迟到/缺勤",
    "lateHours": "迟到时长",
    "attendanceExists": "该员工在此日期的考勤已存在。",
    "theme": "主题",
    "light": "浅色",
    "dark": "深色",
    "payrollSlip": "工资单",
    "payrollFor": "工资单周期",
    "employeeName": "员工姓名",
    "employeeId": "员工 ID",
    "payPeriod": "计薪周期",
    "basicSalary": "基本工资",
    "grossPay": "总工资",
    "totalDeductions": "总扣除",
    "otherDeductions": "其他扣除",
    "employeeSignature": "员工签名",
    "authorizedSignature": "授权签名",
    "computerGenerated": "这是计算机生成的工资单。不需要签名。",
    "generatedOn": "生成于",
    "at": "于",
    "companyName": "公司名称",
    "companyAddress": "公司地址",
    "selectLocation": "选择地点",
    "noLocations": "由于没有可用地点 - 请先创建一个地点",
    "authError": "认证错误：",
    "googleSignInError": "Google 登录错误：",
    "factoryResetWarning": "严重警告：这将永久删除所有数据。您确定吗？",
    "pinPrompt": "请输入安全密码：",
    "incorrectPin": "密码错误。",
    "factoryResetPinPrompt": "输入安全密码以确认出厂设置重置：",
    "factoryResetIncorrectPin": "密码错误。重置已中止。",
    "switchModePrompt": "输入管理员密码以切换模式：",
    "changeUserPrompt": "输入密码以更改用户：",
    "resetComplete": "出厂设置重置完成。所有数据已清除。",
    "resetFailed": "重置失败：",
    "backupExported": "备份成功导出！",
    "exportFailed": "导出失败：",
    "backupImported": "备份已导入！正在重新加载...",
    "importFailed": "导入失败：",
    "overwriteWarning": "警告：这将覆盖所有现有数据。是否继续？",
    "guestLogin": "游客登录",
    "forgotPassword": "忘记密码？",
    "resetPassword": "重置密码",
    "sendResetLink": "发送重置链接",
    "backToLogin": "返回登录",
    "passwordResetSent": "密码重置邮件已发送！",
    "enterEmail": "输入您的电子邮件以重置密码",
    "orContinue": "或继续使用",
    "signInGoogle": "使用 Google 登录",
    "linkSuccess": "Google 帐户已成功链接！",
    "linkError": "链接错误：",
    "accountLinked": "此 Google 帐户已被关联。",
    "employeeSaved": "员工信息已成功保存！",
    "saveError": "保存失败：",
    "deleteConfirm": "您确定吗？",
    "updateError": "更新失败：",
    "addPurchaseError": "添加采购记录失败：",
    "genInvoiceError": "生成发票失败：",
    "addItemError": "添加项目失败：",
    "deleteLocationWarning": "无法删除。已指派员工。",
    "deleteLocationConfirm": "删除此地点？",
    "errorNoUser": "错误：没有用户登录。",
    "totalIncome": "总收入",
    "visa": "Visa",
    "onlinePayment": "在线支付",
    "forgotPin": "忘记密码？",
    "securityQuestion": "安全问题",
    "securityAnswer": "安全问题答案",
    "enterSecurityAnswer": "输入安全问题回答",
    "pinResetSuccess": "密码重置成功！您的新密码是 1234。",
    "incorrectAnswer": "回答错误。",
    "setSecurityQuestion": "设置安全问题",
    "changePin": "更改安全密码",
    "newPin": "新密码",
    "confirmChangePin": "确认更改 PIN",
    "saveSettings": "保存设置",
    "currentPin": "当前密码",
    "enterNewPin": "输入新密码",
    "pinChanged": "密码更新成功！",
    "pinSetMessage": "密码已设置。使用“忘记密码”进行重置。",
    "secQ_pet": "您的第一个宠物叫什么名字？",
    "secQ_mother": "您母亲的婚前姓是什么？",
    "secQ_city": "您出生在哪个城市？",
    "secQ_school": "您的第一所学校叫什么名字？",
    "daily": "每日",
    "weekly": "每周",
    "monthly": "每月",
    "yearly": "每年",
    "profitLossReport": "损益报表",
    "monthlyPl": "每月损益",
    "plSubtitle": "收入 vs 销货成本 vs 费用分析",
    "revenue": "收入",
    "totalSales": "总销售额",
    "discount": "折扣",
    "cogs": "销货成本",
    "cogsFull": "销货成本",
    "grossProfit": "毛利",
    "expenses": "费用",
    "purchasesOther": "采购/其他",
    "netProfit": "净利润",
    "netLoss": "净亏损",
    "incomeStatement": "损益表",
    "salesCash": "销售 - 现金",
    "salesVisa": "销售 - Visa",
    "salesOnline": "销售 - 在线",
    "totalRevenue": "总收入",
    "costOfGoodsSold": "销货成本",
    "grossMargin": "毛利率",
    "operatingExpenses": "运营费用",
    "totalExpenses": "总费用",
    "netMargin": "净利率",
    "deptExpenses": "部门费用",
    "invPurchases": "库存采购",
    "selectEmployeeAlert": "请选择一名销售员工！",
    "accountHandling": "账户处理",
    "connectGoogle": "关联 Google 帐户",
    "linkGoogleDesc": "关联您的 Google 帐户，以便使用它进行登录，而不是使用密码。",
    "soldItemsDetail": "已售商品详情",
    "boughtItemsDetail": "采购商品详情 (采购与费用)",
    "unknown": "未知",
    "totals": "总计",
    "unitCost": "单位成本",
    "period": "周期",
    "na": "不适用",
    "totalCost": "总成本",
    "profit": "利润",
    "liveBoard": "实时看板",
    "manageUnits": "房间和桌位",
    "menuRecipes": "菜单和配方",
    "activeSessions": "活跃会话",
    "unitsMonitoring": "{0} 个单元的实时监控",
    "inSession": "会话中",
    "available": "可用",
    "startSession": "开始会话",
    "addOrder": "添加订单",
    "stop": "结算",
    "recipeBuilder": "配方构建器",
    "manageUnitsTitle": "管理单元",
    "roomName": "房间名称",
    "unitType": "单元类型",
    "hourlyRate": "小时费率",
    "saveUnit": "保存单元",
    "cafeTable": "咖啡桌",
    "playStationRoom": "游戏房",
    "billiardsTable": "台球桌",
    "category": "类别",
    "offerPrice": "价格",
    "composition": "组成",
    "linkStock": "+ 关联仓库库存",
    "hotDrinks": "热饮",
    "coldDrinks": "冷饮",
    "snacks": "小吃",
    "meals": "正餐",
    "updateItem": "更新项目",
    "addToMenu": "添加到菜单",
    "appendSession": "将会话项目追加到会话中",
    "orderHistory": "订单历史",
    "newSelection": "新选择",
    "trayEmpty": "托盘为空",
    "trayTotal": "托盘总计",
    "confirmOrder": "确认订单",
    "menuItemsMissingTitle": "菜单项目缺失",
    "all": "全部",
    "customerPhone": "客户电话 *",
    "customerName": "客户姓名",
    "sessionType": "会话类型",
    "openSession": "开放 (无限制)",
    "fixedDuration": "固定时长",
    "startSessionTitle": "开始会话",
    "managePayroll": "管理工资单",
    "advanceTaken": "预支金额",
    "manualDeductions": "手动扣除",
    "lateAbsentAuto": "迟到/缺勤 (自动)",
    "grossEarnings": "总收入",
    "netPayable": "应付净额",
    "reset": "重置",
    "saveRecord": "保存记录",
    "hourlyRateLabel": "小时费率",
    "sessionTypeLabel": "会话类型",
    "phonePlaceholder": "例如：050 123 4567",
    "guestName": "访客姓名",
    "subtotalLabel": "小计",
    "retryCamera": "重试摄像头",
    "scanFocusInfo": "捏合或使用滑块进行对焦。",
    "tapToFocus": "点击屏幕强制对焦。",
    "centerCodeFrame": "将代码置于蓝色框内",
    "holdAwayTap": "保持 20 厘米距离并点击以清晰显示",
    "selectMonthInfo": "选择月份以查看工资详情",
    "manageEditMonth": "管理/编辑本月",
    "viewManageLocations": "查看并管理您所有的物理地点",
    "addAccount": "添加帐户",
    "accountName": "帐户名称",
    "initialBalance": "初始余额",
    "editItem": "编辑项目",
    "addInventoryItem": "添加库存项目",
    "printBarcodeLabel": "打印条形码标签",
    "newSale": "新销售",
    "totalAmount": "总金额",
    "completed": "已完成",
    "shipped": "已发货",
    "itemsSummaryLabel": "项目摘要",
    "connectionError": "连接错误：",
    "dismiss": "忽略",
    "adminUser": "管理员用户",
    "optional": "可选",
    "onTimeLabel": "准时",
    "lateLabel": "迟到",
    "absentLabel": "缺勤",
    "pendingLabel": "待处理",
    "createSale": "创建销售",
    "newPurchase": "新采购",
    "supplierName": "供应商名称",
    "tax": "税费",
    "manageLocations": "管理并监控您所有的物理站点和地点。",
    "siteEmployees": "站点员工",
    "accountsSubtitle": "跟踪资产、负债和费用。",
    "mixedLocationError": "不能混合来自不同地点的物品！请先清空购物车。",
    "department": "部门",
    "missing": "缺失",
    "taxEstimation": "估计扣税额",
    "noAccounts": "未找到帐户。添加一个以开始。",
    "outOfStock": "无现货",
    "printWizard": "打印条形码向导",
    "totalLabels": "标签总数",
    "layoutMode": "布局模式",
    "printNow": "现在打印",
    "dailySales": "每日销售",
    "cafeHistory": "咖啡厅历史",
    "searchByDate": "按日期搜索",
    "printSelected": "打印所选",
    "previousBills": "之前的账单",
    "confirmDelete": "您确定要删除吗？",
    "deleteError": "删除项目时出错",
    "history": "历史",
    "itemExists": "项目已存在",
    "update": "更新",
    "upi": "UPI",
    "pay": "支付",
    "Saved": "已保存！",
    "Report": "报告",
    "Reset to defaults": "重置为默认值",
    "id": "ID",
    "instaPay": "InstaPay",
    "method": "方法",
    "exp": "费用",
    "a": "A",
    "T": "T",
    "pn": "PN",
    "No items with barcodes to print.": "没有带条形码的项目可以打印。",
    "Please allow popups to print payroll slip": "请允许弹出窗口以打印工资单",
    "Please select a question and answer!": "请选择问题和答案！",
    "printPayrollSlip": "打印工资单",
    "profit_loss": "损益",
    "now": "现在",
    "h": "时",
    "m": "分",
    "PlayStation": "PlayStation",
    "Billiards": "台球",
    "Cafe": "咖啡厅",
    "sticker": "贴片",
    "a4 sheet": "A4 纸",
    "noBarcode": "无条形码",
    "allowPopups": "请允许弹出窗口以打印收据。",
    "menuService": "服务与维修",
    "activeJobs": "活跃任务",
    "newTicket": "新工单",
    "serviceHistory": "服务历史",
    "customerInfo": "客户信息",
    "deviceDetails": "设备详情",
    "issueDescription": "问题描述",
    "describeIssue": "描述问题...",
    "estimatedCost": "预估成本",
    "technician": "技师",
    "priority": "优先级",
    "createTicket": "创建工单",
    "searchTickets": "搜索工单...",
    "noActiveJobs": "无活跃维修任务",
    "editTicket": "编辑维修工单",
    "saveChanges": "保存更改",
    "received": "已接收",
    "inProgress": "进行中",
    "waitingParts": "等待配件",
    "readyPickup": "待取货",
    "delivered": "已交付",
    "lowStockAlerts": "低库存警报",
    "pendingRepairs": "待处理维修",
    "completedRepairs": "已完成维修",
    "pendingPayments": "待付款",
    "servicePerformance": "服务绩效",
    "topRepairs": "热门维修类型",
    "technicianRevenue": "技师收入",
    "monthlyServiceRevenue": "月度服务收入",
    "sparePartsUsage": "备件使用情况",
    "addCustomer": "添加客户",
    "addStock": "添加库存",
    "createInvoice": "创建发票",
    "attachPhotos": "设备照片",
    "add": "添加",
    "recentActivity": "最近活动",
    "customerProfile": "客户详情",
    "deviceInfo": "设备信息",
    "repairHistory": "维修历史",
    "diagnostics": "诊断",
    "partsUsed": "使用配件",
    "paymentStatus": "付款状态",
    "paid": "已付款",
    "unpaid": "未付款",
    "partial": "部分付款",
    "spareParts": "备用配件",
    "lowStock": "低库存",
    "phoneParts": "手机配件",
    "pcComponents": "电脑组件",
    "accessories": "配件",
    "urgent": "紧急",
    "high": "高",
    "normal": "普通",
    "low": "低",
    "createNewRepairTicket": "创建新维修工单",
    "todaysRevenue": "今日收入",
    "address": "地址",
    "assignedTechnician": "指派技师",
    "brand": "品牌",
    "collected": "已收款",
    "console": "游戏机",
    "creditCard": "信用卡",
    "dashboard": "仪表板",
    "device": "设备",
    "editCustomer": "编辑客户",
    "internalNotes": "内部备注",
    "minStock": "最低库存",
    "mobile": "多端",
    "model": "型号",
    "other": "其他",
    "page": "页",
    "paymentMethod": "付款方式",
    "pc": "电脑",
    "serialNo": "序列号",
    "tablet": "平板电脑",
    "totalNetPay": "总净工资",
    "totalRecords": "总记录数",
    "customers": "客户",
    "sell": "出售",
    "servicePOS": "服务 POS",
    "activeRepairs": "活跃维修",
    "searchRepairsAndStock": "搜索维修或库存...",
    "morning8": "白班 (8小时)",
    "night8": "晚班 (8小时)",
    "finance": "财务部",
    "shopLogo": "店铺图标",
    "uploadLogo": "上传图标",
    "changeLogo": "修改图标",
    "removeLogo": "移除图标",
    "kioskCheckInSuccess": "打卡成功！",
    "kioskCheckOutSuccess": "签退成功！",
    "allTransactions": "所有交易",
    "searchHistory": "搜索历史...",
    "reviewPastSales": "查看过去的销售和维修记录",
    "payment": "付款",
    "reprint": "重新打印",
    "repair": "维修",
    "noHistoryInPeriod": "在此期间未发现记录",
    "ownerMode": "所有者模式",
    "managerMode": "经理模式",
    "cashierMode": "收银员模式",
    "siteLogo": "站点图标",
    "systemLogo": "系统图标",
    "uploadSiteLogo": "上传站点图标",
    "changeSiteLogo": "修改站点图标",
    "removeSiteLogo": "移除站点图标",
    "manual": "手动",
    "partsTotal": "配件总计",
    "noPartsUsed": "尚未记录配件使用情况",
    "orderNumber": "订单号",
    "serviceInvoice": "服务发票",
    "serviceCenter": "服务中心",
    "repairManagement": "维修管理",
    "noRecentActivity": "无最近活动",
    "otherPayment": "其他支付方式",
    "repairs": "维修",
    "insufficientIngredient": "配料库存不足",
    "insufficientStock": "库存不足为",
    "maxStockReached": "达到最大库存：",
    "customItem": "自定义项目",
    "enterItemName": "输入项目名称：",
    "enterItemPrice": "输入项目价格：",
    "inventoryParts": "库存零件",
    "useExternalTerminal": "使用外部终端",
    "billToPOS": "开票至 POS",
    "permissionDeniedOwner": "拒绝访问：需要所有者密码。",
    "ownerOnlyPins": "仅所有者可管理密码",
    "instapay": "InstaPay",
    "repairLabor": "维修工时",
    "autoHide": "自动隐藏",
    "seconds": "秒",
    "terminal": "终端",
    "jobs": "任务",
    "sparePart": "备件",
    "todaysServices": "今日服务",
    "servicesOn": "服务日期",
    "scan": "扫描",
    "viewCart": "查看购物车",
    "serviceModule": "服务模块",
    "customerInformation": "客户资料",
    "ticketId": "工单 ID",
    "inventoryManagement": "库存管理",
    "pinManagement": "密码管理",
    "cashierPin": "收银员密码",
    "managerPin": "经理密码",
    "ownerPin": "所有者密码",
    "saleCompleted": "销售完成！",
    "repairAlreadyInCart": "维修已在购物车中！",
    "deleteViaActiveJobs": "通过活跃任务删除",
    "photoUploadFailed": "照片上传失败。请检查连接。",
    "logoSizeError": "图标必须小于 2MB",
    "adminPinRequired": "拒绝访问：需要管理员密码。",
    "managerPinRestricted": "经理密码权限受限。",
    "ownerPinRestricted": "所有者密码权限受限。",
    "totalQty": "总数量",
    "exitKioskPrompt": "双击退出自助服务模式",
    "borrow": "借用",
    "borrowDate": "借用日期",
    "borrowTime": "时间",
    "dateBorrowed": "借出日期",
    "dateReturned": "归还日期",
    "returned": "已归还",
    "borrowed": "已借出",
    "borrowItems": "借出物品",
    "noBorrowRecords": "无借用记录",
    "borrower": "借用人",
    "markAsBorrowed": "标记为已借",
    "markAsReturned": "标记为已还",
    "borrowerName": "借用人",
    "addBorrowRecord": "添加借用记录",
    "addRecord": "添加记录",
    "additionalInfo": "附加信息",
    "enableGst": "启用GST",
    "gstNumber": "GST 编号",
    "gstPercent": "GST 税率 (%)",
    "taxableAmt": "应纳税额",
    "taxableAmtMgmt": "纳税金额管理",
    "gstPlaceholder": "例: 22AAAAA0000",
    "gst": "GST"
  },
  "ur": {
    "appName": "فین ای آر پی",
    "appSubtitle": "انٹرپرائز ریسورس پلاننگ",
    "menuDashboard": "ڈیش بورڈ",
    "menuEmployees": "ملازمین",
    "menuSites": "مقامات",
    "menuAttendance": "حاضری",
    "menuPayroll": "تنخواہ",
    "menuReports": "رپورٹس",
    "menuKiosk": "کیوسک موڈ",
    "kioskWelcome": "ہمارے کیوسک میں خوش آمدید",
    "kioskSub": "براہ کرم شروع کرنے کے لیے ایک سروس منتخب کریں",
    "kioskPos": "سیلف سروس POS",
    "kioskService": "مرمت کی ٹریکنگ",
    "kioskCheckIn": "عملے کا چیک ان",
    "kioskClock": "موجودہ وقت",
    "kioskBack": "ہوم پر واپس جائیں",
    "settings": "ترتیبات",
    "search": "تلاش کریں...",
    "allEmployees": "All Employees",
    "manageStaff": "عملے کا انتظام کریں",
    "addEmployee": "Add Employee",
    "name": "نام",
    "role": "عہدہ",
    "dept": "شعبہ",
    "salary": "بنیادی تنخواہ",
    "bonus": "بونس",
    "overtime": "اوور ٹائم",
    "deductions": "کٹوتیاں",
    "total": "کل",
    "netPay": "خالص تنخواہ",
    "actions": "Actions",
    "login": "لاگ ان",
    "signup": "رجسٹر",
    "email": "ای میل",
    "password": "پاس ورڈ",
    "welcome": "خوش آمدید",
    "signInToAccess": "ڈیش بورڈ تک رسائی کے لیے سائن ان کریں۔",
    "createAccount": "اکاؤنٹ بنائیں",
    "haveAccount": "پہلے سے اکاؤنٹ ہے؟",
    "noAccount": "اکاؤنٹ نہیں ہے؟",
    "logout": "لاگ آؤٹ",
    "location": "مقام",
    "shift": "شفٹ",
    "totalComp": "کل معاوضہ",
    "dailyAttendance": "روزانہ حاضری کا لاگ",
    "trackAttendance": "ملازمین کے چیک ان اور شفٹوں کو ٹریک کریں۔",
    "checkIn": "حاضری لگائیں",
    "checkOut": "خصت لگائیں",
    "status": "حالت",
    "import": "درآمد کریں",
    "export": "برآمد کریں",
    "payrollMgmt": "تنخواہ کا انتظام",
    "costAnalysis": "اخراجات کا تجزیہ",
    "aiInsights": "اے آئی بصیرت",
    "siteStats": "سائٹ کے اعداد و شمار",
    "assignedGuards": "تعینات ملازمین",
    "deleteLocation": "مقام حذف کریں",
    "terminateGuard": "ملازم کو برخاست / حذف کریں",
    "aiAssistant": "اے آئی اسسٹنٹ",
    "genReview": "کارکردگی کا جائزہ لیں",
    "generating": "تیار ہو رہا ہے...",
    "downloadReport": "رپورٹ ڈاؤن لوڈ کریں",
    "editLocation": "ترمیم کریں",
    "otp": "او ٹی پی کوڈ",
    "otpSent": "او ٹی پی بھیج دیا گیا",
    "otpSentDetail": "او ٹی پی shoaibwwe01@outlook.com پر بھیج دیا گیا ہے۔ برائے مہربانی ایڈمن سے کوڈ لیں۔",
    "invalidOtp": "غلط او ٹی پی کوڈ",
    "registeredOnly": "صرف رجسٹرڈ صارفین کے لیے",
    "guestNotice": "آپ گیسٹ موڈ میں ہیں۔ تمام خصوصیات کے لیے رجسٹر کریں۔",
    "menuAccounts": "اکاؤنٹس",
    "menuSalesPurchases": "فروخت",
    "menuWarehouses": "گودام",
    "menuCafe": "کیفے",
    "menuInvoices": "انوائسز",
    "weeklySales": "ہفتہ وار فروخت کی رپورٹ",
    "weeklyBuy": "ہفتہ وار خرید/انوونٹری رپورٹ",
    "walkIn": "واک ان",
    "takeaway": "ٹیک اوے",
    "walkInCustomer": "واک ان کسٹمر",
    "takeawayCustomer": "ٹیک اوے کسٹمر",
    "customerCopy": "کسٹمر کاپی",
    "shopCopy": "شاپ کاپی",
    "printSettings": "پرنٹ کی ترتیبات",
    "thermal": "تھرمل (80mm)",
    "a4": "A4 (Standard)",
    "dualPrint": "ڈبل پرنٹ (کسٹمر + شاپ)",
    "lastUpdated": "آخری بار اپ ڈیٹ کیا گیا",
    "stockValueBuy": "اسٹاک کی مالیت (خرید)",
    "stockValueSell": "اسٹاک کی مالیت (فروخت)",
    "itemsSummary": "آئیٹمز کا خلاصہ",
    "invoiceId": "انوائس آئی ڈی",
    "type": "قسم",
    "soldBy": "فروخت کنندہ",
    "customerId": "کسٹمر آئی ڈی",
    "taxed": "ٹیکس شدہ",
    "advanceSalary": "ایڈوانس تنخواہ",
    "image": "تصویر",
    "salesEmployee": "سیلز ملازم",
    "adminDefault": "ایڈمن (ڈیفالٹ)",
    "historyLog": "ہسٹری لاگ",
    "historySubtitle": "فروخت اور گودام کی سرگرمیوں کا جامع ریکارڈ۔",
    "allTypes": "تمام اقسام",
    "sales": "فروخت",
    "stockUpdates": "اسٹاک اپ ڈیٹس",
    "valueStatus": "قیمت / حالت",
    "noHistory": "کوئی سرگزشت نہیں ملی",
    "sold": "فروخت ہوا",
    "to": "کو",
    "units": "یونٹس",
    "stockCheck": "اسٹاک چیک",
    "items": "آئیٹمز",
    "posTerminal": "پی او ایس ٹرمینل",
    "searchProducts": "مصنوعات تلاش کریں...",
    "todaysSales": "آج کی فروخت",
    "salesOn": "فروخت کی تاریخ",
    "time": "وقت",
    "amount": "رقم",
    "receipt": "رسید",
    "currentBill": "موجودہ بل",
    "cartEmpty": "کارٹ خالی ہے",
    "selectItems": "فہرست سے اشیاء منتخب کریں",
    "subtotal": "سب ٹوٹل",
    "checkout": "چیک آؤٹ",
    "customerNameOptional": "گاہک کا نام (اختیاری)",
    "hold": "ہولڈ کریں",
    "resumeWarning": "دوبارہ شروع کرنے سے موجودہ کارٹ مٹ جائے گا۔ جاری رکھیں؟",
    "quickStockIn": "فوری اسٹاک ان",
    "currentQuantity": "موجودہ مقدار",
    "enterAddedQty": "اضافی مقدار درج کریں",
    "payWithUPI": "UPI سے ادائیگی کریں",
    "assistant": "اسسٹنٹ",
    "reviewOrder": "آرڈر کا جائزہ لیں",
    "products": "مصنوعات",
    "scanner": "اسکینر",
    "cart": "کارٹ",
    "digitalPayment": "ڈیجیٹل ادائیگی",
    "linkExpired": "لنک ختم ہو چکا ہے",
    "linkExpiredDetail": "یہ ادائیگی کا لنک صرف 10 منٹ کے لیے درست تھا۔ براہ کرم نیا QR کوڈ طلب کریں۔",
    "payNow": "ابھی ادائیگی کریں",
    "secureUpi": "محفوظ UPI ادائیگی",
    "securePayment": "محفوظ ڈیجیٹل ادائیگی",
    "totalLabel": "کل",
    "goBackToApp": "ایپ پر واپس جائیں",
    "inventorySubtitle": "انوونٹری کی سطح اور اسٹاک کی نقل و حرکت",
    "searchInventory": "نام سے انوونٹری تلاش کریں...",
    "itemName": "نام",
    "buyPrice": "خرید قیمت",
    "sellPrice": "فروخت قیمت",
    "barcode": "بارکوڈ",
    "scanBarcode": "اسکین بارکوڈ",
    "paymentMethodNotConfigured": "ترتیبات میں ادائیگی کا طریقہ ترتیب نہیں دیا گیا ہے",
    "digitalPayment_QR": "ڈیجیٹل ادائیگی (QR)",
    "upiId": "UPI ID",
    "instapayId": "InstaPay ID",
    "payWithInstapay": "InstaPay سے ادائیگی کریں",
    "confirmCheckout": "چیک آؤٹ کی تصدیق کریں",
    "totalWithDiscount": "رعایت کے بعد کل",
    "quantity": "مقدار",
    "refinement": "اصلاح",
    "noInventory": "کوئی انوینٹری نہیں ملی",
    "hideCosts": "اخراجات چھپائیں",
    "showCosts": "اخراجات دکھائیں",
    "securityCheck": "سیکیورٹی چیک",
    "addItem": "Add Item",
    "edit": "ترمیم",
    "itemNotFound": "پروڈکٹ انوینٹری میں نہیں ملی۔ براہ کرم چیک کریں یا شامل کریں۔",
    "generate": "تیار کریں",
    "print": "پرنٹ کریں",
    "printAll": "تمام بارکوڈز پرنٹ کریں",
    "shopSettings": "دکان کی ترتیبات",
    "shopName": "دکان کا نام",
    "shopAddress": "دکان کا پتہ",
    "shopPhone": "دکان کا فون",
    "updateSettings": "ترتیبات اپ ڈیٹ کریں",
    "securityPin": "سیکیورٹی پن",
    "language": "زبان",
    "close": "بند کریں",
    "retailInvoice": "ریٹیل انوائس",
    "invoice": "انوائس",
    "date": "تاریخ",
    "billNo": "بل نمبر",
    "paymentMode": "ادائیگی کا طریقہ",
    "cash": "نقد",
    "item": "آئٹم",
    "qty": "مقدار",
    "amt": "رقم",
    "price": "قیمت",
    "taxVAT": "ٹیکس/VAT",
    "taxRate": "ٹیکس کی شرح",
    "makeChecksPayable": "تمام چیک اس نام پر بنائیں",
    "thankYou": "آپ کے تعاون کا شکریہ!",
    "billTo": "بل بنام",
    "description": "تفصیل",
    "unitPrice": "یونٹ کی قیمت",
    "lineTotal": "لائن کل",
    "comments": "تبصرے",
    "termsConditions": "شرائط و ضوابط",
    "paymentTerms": "1. کل ادائیگی 30 دنوں میں واجب الادا ہے",
    "includeInvoiceNumber": "2. براہ کرم اپنے چیک پر انوائس نمبر درج کریں",
    "phone": "فون",
    "customer": "گاہک",
    "contactQuestions": "اگر آپ کو اس انوائس کے بارے میں کوئی سوال ہے تو رابطہ کریں",
    "details": "ملازم کی معلومات",
    "manageDetails": "انتخاب کا انتظام کریں",
    "siteName": "سائٹ کا نام",
    "city": "شہر / علاقہ",
    "manager": "مینیجر",
    "operationalStatus": "آپریشنل حیثیت",
    "photoUrl": "ملازم کی تصویر",
    "uploadPhoto": "تصویر اپ لوڈ کریں",
    "unassigned": "غیر مقرر کردہ",
    "securityTeam": "ٹیم",
    "guards": "ملازمین",
    "addLocation": "نیا مقام شامل کریں",
    "createLocation": "مقام بنائیں",
    "cancel": "منسوخ کریں",
    "filterAll": "تمام مقامات",
    "morningShift": "صبح (9AM - 5PM)",
    "nightShift": "شام (5PM - 1AM)",
    "operational": "آپریشنل",
    "renovating": "تجدید ہو رہی ہے",
    "active": "Active",
    "closed": "بند",
    "onTime": "وقت پر",
    "late": "لیٹ",
    "absent": "غیر حاضر",
    "design": "ڈیزائن",
    "engineering": "انجینئرنگ",
    "hr": "ہیومن ریسورس",
    "marketing": "مارکیٹنگ",
    "operations": "آپریشنز",
    "security": "سیکیورٹی",
    "it": "آئی ٹی",
    "headquarters": "ہیڈ کوارٹر",
    "kitchen": "باورچی خانہ",
    "service": "سروس",
    "bar": "بار",
    "retail": "فروخت (ریٹیل)",
    "warehouse": "انوونٹری/اسٹاک",
    "cafe": "کیفے",
    "inventory": "انوونٹری",
    "customers": "گاہک",
    "addCustomer": "گاہک شامل کریں",
    "newTicket": "نیا ٹکٹ",
    "serviceModule": "سروس ماڈیول",
    "devicePhotos": "ڈیوائس کی تصاویر",
    "accounts": "اکاؤنٹس",
    "management": "انتظامیہ",
    "cleaning": "صفائی",
    "maintenance": "مینٹیننس",
    "morning12": "صبح (12 گھنٹے)",
    "night12": "رات (12 گھنٹے)",
    "importSuccess": "Successfully imported {0} records.",
    "importError": "Error importing: ",
    "payrollUpdateSuccess": "Successfully updated payroll for {0} employees.",
    "payrollUpdateError": "Error updating payroll: ",
    "myProfile": "میری پروفائل",
    "emailLabel": "ای میل:",
    "userIdLabel": "صارف آئی ڈی:",
    "accountTypeLabel": "اکاؤنٹ کی قسم:",
    "admin": "ایڈمن",
    "shopSettingsSaved": "دکان کی ترتیبات محفوظ ہوگئیں",
    "shopSettingsError": "Error saving settings",
    "localization": "مقامی ترتیب",
    "currency": "کرنسی",
    "departmentSettings": "Department Settings",
    "departments": "Departments",
    "manageDepartments": "Add or remove departments",
    "addDepartment": "Add Department",
    "backupRestore": "بیک اپ اور بحالی",
    "exportBackup": "Export Backup",
    "importBackup": "Import Backup",
    "backupDescription": "Export your data as JSON or restore from a previous backup.",
    "dangerZone": "خطرناک زون",
    "irreversibleAction": "Irreversible action. Deletes all data.",
    "factoryReset": "فیکٹری ری سیٹ",
    "compensation": "Compensation",
    "advance": "سلفہ",
    "delete": "حذف کریں",
    "terminateService": "سروس ختم کریں",
    "addAttendance": "حاضری لگائیں",
    "editAttendance": "حاضری میں ترمیم کریں",
    "deleteAttendance": "حاضری حذف کریں",
    "selectEmployee": "ملازم منتخب کریں",
    "selectDate": "تاریخ منتخب کریں",
    "selectStatus": "حالت منتخب کریں",
    "save": "محفوظ کریں",
    "replacementFor": "کے بدلے میں",
    "coveringFor": "کی جگہ پر",
    "lateDeductions": "تاخیر کی کٹوتیاں",
    "absentDeductions": "غیر حاضری کی کٹوتیاں",
    "manualDeduction": "دستی کٹوتی",
    "cost": "لاگت",
    "none": "کچھ نہیں",
    "dashboardTotal": "کل",
    "activeGuards": "فعال ملازمین",
    "operationalSites": "فعال مقامات",
    "checkedInToday": "آج حاضر ہوئے",
    "issuesToday": "آج کے مسائل",
    "quickActions": "فوری اقدامات",
    "addStaff": "ملازم شامل کریں",
    "addSite": "مقامی مقام شامل کریں",
    "systemStatus": "سسٹم کی حالت",
    "systemOperational": "All systems operational. Database synced.",
    "online": "Online",
    "attendanceReport": "حاضری رپورٹ",
    "payrollReport": "تنخواہ رپورٹ",
    "staffReport": "عملہ رپورٹ",
    "taxReport": "ٹیکس رپورٹ",
    "today": "آج",
    "lateAbsent": "تاخیر/غیر حاضر",
    "lateHours": "تاخیر کے گھنٹے",
    "attendanceExists": "Attendance already exists for this employee on this date.",
    "theme": "تھیم",
    "light": "لائٹ",
    "dark": "ڈارک",
    "payrollSlip": "تنخواہ کی پرچی",
    "payrollFor": "Payroll for",
    "employeeName": "ملازم کا نام",
    "employeeId": "ملازم آئی ڈی",
    "payPeriod": "تنخواہ کی مدت",
    "basicSalary": "بنیادی تنخواہ",
    "grossPay": "کل تنخواہ",
    "totalDeductions": "کل کٹوتیاں",
    "otherDeductions": "دیگر کٹوتیاں",
    "employeeSignature": "ملازم کے دستخط",
    "authorizedSignature": "مجاز دستخط",
    "computerGenerated": "یہ کمپیوٹر سے تیار کردہ پرچی ہے۔ دستخط کی ضرورت نہیں ہے۔",
    "generatedOn": "تیار کیا گیا",
    "at": "پر",
    "companyName": "کمپنی کا نام",
    "companyAddress": "کمپنی کا پتہ",
    "selectLocation": "مقام منتخب کریں",
    "noLocations": "کوئی مقام دستیاب نہیں ہے",
    "authError": "تصدیق کی خرابی",
    "googleSignInError": "گوگل سائن ان کی خرابی",
    "factoryResetWarning": "CRITICAL WARNING: This will DELETE ALL DATA (Employees, Sales, Inventory, etc.) PERMANENTLY. Are you sure?",
    "pinPrompt": "Enter Security PIN to continue:",
    "incorrectPin": "Incorrect PIN. Please try again.",
    "factoryResetPinPrompt": "Enter Security PIN to confirm Factory Reset:",
    "factoryResetIncorrectPin": "Incorrect PIN. Reset Aborted.",
    "switchModePrompt": "موڈ تبدیل کرنے کے لئے پن درج کریں",
    "changeUserPrompt": "Enter PIN to Change Sales User:",
    "resetComplete": "فیکٹری ری سیٹ مکمل ہو گیا۔ تمام ڈیٹا حذف کر دیا گیا ہے۔",
    "resetFailed": "Factory Reset Failed: ",
    "backupExported": "Backup exported successfully!",
    "exportFailed": "Export failed: ",
    "backupImported": "Backup imported successfully! Reloading...",
    "importFailed": "Import failed: ",
    "overwriteWarning": "WARNING: This will OVERWRITE all existing data. Continue?",
    "guestLogin": "گیسٹ لاگ ان",
    "forgotPassword": "پاس ورڈ بھول گئے؟",
    "resetPassword": "Reset Password",
    "sendResetLink": "Send Reset Link",
    "backToLogin": "Back to Login",
    "passwordResetSent": "Password reset email sent!",
    "enterEmail": "Enter your email to reset password",
    "orContinue": "یا اس کے ساتھ جاری رکھیں",
    "signInGoogle": "گوگل کے ساتھ سائن ان کریں",
    "linkSuccess": "Google Account Linked Successfully!",
    "linkError": "Link Error: ",
    "accountLinked": "This Google Account is already active. Please Log Out and use \"Sign in with Google\" directly.",
    "employeeSaved": "Employee Saved Successfully!",
    "saveError": "Error saving: ",
    "deleteConfirm": "Are you sure?",
    "updateError": "Error updating item: ",
    "addPurchaseError": "Error adding purchase: ",
    "genInvoiceError": "Error generating invoice: ",
    "addItemError": "Error adding item: ",
    "deleteLocationWarning": "Cannot delete. Employees assigned.",
    "deleteLocationConfirm": "Delete this location?",
    "errorNoUser": "Error: No user logged in.",
    "totalIncome": "Total Income",
    "visa": "Visa",
    "onlinePayment": "Online",
    "forgotPin": "پن بھول گئے؟",
    "securityQuestion": "Security Question",
    "securityAnswer": "Security Answer",
    "enterSecurityAnswer": "Enter Security Answer",
    "pinResetSuccess": "PIN Reset Successfully! Your new PIN is 1234.",
    "incorrectAnswer": "Incorrect Answer.",
    "setSecurityQuestion": "Set Security Question",
    "changePin": "پن تبدیل کریں",
    "newPin": "New PIN",
    "manageLocations": "Manage and monitor all your physical sites and locations.",
    "siteEmployees": "Employees",
    "saveSettings": "ترتیبات محفوظ کریں",
    "currentPin": "موجودہ پن",
    "enterNewPin": "نیا پن درج کریں",
    "pinChanged": "پن کامیابی کے ساتھ تبدیل ہو گیا ہے!",
    "pinSetMessage": "PIN is set. Use \"Forgot PIN\" to reset.",
    "confirmChangePin": "نیا پن سیٹ کریں؟",
    "secQ_pet": "What is your first pet's name?",
    "secQ_mother": "What is your mother's maiden name?",
    "secQ_city": "In what city were you born?",
    "secQ_school": "What is the name of your first school?",
    "daily": "Daily",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "profitLossReport": "نفع اور نقصان کی رپورٹ",
    "monthlyPl": "ماہانہ نفع اور نقصان",
    "plSubtitle": "Revenue vs COGS vs Expenses analysis",
    "revenue": "آمدنی",
    "totalSales": "کل فروخت",
    "discount": "رعایت",
    "cogs": "COGS",
    "cogsFull": "Cost of Goods Sold",
    "grossProfit": "مجموعی نفع",
    "expenses": "اخراجات",
    "purchasesOther": "Purchases/Other",
    "netProfit": "خالص نفع",
    "netLoss": "NET LOSS",
    "incomeStatement": "INCOME STATEMENT",
    "salesCash": "Sales - Cash",
    "salesVisa": "Sales - Visa",
    "salesOnline": "Sales - Online",
    "totalRevenue": "Total Revenue",
    "costOfGoodsSold": "Cost of Goods Sold",
    "grossMargin": "Gross Margin",
    "operatingExpenses": "OPERATING EXPENSES",
    "totalExpenses": "Total Expenses",
    "netMargin": "Net Margin",
    "deptExpenses": "Department Expenses",
    "invPurchases": "Inventory Purchases",
    "selectEmployeeAlert": "براہ کرم سیلز ملازم کا انتخاب کریں!",
    "accountHandling": "اکاؤنٹ ہینڈلنگ",
    "connectGoogle": "گوگل اکاؤنٹ سے منسلک کریں",
    "linkGoogleDesc": "پاس ورڈ کے بجائے لاگ ان کرنے کے لیے اپنا گوگل اکاؤنٹ لنک کریں۔",
    "soldItemsDetail": "SOLD ITEMS DETAIL",
    "boughtItemsDetail": "BOUGHT ITEMS DETAIL (Purchases & Expenses)",
    "unknown": "Unknown",
    "totals": "TOTALS",
    "unitCost": "یونٹ لاگت",
    "period": "Period",
    "na": "N/A",
    "totalCost": "Total Cost",
    "profit": "Profit",
    "liveBoard": "لائیو بورڈ",
    "manageUnits": "کمرے اور میزیں",
    "menuRecipes": "مینیو اور تراکیب",
    "activeSessions": "Active Sessions",
    "unitsMonitoring": "Live monitoring for {0} units",
    "inSession": "سیشن میں",
    "available": "دستیاب",
    "startSession": "سیشن شروع کریں",
    "addOrder": "آرڈر شامل کریں",
    "stop": "روکیں",
    "recipeBuilder": "ترکیب بنانے والا",
    "manageUnitsTitle": "Manage Units",
    "roomName": "کمرے کا نام",
    "unitType": "یونٹ کی قسم",
    "hourlyRate": "فی گھنٹہ ریٹ",
    "saveUnit": "یونٹ محفوظ کریں",
    "cafeTable": "کیفے ٹیبل",
    "playStationRoom": "پلے اسٹیشن روم",
    "billiardsTable": "بلیئرڈ ٹیبل",
    "category": "زمرہ",
    "offerPrice": "قیمت",
    "composition": "Composition",
    "linkStock": "+ Link warehouse stock",
    "hotDrinks": "گرم مشروبات",
    "coldDrinks": "ٹھنڈے مشروبات",
    "snacks": "اسنیکس",
    "meals": "کھانا",
    "updateItem": "Update Item",
    "addToMenu": "مینیو میں شامل کریں",
    "appendSession": "Append items to session",
    "orderHistory": "آرڈر کی تاریخ",
    "newSelection": "New Selection",
    "trayEmpty": "ٹرے خالی ہے",
    "trayTotal": "Tray Total",
    "confirmOrder": "Confirm Order",
    "menuItemsMissingTitle": "Menu items missing",
    "all": "تمام",
    "customerPhone": "Customer Phone *",
    "customerName": "Customer Name",
    "sessionType": "Session Type",
    "openSession": "Open (No Limit)",
    "fixedDuration": "Fixed Duration",
    "startSessionTitle": "Start Session",
    "managePayroll": "Manage Payroll",
    "advanceTaken": "Advance Taken",
    "manualDeductions": "Manual Deductions",
    "lateAbsentAuto": "Late/Absent (Auto)",
    "grossEarnings": "Gross Earnings",
    "netPayable": "Net Payable",
    "reset": "Reset",
    "saveRecord": "محفوظ کریں",
    "hourlyRateLabel": "HOURLY RATE",
    "sessionTypeLabel": "SESSION TYPE",
    "phonePlaceholder": "e.g. 050 123 4567",
    "guestName": "Guest Name",
    "subtotalLabel": "سب ٹوٹل",
    "retryCamera": "Retry Camera",
    "scanFocusInfo": "Pinch or use slider to focus.",
    "tapToFocus": "Tap screen to force focus.",
    "centerCodeFrame": "Center the code inside the blue frame",
    "holdAwayTap": "Hold 20cm away & Tap to sharpen",
    "selectMonthInfo": "Select month to view salary details",
    "manageEditMonth": "Manage/Edit for this Month",
    "viewManageLocations": "View and manage all your physical locations",
    "addAccount": "Add Account",
    "accountName": "Account Name",
    "initialBalance": "Initial Balance",
    "editItem": "Edit Item",
    "addInventoryItem": "Add Inventory Item",
    "printBarcodeLabel": "Print Barcode Label",
    "newSale": "New Sale",
    "totalAmount": "کل رقم",
    "completed": "مکمل",
    "shipped": "بھیج دیا گیا",
    "itemsSummaryLabel": "Items (Summary)",
    "connectionError": "کنکشن کی خرابی:",
    "dismiss": "خارج کریں",
    "adminUser": "ایڈمن صارف",
    "optional": "اختیاری",
    "onTimeLabel": "On Time",
    "lateLabel": "Late",
    "absentLabel": "Absent",
    "pendingLabel": "Pending",
    "createSale": "فروخت بنائیں",
    "newPurchase": "نئی خریداری",
    "supplierName": "سپلائر کا نام",
    "tax": "ٹیکس",
    "accountsSubtitle": "Track assets, liabilities, and expenses.",
    "mixedLocationError": "مختلف مقامات سے آئٹمز مکس نہیں کیے جا سکتے!",
    "department": "شعبہ",
    "missing": "لاپتہ",
    "taxEstimation": "Estimated tax deductions",
    "noAccounts": "No accounts found. Add one to get started.",
    "outOfStock": "یہ آئٹم اسٹاک میں نہیں ہے!",
    "printWizard": "Print Barcodes Wizard",
    "totalLabels": "Total Labels",
    "layoutMode": "Layout Mode",
    "orderNumber": "Order Number",
    "partsUsed": "Parts Used",
    "createInvoice": "Create Invoice",
    "serviceInvoice": "Service Invoice",
    "printNow": "Print Now",
    "dailySales": "Daily Sales",
    "cafeHistory": "Cafe History",
    "searchByDate": "Search by Date",
    "printSelected": "Print Selected",
    "previousBills": "Previous Bills",
    "confirmDelete": "Are you sure you want to delete?",
    "deleteError": "Error deleting item",
    "history": "سرگزشت",
    "itemExists": "Item already exists",
    "update": "Update",
    "upi": "UPI",
    "pay": "Pay",
    "Saved": "محفوظ ہوگیا!",
    "Report": "رپورٹ",
    "Reset to defaults": "Reset to defaults",
    "id": "آئی ڈی",
    "instaPay": "InstaPay",
    "method": "Method",
    "exp": "Exp",
    "a": "A",
    "T": "T",
    "pn": "PN",
    "No items with barcodes to print.": "No items with barcodes to print.",
    "Please allow popups to print payroll slip": "Please allow popups to print payroll slip",
    "Please select a question and answer!": "Please select a question and answer!",
    "printPayrollSlip": "Print Payroll Slip",
    "profit_loss": "Profit & Loss",
    "now": "اب",
    "h": "h",
    "m": "منٹ",
    "PlayStation": "PlayStation",
    "Billiards": "Billiards",
    "Cafe": "Cafe",
    "sticker": "Sticker",
    "a4 sheet": "A4 Sheet",
    "noBarcode": "No Barcode",
    "menuService": "سروس اور مرمت",
    "activeJobs": "زیر التواء کام",
    "serviceHistory": "سروس کی تاریخ",
    "customerInfo": "گاہک کی معلومات",
    "deviceDetails": "ڈیوائس کی تفصیلات",
    "issueDescription": "مسئلہ کی تفصیل",
    "describeIssue": "مسئلہ بیان کریں...",
    "estimatedCost": "تخمینہ لاگت",
    "technician": "ٹیکنیشن",
    "priority": "ترجیح",
    "createTicket": "ٹکٹ بنائیں",
    "searchTickets": "ٹکٹ تلاش کریں...",
    "noActiveJobs": "کوئی فعال مرمت کا کام نہیں",
    "editTicket": "مرمت کا ٹکٹ ترمیم کریں",
    "saveChanges": "تبدیلیاں محفوظ کریں",
    "received": "موصول ہو گیا",
    "inProgress": "کام جاری ہے",
    "waitingParts": "پرزوں کا انتظار",
    "readyPickup": "تیار ہے",
    "delivered": "ڈیلیور ہو گیا",
    "lowStockAlerts": "کم اسٹاک الرٹس",
    "pendingRepairs": "زیر التواء مرمت",
    "completedRepairs": "مکمل مرمت",
    "pendingPayments": "زیر التواء ادائیگیاں",
    "servicePerformance": "سروس کی کارکردگی",
    "topRepairs": "اعلی مرمت کی اقسام",
    "technicianRevenue": "ٹیکنیشن کی آمدنی",
    "monthlyServiceRevenue": "ماہانہ سروس آمدنی",
    "sparePartsUsage": "اضافی پرزوں کا استعمال",
    "addStock": "اسٹاک شامل کریں",
    "attachPhotos": "ڈیوائس کی تصاویر",
    "add": "Add",
    "recentActivity": "حالیہ سرگرمی",
    "customerProfile": "گاہک کی پروفائل",
    "deviceInfo": "ڈیوائس کی معلومات",
    "repairHistory": "مرمت کی تاریخ",
    "diagnostics": "تشخیص",
    "paymentStatus": "ادائیگی کی حیثیت",
    "paid": "ادا شدہ",
    "unpaid": "غیر ادا شدہ",
    "partial": "جزوی",
    "spareParts": "اضافی پرزے",
    "lowStock": "کم اسٹاک",
    "phoneParts": "فون کے پرزے",
    "pcComponents": "پی سی کے اجزاء",
    "accessories": "لوازمات",
    "urgent": "فوری",
    "high": "زیادہ",
    "normal": "نارمل",
    "low": "کم",
    "createNewRepairTicket": "نیا مرمت ٹکٹ بنائیں",
    "todaysRevenue": "آج کی آمدنی",
    "address": "پتہ",
    "assignedTechnician": "Assigned Technician",
    "brand": "برانڈ",
    "collected": "Collected",
    "console": "Console",
    "creditCard": "Credit Card",
    "dashboard": "ڈیش بورڈ",
    "device": "ڈیوائس",
    "editCustomer": "Edit Customer",
    "internalNotes": "Internal Notes",
    "minStock": "Min Stock",
    "mobile": "موبائل",
    "model": "ماڈل",
    "other": "Other",
    "page": "Page",
    "paymentMethod": "Payment Method",
    "pc": "PC",
    "serialNo": "سیریل نمبر",
    "tablet": "Tablet",
    "totalNetPay": "کل خالص ادائیگی",
    "totalRecords": "کل ریکارڈز",
    "allowPopups": "Please allow popups to print the receipt.",
    "sell": "Sell",
    "servicePOS": "Service POS",
    "serviceCenter": "Service Center",
    "repairManagement": "Repair Management",
    "activeRepairs": "Active Repairs",
    "noRecentActivity": "No Recent Activity",
    "searchRepairsAndStock": "مرمت یا اسٹاک تلاش کریں...",
    "morning8": "Morning (8h)",
    "night8": "Night (8h)",
    "finance": "مالیات",
    "ownerMode": "Owner Mode",
    "managerMode": "Manager Mode",
    "cashierMode": "Cashier Mode",
    "otherPayment": "Other Payment",
    "repairs": "Repairs",
    "insufficientIngredient": "Insufficient stock for ingredient",
    "insufficientStock": "اسٹاک ناکافی ہے۔",
    "maxStockReached": "اسٹاک کی حد تک پہنچ گیا ہے!",
    "customItem": "Custom Item",
    "enterItemName": "Enter Item Name:",
    "enterItemPrice": "Enter Item Price:",
    "inventoryParts": "Inventory Parts",
    "useExternalTerminal": "Use External Terminal",
    "billToPOS": "Bill to POS",
    "permissionDeniedOwner": "Access Denied: Owner PIN Required.",
    "ownerOnlyPins": "Only Owner can manage PINs",
    "instapay": "InstaPay",
    "repairLabor": "Repair Labor",
    "autoHide": "Auto-hide",
    "seconds": "s",
    "terminal": "Terminal",
    "jobs": "Jobs",
    "sparePart": "Spare Part",
    "todaysServices": "Today's Services",
    "servicesOn": "Services on",
    "scan": "Scan",
    "shopLogo": "Shop Logo",
    "uploadLogo": "Upload Logo",
    "changeLogo": "لوگو تبدیل کریں",
    "removeLogo": "لوگو ہٹائیں",
    "kioskCheckInSuccess": "چیک ان کامیاب!",
    "kioskCheckOutSuccess": "چیک آؤٹ کامیاب!",
    "allTransactions": "تمام لین دین",
    "searchHistory": "سرگزشت تلاش کریں...",
    "reviewPastSales": "REVIEW PAST SALES & REPAIRS",
    "payment": "ادائیگی",
    "reprint": "دوبارہ پرنٹ کریں",
    "repair": "مرمت (سروس)",
    "noHistoryInPeriod": "اس مدت کے لیے کوئی سرگزشت نہیں ملی",
    "manual": "مینول",
    "partsTotal": "حصوں کا کل",
    "noPartsUsed": "No parts used yet",
    "viewCart": "کارٹ دیکھیں",
    "customerInformation": "Customer Information",
    "ticketId": "ٹکٹ آئی ڈی",
    "inventoryManagement": "انوونٹری مینجمنٹ",
    "pinManagement": "پن مینجمنٹ",
    "cashierPin": "کیشیئر پن",
    "managerPin": "مینیجر پن",
    "ownerPin": "مالک پن",
    "saleCompleted": "فروخت مکمل ہوگئی!",
    "repairAlreadyInCart": "Repair already in cart!",
    "deleteViaActiveJobs": "Delete via Service Active Jobs",
    "photoUploadFailed": "Photo upload failed. Please check connection.",
    "logoSizeError": "Logo must be smaller than 2MB",
    "adminPinRequired": "Access Denied: Admin PIN Required.",
    "managerPinRestricted": "Manager PIN Restricted.",
    "ownerPinRestricted": "Owner PIN Restricted.",
    "totalQty": "کل مقدار",
    "exitKioskPrompt": "کیوسک سے باہر نکلنے کے لیے ڈبل کلک کریں",
    "borrow": "ادھار",
    "borrowDate": "ادھار کی تاریخ",
    "borrowTime": "وقت",
    "dateBorrowed": "ادھار لیا گیا",
    "dateReturned": "واپس کیا گیا",
    "returned": "واپس",
    "borrowed": "ادھار",
    "borrowItems": "ادھار کی چیزیں",
    "noBorrowRecords": "کوئی ریکارڈ نہیں",
    "borrower": "ادھار لینے والا",
    "markAsBorrowed": "ادھار نشان زد کریں",
    "markAsReturned": "واپسی نشان زد کریں",
    "borrowerName": "نام",
    "addBorrowRecord": "ادھار شامل کریں",
    "addRecord": "ریکارڈ شامل کریں",
    "additionalInfo": "اضافی معلومات",
    "enableGst": "GST فعال کریں",
    "gstNumber": "GST نمبر",
    "gstPercent": "GST شرح (%)",
    "taxableAmt": "قابل ٹیکس رقم",
    "taxableAmtMgmt": "ٹیکس کے قابل رقم کا انتظام",
    "gstPlaceholder": "مثال: 22AAAAA0000",
    "gst": "GST"
  },
  "bn": {
    "appName": "Finn ERP",
    "appSubtitle": "এন্টারপ্রাইজ রিসোর্স প্ল্যানিং",
    "menuDashboard": "ড্যাশবোর্ড",
    "menuEmployees": "কর্মচারী",
    "menuSites": "সাইট",
    "menuAttendance": "উপস্থিতি",
    "menuPayroll": "পেরোল",
    "menuReports": "রিপোর্ট",
    "menuKiosk": "কিয়স্ক মোড",
    "kioskWelcome": "আমাদের কিয়স্কে স্বাগতম",
    "kioskSub": "শুরু করতে একটি পরিষেবা নির্বাচন করুন",
    "kioskPos": "সেলফ-সার্ভিস পিওএস",
    "kioskService": "মেরামত ট্র্যাকিং",
    "kioskCheckIn": "স্টাফ চেক-ইন",
    "kioskClock": "বর্তমান সময়",
    "kioskBack": "হোমে ফিরে যান",
    "settings": "সেটিংস",
    "search": "অনুসন্ধান...",
    "allEmployees": "সকল কর্মচারী",
    "manageStaff": "কর্মী ব্যবস্থাপনা",
    "addEmployee": "কর্মচারী যোগ করুন",
    "name": "নাম",
    "role": "পদ",
    "dept": "বিভাগ",
    "salary": "মূল বেতন",
    "bonus": "বোনাস",
    "overtime": "ওভারটাইম",
    "deductions": "কর্তন",
    "total": "মোট",
    "netPay": "নীট বেতন",
    "actions": "পদক্ষেপ",
    "login": "লগইন",
    "signup": "সাইন আপ",
    "email": "ইমেল",
    "password": "পাসওয়ার্ড",
    "welcome": "স্বাগতম",
    "signInToAccess": "আপনার ড্যাশবোর্ড অ্যাক্সেস করতে সাইন ইন করুন",
    "createAccount": "অ্যাকাউন্ট তৈরি করুন",
    "haveAccount": "আগে থেকেই অ্যাকাউন্ট আছে?",
    "noAccount": "অ্যাকাউন্ট নেই?",
    "logout": "লগআউট",
    "location": "লোকেশন",
    "shift": "শিফট",
    "totalComp": "মোট পারিশ্রমিক",
    "dailyAttendance": "দৈনিক উপস্থিতি লগ",
    "trackAttendance": "কর্মচারীদের চেক-ইন এবং শিফট ট্র্যাক করুন।",
    "checkIn": "চেক ইন",
    "checkOut": "চেক আউট",
    "status": "অবস্থা",
    "import": "আমদানি",
    "export": "রপ্তানি",
    "payrollMgmt": "পেরোল ব্যবস্থাপনা",
    "costAnalysis": "রিয়েল-টাইম ব্যয় বিশ্লেষণ।",
    "aiInsights": "এআই ইনসাইটস",
    "siteStats": "সাইট পরিসংখ্যান",
    "assignedGuards": "নিযুক্ত কর্মচারী",
    "deleteLocation": "লোকেশন মুছুন",
    "terminateGuard": "কর্মচারী ছাঁটাই / ডিলিট করুন",
    "aiAssistant": "এআই অ্যাসিস্ট্যান্ট",
    "genReview": "পারফরম্যান্স রিভিউ তৈরি করুন",
    "generating": "তৈরি হচ্ছে...",
    "downloadReport": "রিপোর্ট ডাউনলোড করুন",
    "editLocation": "লোকেশন সম্পাদনা করুন",
    "otp": "ওটিপি কোড",
    "otpSent": "ওটিপি পাঠানো হয়েছে",
    "otpSentDetail": "ওটিপি shoaibwwe01@outlook.com এ পাঠানো হয়েছে। অনুগ্রহ করে অ্যাডমিনের কাছ থেকে কোড নিন।",
    "invalidOtp": "অবৈধ ওটিপি কোড",
    "registeredOnly": "শুধুমাত্র নিবন্ধিত ব্যবহারকারীদের জন্য",
    "guestNotice": "আপনি গেস্ট মোডে আছেন। সকল অনলাইন ফিচারের জন্য রেজিস্টার করুন।",
    "menuAccounts": "অ্যাকাউন্টস",
    "menuSalesPurchases": "বিক্রয়",
    "menuWarehouses": "গুদাম",
    "menuCafe": "ক্যাফে",
    "menuInvoices": "ইনভয়েস",
    "weeklySales": "সাপ্তাহিক বিক্রয় রিপোর্ট",
    "weeklyBuy": "সাপ্তাহিক ক্রয়/ইনভেন্টরি রিপোর্ট",
    "walkIn": "ওয়াক-ইন",
    "takeaway": "টেকঅ্যাওয়ে",
    "walkInCustomer": "ওয়াক-ইন কাস্টমার",
    "takeawayCustomer": "টেকঅ্যাওয়ে কাস্টমার",
    "customerCopy": "গ্রাহক কপি",
    "shopCopy": "দোকান কপি",
    "printSettings": "প্রিন্ট সেটিংস",
    "thermal": "থার্মাল (৮০ মিমি)",
    "a4": "এ৪ (স্ট্যান্ডার্ড)",
    "dualPrint": "ডুয়াল প্রিন্ট (গ্রাহক + দোকান)",
    "lastUpdated": "সর্বশেষ আপডেট",
    "stockValueBuy": "স্টক ভ্যালু (ক্রয়)",
    "stockValueSell": "স্টক ভ্যালু (বিক্রয়)",
    "itemsSummary": "আইটেম সারাংশ",
    "invoiceId": "ইনভয়েস আইডি",
    "type": "টাইপ",
    "soldBy": "বিক্রয়কারী",
    "customerId": "গ্রাহক আইডি",
    "taxed": "ট্যাক্সসহ",
    "advanceSalary": "অগ্রিম বেতন",
    "image": "ছবি",
    "salesEmployee": "সেলস এমপ্লয়ি",
    "adminDefault": "অ্যাডমিন (ডিফল্ট)",
    "historyLog": "ইতিহাস লগ",
    "historySubtitle": "বিক্রয় এবং গুদাম কার্যক্রমের বিস্তারিত লগ।",
    "allTypes": "সব ধরনের",
    "sales": "বিক্রয়",
    "stockUpdates": "স্টক আপডেট",
    "valueStatus": "মূল্য/অবস্থা",
    "noHistory": "কোনো ইতিহাস নেই",
    "sold": "বিক্রিত",
    "to": "প্রতি",
    "units": "ইউনিট",
    "stockCheck": "স্টক চেক",
    "items": "আইটেম",
    "posTerminal": "পিওএস টার্মিনাল",
    "searchProducts": "পণ্য খুঁজুন...",
    "todaysSales": "আজকের বিক্রয়",
    "salesOn": "বিক্রয় তারিখ",
    "time": "সময়",
    "amount": "পরিমাণ",
    "receipt": "রশিদ",
    "currentBill": "বর্তমান বিল",
    "cartEmpty": "কার্ট খালি",
    "selectItems": "আইটেম যোগ করতে গ্রিড থেকে নির্বাচন করুন",
    "subtotal": "সাবটোটাল",
    "checkout": "চেকআউট",
    "customerNameOptional": "গ্রাহকের নাম (ঐচ্ছিক)",
    "hold": "কার্ট হোল্ড করুন",
    "resumeWarning": "পুনরায় শুরু করলে বর্তমান কার্ট মুছে যাবে। চালিয়ে যাবেন?",
    "quickStockIn": "দ্রুত স্টক ইন",
    "currentQuantity": "বর্তমান পরিমাণ",
    "enterAddedQty": "অতিরিক্ত পরিমাণ লিখুন",
    "payWithUPI": "ইউপিআই পেমেন্ট",
    "assistant": "সহকারী",
    "reviewOrder": "অর্ডার পর্যালোচনা",
    "products": "পণ্য",
    "scanner": "স্ক্যানার",
    "cart": "কার্ট",
    "digitalPayment": "ডিজিটাল পেমেন্ট",
    "linkExpired": "লিংকের মেয়াদ শেষ",
    "linkExpiredDetail": "এই পেমেন্ট লিংকের মেয়াদ ছিল ১০ মিনিট। অনুগ্রহ করে নতুন কিউআর কোড চান।",
    "payNow": "এখনই পরিশোধ করুন",
    "secureUpi": "নিরাপদ ইউপিআই পেমেন্ট",
    "securePayment": "নিরাপদ ডিজিটাল পেমেন্ট",
    "totalLabel": "মোট",
    "goBackToApp": "অ্যাপে ফিরে যান",
    "inventorySubtitle": "ইনভেন্টরি লেভেল এবং স্টক মুভমেন্ট",
    "searchInventory": "নাম দিয়ে ইনভেন্টরি খুঁজুন...",
    "itemName": "নাম",
    "buyPrice": "ক্রয় মূল্য",
    "sellPrice": "বিক্রয় মূল্য",
    "barcode": "বারকোড",
    "scanBarcode": "বারকোড স্ক্যান",
    "paymentMethodNotConfigured": "সেটিংসে পেমেন্ট পদ্ধতি সেট করা নেই",
    "digitalPayment_QR": "ডিজিটাল পেমেন্ট (কিউআর)",
    "upiId": "ইউপিআই আইডি",
    "instapayId": "ইনস্টাপে আইডি",
    "payWithInstapay": "ইনস্টাপে দিয়ে পে করুন",
    "confirmCheckout": "চেকআউট নিশ্চিত করুন",
    "totalWithDiscount": "ডিসকাউন্টের পর মোট",
    "quantity": "পরিমাণ",
    "refinement": "পরিশোধন",
    "noInventory": "কোনো ইনভেন্টরি পাওয়া যায়নি",
    "hideCosts": "ব্যয় লুকান",
    "showCosts": "ব্যয় দেখান",
    "securityCheck": "নিরাপত্তা পরীক্ষা",
    "addItem": "আইটেম যোগ করুন",
    "edit": "সম্পাদনা",
    "itemNotFound": "ইনভেন্টরিতে পণ্যটি পাওয়া যায়নি। অনুগ্রহ করে চেক করুন বা যোগ করুন।",
    "generate": "জেনারেট",
    "print": "প্রিন্ট",
    "printAll": "সমস্ত বারকোড প্রিন্ট করুন",
    "shopSettings": "দোকান সেটিংস",
    "shopName": "দোকানের নাম",
    "shopAddress": "ঠিকানা",
    "shopPhone": "ফোন",
    "updateSettings": "সেটিংস আপডেট",
    "securityPin": "সিকিউরিটি পিন",
    "language": "ভাষা",
    "close": "বন্ধ",
    "retailInvoice": "খুচরা ইনভয়েস",
    "invoice": "ইনভয়েস",
    "date": "তারিখ",
    "billNo": "বিল নং",
    "paymentMode": "পেমেন্ট মোড",
    "cash": "নগদ",
    "item": "আইটেম",
    "qty": "পরিমাণ",
    "amt": "পরিমাণ",
    "price": "মূল্য",
    "taxVAT": "ট্যাক্স/ভ্যাট",
    "taxRate": "ট্যাক্সের হার",
    "makeChecksPayable": "চেক যার নামে হবে",
    "thankYou": "ধন্যবাদ!",
    "billTo": "বিল প্রাপক",
    "description": "বর্ণনা",
    "unitPrice": "ইউনিট মূল্য",
    "lineTotal": "লাইন মোট",
    "comments": "মন্তব্য",
    "termsConditions": "শর্তাবলী",
    "paymentTerms": "১. ৩০ দিনের মধ্যে মোট পেমেন্ট পরিশোধ করতে হবে",
    "includeInvoiceNumber": "২. অনুগ্রহ করে চেকে ইনভয়েস নম্বর উল্লেখ করুন",
    "phone": "ফোন",
    "customer": "গ্রাহক",
    "contactQuestions": "ইনভয়েস সম্পর্কে কোনো প্রশ্ন থাকলে যোগাযোগ করুন",
    "details": "কর্মচারীর তথ্য",
    "manageDetails": "নির্বাচন পরিচালনা করুন",
    "siteName": "সাইটের নাম",
    "city": "শহর / অঞ্চল",
    "manager": "ম্যানেজার",
    "operationalStatus": "কাজের অবস্থা",
    "photoUrl": "কর্মচারীর ছবি",
    "uploadPhoto": "ছবি আপলোড করুন",
    "unassigned": "অনির্ধারিত",
    "securityTeam": "টিম",
    "guards": "কর্মচারী",
    "addLocation": "নতুন অবস্থান যোগ করুন",
    "createLocation": "অবস্থান তৈরি করুন",
    "cancel": "বাতিল",
    "filterAll": "সকল অবস্থান",
    "morningShift": "সকাল (৯টা - ৫টা)",
    "nightShift": "সন্ধ্যা (৫টা - ১টা)",
    "operational": "চলমান",
    "renovating": "সংস্কার চলছে",
    "active": "সক্রিয়",
    "closed": "বন্ধ",
    "onTime": "সময়মত",
    "late": "দেরি",
    "absent": "অনুপস্থিত",
    "design": "ডিজাইন",
    "engineering": "ইঞ্জিনিয়ারিং",
    "hr": "হিউম্যান রিসোর্স",
    "marketing": "মার্কেটিং",
    "operations": "অপারেশনস",
    "security": "সিকিউরিটি",
    "it": "আইটি",
    "headquarters": "প্রধান কার্যালয়",
    "kitchen": "রান্নাঘর",
    "service": "সার্ভিস",
    "bar": "বার",
    "retail": "রুটেইল বিক্রয়",
    "warehouse": "ইনভেন্টরি/স্টক",
    "cafe": "ক্যাফে",
    "inventory": "ইনভেন্টরি",
    "customers": "গ্রাহক",
    "addCustomer": "গ্রাহক যোগ করুন",
    "newTicket": "নতুন টিকিট",
    "serviceModule": "সার্ভিস মডিউল",
    "devicePhotos": "ডিভাইস ফটো",
    "accounts": "অ্যাকাউন্টস",
    "management": "Management",
    "cleaning": "Cleaning",
    "maintenance": "Maintenance",
    "morning12": "Morning (12 Hours)",
    "night12": "Night (12 Hours)",
    "importSuccess": "Successfully imported {0} records.",
    "importError": "Error importing: ",
    "payrollUpdateSuccess": "Successfully updated payroll for {0} employees.",
    "payrollUpdateError": "Error updating payroll: ",
    "myProfile": "আমার প্রোফাইল",
    "emailLabel": "ইমেল:",
    "userIdLabel": "ইউজার আইডি:",
    "accountTypeLabel": "অ্যাকাউন্টের ধরন:",
    "admin": "অ্যাডমিন",
    "shopSettingsSaved": "দোকানের সেটিংস ক্লাউডে সংরক্ষিত হয়েছে",
    "shopSettingsError": "Error saving settings",
    "localization": "আঞ্চলিক সেটিংস",
    "currency": "Currency",
    "departmentSettings": "Department Settings",
    "departments": "Departments",
    "manageDepartments": "Add or remove departments",
    "addDepartment": "Add Department",
    "backupRestore": "Backup & Restore",
    "exportBackup": "Export Backup",
    "importBackup": "Import Backup",
    "backupDescription": "Export your data as JSON or restore from a previous backup.",
    "dangerZone": "Danger Zone",
    "irreversibleAction": "Irreversible action. Deletes all data.",
    "factoryReset": "Factory Reset System",
    "compensation": "Compensation",
    "advance": "Advance",
    "delete": "Delete",
    "terminateService": "Terminate Service",
    "addAttendance": "Add Attendance",
    "editAttendance": "Edit Attendance",
    "deleteAttendance": "Delete Attendance",
    "selectEmployee": "Select Employee",
    "selectDate": "Select Date",
    "selectStatus": "Select Status",
    "save": "সংরক্ষণ",
    "replacementFor": "Replacement For",
    "coveringFor": "Covering For",
    "lateDeductions": "Late Deductions",
    "absentDeductions": "Absent Deductions",
    "manualDeduction": "Manual Deduction",
    "cost": "Cost",
    "none": "কিছুই না",
    "dashboardTotal": "Total",
    "activeGuards": "Active Employees",
    "operationalSites": "Operational Sites",
    "checkedInToday": "Checked In Today",
    "issuesToday": "Issues Today",
    "quickActions": "Quick Actions",
    "addStaff": "Add Staff",
    "addSite": "Add Site",
    "systemStatus": "System Status",
    "systemOperational": "All systems operational. Database synced.",
    "online": "Online",
    "attendanceReport": "Attendance Report",
    "payrollReport": "পেরোল রিপোর্ট",
    "staffReport": "কর্মী রিপোর্ট",
    "taxReport": "ট্যাক্স রিপোর্ট",
    "today": "আজ",
    "lateAbsent": "Late/Absent",
    "lateHours": "Late Hours",
    "attendanceExists": "Attendance already exists for this employee on this date.",
    "theme": "Theme",
    "light": "Light",
    "dark": "Dark",
    "payrollSlip": "পেরোল স্লিপ",
    "payrollFor": "Payroll for",
    "employeeName": "Employee Name",
    "employeeId": "Employee ID",
    "payPeriod": "পেরোল পিরিয়ড",
    "basicSalary": "Basic Salary",
    "grossPay": "Gross Pay",
    "totalDeductions": "মোট কর্তন",
    "otherDeductions": "অন্যান্য কর্তন",
    "employeeSignature": "Employee Signature",
    "authorizedSignature": "Authorized Signature",
    "computerGenerated": "This is a computer-generated payroll slip. No signature required.",
    "generatedOn": "Generated on",
    "at": "at",
    "companyName": "Company Name",
    "companyAddress": "Company Address",
    "selectLocation": "Select Location",
    "noLocations": "No locations available - Please create a location first",
    "authError": "প্রমাণীকরণের ত্রুটি",
    "googleSignInError": "গুগল সাইন-ইন ত্রুটি",
    "factoryResetWarning": "CRITICAL WARNING: This will DELETE ALL DATA (Employees, Sales, Inventory, etc.) PERMANENTLY. Are you sure?",
    "pinPrompt": "Enter Security PIN to continue:",
    "incorrectPin": "Incorrect PIN. Please try again.",
    "factoryResetPinPrompt": "Enter Security PIN to confirm Factory Reset:",
    "factoryResetIncorrectPin": "Incorrect PIN. Reset Aborted.",
    "switchModePrompt": "Enter Admin PIN to switch mode:",
    "changeUserPrompt": "Enter PIN to Change Sales User:",
    "resetComplete": "ফ্যাক্টরি রিসেট সম্পন্ন হয়েছে। সমস্ত ডেটা মুছে ফেলা হয়েছে।",
    "resetFailed": "Factory Reset Failed: ",
    "backupExported": "Backup exported successfully!",
    "exportFailed": "Export failed: ",
    "backupImported": "Backup imported successfully! Reloading...",
    "importFailed": "Import failed: ",
    "overwriteWarning": "WARNING: This will OVERWRITE all existing data. Continue?",
    "guestLogin": "Guest Login",
    "forgotPassword": "Forgot Password?",
    "resetPassword": "Reset Password",
    "sendResetLink": "Send Reset Link",
    "backToLogin": "Back to Login",
    "passwordResetSent": "Password reset email sent!",
    "enterEmail": "Enter your email to reset password",
    "orContinue": "অথবা এর সাথে চালিয়ে যান",
    "signInGoogle": "গুগল দিয়ে সাইন ইন করুন",
    "linkSuccess": "Google Account Linked Successfully!",
    "linkError": "Link Error: ",
    "accountLinked": "This Google Account is already active. Please Log Out and use \"Sign in with Google\" directly.",
    "employeeSaved": "Employee Saved Successfully!",
    "saveError": "Error saving: ",
    "deleteConfirm": "Are you sure?",
    "updateError": "Error updating item: ",
    "addPurchaseError": "Error adding purchase: ",
    "genInvoiceError": "Error generating invoice: ",
    "addItemError": "Error adding item: ",
    "deleteLocationWarning": "Cannot delete. Employees assigned.",
    "deleteLocationConfirm": "Delete this location?",
    "errorNoUser": "Error: No user logged in.",
    "totalIncome": "Total Income",
    "visa": "Visa",
    "onlinePayment": "Online",
    "forgotPin": "Forgot PIN?",
    "securityQuestion": "Security Question",
    "securityAnswer": "Security Answer",
    "enterSecurityAnswer": "Enter Security Answer",
    "pinResetSuccess": "PIN Reset Successfully! Your new PIN is 1234.",
    "incorrectAnswer": "Incorrect Answer.",
    "setSecurityQuestion": "Set Security Question",
    "changePin": "Change Security PIN",
    "newPin": "New PIN",
    "manageLocations": "Manage and monitor all your physical sites and locations.",
    "siteEmployees": "Employees",
    "saveSettings": "সেটিংস সংরক্ষণ করুন",
    "currentPin": "বর্তমান পিন",
    "enterNewPin": "নতুন পিন লিখুন",
    "pinChanged": "পিন সফলভাবে পরিবর্তিত হয়েছে!",
    "pinSetMessage": "PIN is set. Use \"Forgot PIN\" to reset.",
    "confirmChangePin": "নতুন পিন সেট করবেন?",
    "secQ_pet": "What is your first pet's name?",
    "secQ_mother": "What is your mother's maiden name?",
    "secQ_city": "In what city were you born?",
    "secQ_school": "What is the name of your first school?",
    "daily": "Daily",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "profitLossReport": "Profit & Loss Report",
    "monthlyPl": "Monthly Profit & Loss",
    "plSubtitle": "Revenue vs COGS vs Expenses analysis",
    "revenue": "REVENUE",
    "totalSales": "Total Sales",
    "discount": "ছাড়",
    "cogs": "COGS",
    "cogsFull": "Cost of Goods Sold",
    "grossProfit": "GROSS PROFIT",
    "expenses": "EXPENSES",
    "purchasesOther": "Purchases/Other",
    "netProfit": "NET PROFIT",
    "netLoss": "NET LOSS",
    "incomeStatement": "INCOME STATEMENT",
    "salesCash": "Sales - Cash",
    "salesVisa": "Sales - Visa",
    "salesOnline": "Sales - Online",
    "totalRevenue": "Total Revenue",
    "costOfGoodsSold": "Cost of Goods Sold",
    "grossMargin": "Gross Margin",
    "operatingExpenses": "OPERATING EXPENSES",
    "totalExpenses": "Total Expenses",
    "netMargin": "Net Margin",
    "deptExpenses": "Department Expenses",
    "invPurchases": "Inventory Purchases",
    "selectEmployeeAlert": "অনুগ্রহ করে একজন সেলস কর্মী নির্বাচন করুন!",
    "accountHandling": "অ্যাকাউন্ট হ্যান্ডলিং",
    "connectGoogle": "গুগল অ্যাকাউন্টের সাথে সংযোগ করুন",
    "linkGoogleDesc": "পাসওয়ার্ডের পরিবর্তে আপনার গুগল অ্যাকাউন্ট ব্যবহার করে লগইন করতে লিঙ্ক করুন।",
    "soldItemsDetail": "SOLD ITEMS DETAIL",
    "boughtItemsDetail": "BOUGHT ITEMS DETAIL (Purchases & Expenses)",
    "unknown": "Unknown",
    "totals": "TOTALS",
    "unitCost": "Unit Cost",
    "period": "Period",
    "na": "N/A",
    "totalCost": "Total Cost",
    "profit": "Profit",
    "liveBoard": "লাইভ বোর্ড",
    "manageUnits": "রুম এবং টেবিল",
    "menuRecipes": "মেনু এবং রেসিপি",
    "activeSessions": "Active Sessions",
    "unitsMonitoring": "Live monitoring for {0} units",
    "inSession": "In-Session",
    "available": "Available",
    "startSession": "সেশন শুরু",
    "addOrder": "Add Order",
    "stop": "বন্ধ",
    "recipeBuilder": "রেসিপি বিল্ডার",
    "manageUnitsTitle": "Manage Units",
    "roomName": "রুমের নাম",
    "unitType": "ইউনিট টাইপ",
    "hourlyRate": "ঘণ্টা রেট",
    "saveUnit": "ইউনিট সংরক্ষণ",
    "cafeTable": "Cafe Table",
    "playStationRoom": "প্লেস্টেশন রুম",
    "billiardsTable": "Billiards Table",
    "category": "Category",
    "offerPrice": "মূল্য",
    "composition": "Composition",
    "linkStock": "+ Link warehouse stock",
    "hotDrinks": "গরম পানীয়",
    "coldDrinks": "Cold Drinks",
    "snacks": "স্ন্যাকস",
    "meals": "খাবার",
    "updateItem": "Update Item",
    "addToMenu": "Add to Menu",
    "appendSession": "Append items to session",
    "orderHistory": "অর্ডার ইতিহাস",
    "newSelection": "New Selection",
    "trayEmpty": "ট্রে খালি",
    "trayTotal": "Tray Total",
    "confirmOrder": "Confirm Order",
    "menuItemsMissingTitle": "Menu items missing",
    "all": "All",
    "customerPhone": "Customer Phone *",
    "customerName": "Customer Name",
    "sessionType": "Session Type",
    "openSession": "Open (No Limit)",
    "fixedDuration": "Fixed Duration",
    "startSessionTitle": "Start Session",
    "managePayroll": "Manage Payroll",
    "advanceTaken": "Advance Taken",
    "manualDeductions": "Manual Deductions",
    "lateAbsentAuto": "Late/Absent (Auto)",
    "grossEarnings": "Gross Earnings",
    "netPayable": "Net Payable",
    "reset": "Reset",
    "saveRecord": "সংরক্ষণ করুন",
    "hourlyRateLabel": "HOURLY RATE",
    "sessionTypeLabel": "SESSION TYPE",
    "phonePlaceholder": "e.g. 050 123 4567",
    "guestName": "Guest Name",
    "subtotalLabel": "সাবটোটাল",
    "retryCamera": "Retry Camera",
    "scanFocusInfo": "Pinch or use slider to focus.",
    "tapToFocus": "Tap screen to force focus.",
    "centerCodeFrame": "Center the code inside the blue frame",
    "holdAwayTap": "Hold 20cm away & Tap to sharpen",
    "selectMonthInfo": "Select month to view salary details",
    "manageEditMonth": "Manage/Edit for this Month",
    "viewManageLocations": "View and manage all your physical locations",
    "addAccount": "Add Account",
    "accountName": "Account Name",
    "initialBalance": "Initial Balance",
    "editItem": "Edit Item",
    "addInventoryItem": "Add Inventory Item",
    "printBarcodeLabel": "Print Barcode Label",
    "newSale": "New Sale",
    "totalAmount": "মোট পরিমাণ",
    "completed": "Completed",
    "shipped": "Shipped",
    "itemsSummaryLabel": "Items (Summary)",
    "connectionError": "Connection Error:",
    "dismiss": "Dismiss",
    "adminUser": "Admin User",
    "optional": "Optional",
    "onTimeLabel": "On Time",
    "lateLabel": "Late",
    "absentLabel": "Absent",
    "pendingLabel": "Pending",
    "createSale": "Create Sale",
    "newPurchase": "New Purchase",
    "supplierName": "Supplier Name",
    "tax": "Tax",
    "accountsSubtitle": "Track assets, liabilities, and expenses.",
    "mixedLocationError": "বিভিন্ন লোকেশনের পণ্য একসাথে বিক্রি করা যাবে না!",
    "department": "Department",
    "missing": "Missing",
    "taxEstimation": "Estimated tax deductions",
    "noAccounts": "No accounts found. Add one to get started.",
    "outOfStock": "এই পণ্যটি স্টকে নেই!",
    "printWizard": "Print Barcodes Wizard",
    "totalLabels": "Total Labels",
    "layoutMode": "Layout Mode",
    "orderNumber": "Order Number",
    "partsUsed": "Parts Used",
    "createInvoice": "Create Invoice",
    "serviceInvoice": "Service Invoice",
    "printNow": "Print Now",
    "dailySales": "Daily Sales",
    "cafeHistory": "Cafe History",
    "searchByDate": "Search by Date",
    "printSelected": "Print Selected",
    "previousBills": "Previous Bills",
    "confirmDelete": "Are you sure you want to delete?",
    "deleteError": "Error deleting item",
    "history": "ইতিহাস",
    "itemExists": "Item already exists",
    "update": "Update",
    "upi": "UPI",
    "pay": "Pay",
    "Saved": "Saved!",
    "Report": "Report",
    "Reset to defaults": "Reset to defaults",
    "id": "ID",
    "instaPay": "InstaPay",
    "method": "Method",
    "exp": "Exp",
    "a": "A",
    "T": "T",
    "pn": "PN",
    "No items with barcodes to print.": "No items with barcodes to print.",
    "Please allow popups to print payroll slip": "Please allow popups to print payroll slip",
    "Please select a question and answer!": "Please select a question and answer!",
    "printPayrollSlip": "Print Payroll Slip",
    "profit_loss": "Profit & Loss",
    "now": "এখন",
    "h": "h",
    "m": "মিনিট",
    "PlayStation": "PlayStation",
    "Billiards": "Billiards",
    "Cafe": "Cafe",
    "sticker": "Sticker",
    "a4 sheet": "A4 Sheet",
    "noBarcode": "No Barcode",
    "menuService": "সার্ভিস ও মেরামত",
    "activeJobs": "সক্রিয় কাজ",
    "serviceHistory": "সার্ভিস ইতিহাস",
    "customerInfo": "Customer Info",
    "deviceDetails": "Device Details",
    "issueDescription": "সমস্যার বর্ণনা",
    "describeIssue": "Describe the problem...",
    "estimatedCost": "Estimated Cost",
    "technician": "টেকনিশিয়ান",
    "priority": "অগ্রাধিকার",
    "createTicket": "Create Ticket",
    "searchTickets": "টিকিট খুঁজুন...",
    "noActiveJobs": "কোনো চলমান মেরামত নেই",
    "editTicket": "Edit Repair Ticket",
    "saveChanges": "পরিবর্তন সংরক্ষণ",
    "received": "গৃহীত",
    "inProgress": "কাজ চলছে",
    "waitingParts": "পার্টস অপেক্ষমান",
    "readyPickup": "ডেলিভারি প্রস্তুত",
    "delivered": "Delivered",
    "lowStockAlerts": "লো স্টক এলার্ট",
    "pendingRepairs": "বকেয়া মেরামত",
    "completedRepairs": "Completed Repairs",
    "pendingPayments": "বকেয়া পেমেন্ট",
    "servicePerformance": "সার্ভিস পারফরম্যান্স",
    "topRepairs": "শীর্ষ মেরামত বিভাগ",
    "technicianRevenue": "টেকনিশিয়ান আয়",
    "monthlyServiceRevenue": "মাসিক সার্ভিস আয়",
    "sparePartsUsage": "খুচরা পার্টস ব্যবহার",
    "addStock": "Add Stock",
    "attachPhotos": "Device Photos",
    "add": "Add",
    "recentActivity": "সাম্প্রতিক কার্যক্রম",
    "customerProfile": "Customer Profile",
    "deviceInfo": "Device Information",
    "repairHistory": "মেরামত ইতিহাস",
    "diagnostics": "Diagnostics",
    "paymentStatus": "পেমেন্ট স্ট্যাটাস",
    "paid": "পেইড",
    "unpaid": "আনপেইড",
    "partial": "আংশিক",
    "spareParts": "খুচরা পার্টস",
    "lowStock": "কম স্টক",
    "phoneParts": "ফোন পার্টস",
    "pcComponents": "পিসি পার্টস",
    "accessories": "অ্যাকসেসরিজ",
    "urgent": "জরুরি",
    "high": "উচ্চ",
    "normal": "স্বাভাবিক",
    "low": "নিম্ন",
    "createNewRepairTicket": "Create New Repair Ticket",
    "todaysRevenue": "আজকের আয়",
    "address": "ঠিকানা",
    "assignedTechnician": "Assigned Technician",
    "brand": "ব্র্যান্ড",
    "collected": "Collected",
    "console": "Console",
    "creditCard": "Credit Card",
    "dashboard": "Dashboard",
    "device": "Device",
    "editCustomer": "Edit Customer",
    "internalNotes": "Internal Notes",
    "minStock": "Min Stock",
    "mobile": "মোবাইল",
    "model": "মডেল",
    "other": "Other",
    "page": "Page",
    "paymentMethod": "Payment Method",
    "pc": "PC",
    "serialNo": "সিরিয়াল নং",
    "tablet": "Tablet",
    "totalNetPay": "Total Net Pay",
    "totalRecords": "Total Records",
    "allowPopups": "Please allow popups to print the receipt.",
    "sell": "Sell",
    "servicePOS": "Service POS",
    "serviceCenter": "Service Center",
    "repairManagement": "Repair Management",
    "activeRepairs": "Active Repairs",
    "noRecentActivity": "No Recent Activity",
    "searchRepairsAndStock": "Search Repairs or Stock...",
    "morning8": "Morning (8h)",
    "night8": "Night (8h)",
    "finance": "ফাইন্যান্স",
    "ownerMode": "Owner Mode",
    "managerMode": "Manager Mode",
    "cashierMode": "Cashier Mode",
    "otherPayment": "Other Payment",
    "repairs": "Repairs",
    "insufficientIngredient": "Insufficient stock for ingredient",
    "insufficientStock": "পর্যাপ্ত স্টক নেই",
    "maxStockReached": "সর্বোচ্চ স্টক পৌঁছেছে!",
    "customItem": "Custom Item",
    "enterItemName": "Enter Item Name:",
    "enterItemPrice": "Enter Item Price:",
    "inventoryParts": "Inventory Parts",
    "useExternalTerminal": "Use External Terminal",
    "billToPOS": "Bill to POS",
    "permissionDeniedOwner": "Access Denied: Owner PIN Required.",
    "ownerOnlyPins": "Only Owner can manage PINs",
    "instapay": "InstaPay",
    "repairLabor": "Repair Labor",
    "autoHide": "Auto-hide",
    "seconds": "s",
    "terminal": "Terminal",
    "jobs": "Jobs",
    "sparePart": "Spare Part",
    "todaysServices": "Today's Services",
    "servicesOn": "Services on",
    "scan": "Scan",
    "shopLogo": "Shop Logo",
    "uploadLogo": "Upload Logo",
    "changeLogo": "লোগো পরিবর্তন করুন",
    "removeLogo": "লোগো মুছুন",
    "kioskCheckInSuccess": "চেক-ইন সফল!",
    "kioskCheckOutSuccess": "চেক-আউট সফল!",
    "allTransactions": "All Transactions",
    "searchHistory": "ইতিহাস খুঁজুন...",
    "reviewPastSales": "REVIEW PAST SALES & REPAIRS",
    "payment": "Payment",
    "reprint": "Reprint",
    "repair": "সার্ভিস/মেরামত",
    "noHistoryInPeriod": "কোনো রেকর্ড পাওয়া যায়নি",
    "manual": "ম্যানুয়াল",
    "partsTotal": "Parts Total",
    "noPartsUsed": "No parts used yet",
    "viewCart": "View Cart",
    "customerInformation": "Customer Information",
    "ticketId": "Ticket ID",
    "inventoryManagement": "Inventory Management",
    "pinManagement": "PIN Management",
    "cashierPin": "Cashier PIN",
    "managerPin": "Manager PIN",
    "ownerPin": "Owner PIN",
    "saleCompleted": "Sale Completed!",
    "repairAlreadyInCart": "Repair already in cart!",
    "deleteViaActiveJobs": "Delete via Service Active Jobs",
    "photoUploadFailed": "Photo upload failed. Please check connection.",
    "logoSizeError": "Logo must be smaller than 2MB",
    "adminPinRequired": "Access Denied: Admin PIN Required.",
    "managerPinRestricted": "Manager PIN Restricted.",
    "ownerPinRestricted": "Owner PIN Restricted.",
    "totalQty": "মোট পরিমাণ",
    "exitKioskPrompt": "কিয়স্ক মোড থেকে প্রস্থান করতে ডাবল ক্লিক করুন",
    "borrow": "ধার",
    "borrowDate": "ধারের তারিখ",
    "borrowTime": "সময়",
    "dateBorrowed": "ধার নেওয়া হয়েছে",
    "dateReturned": "ফেরত দেওয়া হয়েছে",
    "returned": "ফেরত",
    "borrowed": "ধার",
    "borrowItems": "ধার নেওয়া আইটেম",
    "noBorrowRecords": "কোনো ধার রেকর্ড নেই",
    "borrower": "গ্রহীতা",
    "markAsBorrowed": "ধার হিসেবে চিহ্নিত করুন",
    "markAsReturned": "ফেরত হিসেবে চিহ্নিত করুন",
    "borrowerName": "গ্রহীতার নাম",
    "addBorrowRecord": "ধার রেকর্ড যোগ করুন",
    "addRecord": "রেকর্ড যোগ করুন",
    "additionalInfo": "অতিরিক্ত তথ্য",
    "enableGst": "GST চালু করুন",
    "gstNumber": "জিএসটি নম্বর",
    "gstPercent": "জিএসটি হার (%)",
    "taxableAmt": "করযোগ্য পরিমাণ",
    "taxableAmtMgmt": "করযোগ্য পরিমাণ ব্যবস্থাপনা",
    "gstPlaceholder": "যেমন: 22AAAAA0000",
    "gst": "GST"
  }
}